/* Diccionario FR→ES de la app conectada (generado, revisable). */
export const esApp = {
  "!items?.length ? null : (": "!items?.length? null: (",
  "% TVA": "% IVA",
  "% d'acompte": "% de anticipo",
  "% du HTVA": "% del importe sin IVA",
  "% · ouvrier": "% · operario",
  "(achat": "(compra",
  "(chaque jour ouvrable par défaut, réglable dans le Dashboard Mollie → Virements). Devisto ne détient jamais vos fonds et ne prend aucune commission : seuls les frais Mollie s'appliquent (≈ 0,39 € par paiement Bancontact, sans abonnement). Pour recevoir les virements, votre compte Mollie doit être vérifié (identité + IBAN).": "(cada día laborable por defecto, configurable en el panel de Mollie → Transferencias). Devisto nunca custodia sus fondos ni cobra comisiones: solo se aplican las tarifas de Mollie (≈ 0,39 € por pago con Bancontact, sin suscripción). Para recibir las transferencias, debe verificar su cuenta de Mollie (identidad + IBAN).",
  "(dans": "(en",
  "(display-mode: standalone)": "(display-mode: standalone)",
  "(en vigueur le": "(vigente el",
  "(estimation IA)": "(estimación de IA)",
  "(markdown léger : ## titre, - liste, **gras**)": "(markdown básico: ## título, - lista, **negrita**)",
  "(pro)": "(pro)",
  "(précédemment": "(anteriormente",
  "(rappel client 15 j avant, push la veille, intervention + facture créées automatiquement)": "(recordatorio al cliente 15 días antes, notificación push el día anterior, intervención + factura creadas automáticamente)",
  "(réf.": "(ref.",
  "(variable d'environnement)": "(variable de entorno)",
  ") — vérifiez votre compte puis enregistrez le paiement.": ") — verifique su cuenta y después registre el pago.",
  "), sous votre objectif de": "), por debajo de su objetivo de",
  "). Vérifiez avant d'appliquer.": "). Compruébelo antes de aplicar.",
  "+ Nouvelle option…": "+ Nueva opción…",
  "+32 4xx xx xx xx": "+32 4xx xx xx xx",
  "+33 6 xx xx xx xx": "+33 6 xx xx xx xx",
  "+34 6xx xxx xxx": "+34 6xx xxx xxx",
  "+352 6xx xxx xxx": "+352 6xx xxx xxx",
  ", en attente": ", pendiente",
  ", minmax(0, 1fr))": ", minmax(0, 1fr))",
  ", reconduction tacite ·": ", renovación tácita ·",
  ", sans carte bancaire.": ", sin tarjeta bancaria.",
  ", toutes répondues": ", todas respondidas",
  ", à partir du": ", a partir del",
  ". Déposez un nouveau document ci-dessous.": ". Suba un nuevo documento a continuación.",
  ". Signez ci-dessous pour poursuivre votre entretien sans interruption.": ". Firme a continuación para continuar con su mantenimiento sin interrupciones.",
  ". Vous validez tout avant envoi.": ". Usted valida todo antes del envío.",
  "0 % / exento": "0 % / exento",
  "1 visite / an": "1 visita / año",
  "1 visite par an": "1 visita al año",
  "1 · Que voulez-vous mesurer ?": "1 · ¿Qué desea medir?",
  "100 % belge · Peppol UBL": "100 % belga · Peppol UBL",
  "15 jours": "15 días",
  "1er janvier 2026": "1 de enero de 2026",
  "2 visites / an": "2 visitas / año",
  "2 visites par an": "2 visitas al año",
  "2 · Indication (facultatif)": "2 · Indicación (opcional)",
  "25 € / mois par société": "25 € / mes por empresa",
  "30 jours": "30 días",
  "30 jours gratuits": "30 días gratis",
  "30 jours gratuits · sans carte · Peppol inclus · 25 € HTVA/mois ensuite": "30 días gratis · sin tarjeta · Peppol incluido · después, 25 € sin IVA/mes",
  "4 visites / an": "4 visitas / año",
  "4 visites par an": "4 visitas al año",
  "6 caractères minimum": "6 caracteres como mínimo",
  "6 caractères minimum.": "6 caracteres como mínimo.",
  "7 jours": "7 días",
  ": !buys.length ? (": ":!buys.length? (",
  ": !sales.length ? (": ":!sales.length? (",
  ": \"\"],\n                  [\"Année de construction\", site.year_built],\n                  [\"Surface chauffée\", site.heated_area ?": ": \"\"],\n                  [\"Año de construcción\", site.year_built],\n                  [\"Superficie calefactada\", site.heated_area?",
  ": \"Votre abonnement est en cours.\"\n                : expired\n                  ? \"Activez l'abonnement pour préparer de nouveaux devis. Vos dossiers restent accessibles.\"\n                  :": ": \"Su suscripción está activa.\": expired? \"Active la suscripción para preparar nuevos presupuestos. Sus expedientes siguen estando disponibles.\":",
  ": dictation.recording ?": ": dictation.recording?",
  ": facturé": ": facturado",
  ": form.template_id ?": ": form.template_id?",
  ": le bouton « Laisser un avis » y renverra.": ": el botón « Dejar una reseña » le llevará allí.",
  ": on ?": ": on?",
  ": recording ?": ": recording?",
  ": travaux, matériel, constat et recommandations mis à jour. Relisez et ajustez.": ": trabajos, material, observaciones y recomendaciones actualizados. Revise y ajuste.",
  ": vous validez, le client signe sur place.": ": usted valida, el cliente firma allí mismo.",
  ": withAi ?": ": withAi?",
  "? Cette action est définitive.": "? Esta acción es irreversible.",
  "?force=true": "?force=true",
  "?instruction=": "?instruction=",
  "?invoice_id=": "?invoice_id=",
  "?month=": "?month=",
  "?mt=": "?mt=",
  "?renouveler=1": "?renouveler=1",
  "AV123456": "AV123456",
  "AXA, Ethias, AG, Baloise…": "AXA, Ethias, AG, Baloise…",
  "Abonnement": "Suscripción",
  "Abonnement Devisto (prix local / mois)": "Suscripción a Devisto (precio local / mes)",
  "Abonnement actif": "Suscripción activa",
  "Abonnement activé. Merci !": "Suscripción activada. ¡Gracias!",
  "Abonné": "Suscrito",
  "Abonnés payants": "Suscriptores de pago",
  "Abos actifs": "Suscripciones activas",
  "Absente": "Ausente",
  "Accepter et signer": "Aceptar y firmar",
  "Accepté": "Aceptado",
  "Accès chantier": "Acceso a la obra",
  "Accès comptable": "Acceso de la gestoría",
  "Accès comptable : consultation des factures, achats et exports uniquement": "Acceso para la gestoría: solo consulta de facturas, compras y exportaciones",
  "Accès de la société": "Acceso de la empresa",
  "Accès en consultation : vous ne pouvez ni créer ni modifier de document. Les CSV de l'export utilisent le séparateur « ; » (Excel, WinBooks, Exact, Yuki, Billit, Odoo).": "Acceso de solo lectura: no puede crear ni modificar documentos. Los archivos CSV de la exportación utilizan el separador «; » (Excel, WinBooks, Exact, Yuki, Billit, Odoo).",
  "Accès introuvable": "Acceso no encontrado",
  "Accès retiré.": "Acceso retirado.",
  "Accès à l'application pour votre comptable": "Acceso a la aplicación para su gestoría",
  "Accès, clés, code, étage, emplacement de la chaufferie…": "Acceso, llaves, código, planta, ubicación de la sala de calderas…",
  "Achats": "Compras",
  "Acompte, finale ou libre": "Anticipo, final o libre",
  "Acomptes et factures finales reliés à vos devis. Les notes de crédit sont dans Avoirs.": "Anticipos y facturas finales vinculados a sus presupuestos. Los abonos están en Abonos.",
  "Actif": "Activo",
  "Actif ·": "Activo ·",
  "Actif · clé": "Activo · llave",
  "Actif · prochaine visite": "Activo · próxima visita",
  "Actif · résumé du soir à 18h": "Activo · resumen diario a las 18h",
  "Actifs": "Activos",
  "Action impossible.": "Acción imposible.",
  "Actions rapides": "Acciones rápidas",
  "Activation impossible.": "Activación imposible.",
  "Activer": "Activar",
  "Activer la facturation": "Activar la facturación",
  "Activer mon abonnement": "Activar mi suscripción",
  "Activer mon accès": "Activar mi acceso",
  "Activez Bancontact/Payconiq dans votre Dashboard Mollie.": "Active Bancontact/Payconiq en su panel de Mollie.",
  "Activez l'abonnement pour continuer à préparer vos devis.": "Active la suscripción para seguir preparando sus presupuestos.",
  "Activez l'abonnement pour préparer de nouveaux devis. Vos dossiers restent accessibles.": "Active la suscripción para preparar nuevos presupuestos. Sus expedientes siguen estando accesibles.",
  "Activez votre facturation Peppol": "Active su facturación Peppol",
  "Activité mensuelle": "Actividad mensual",
  "Actualiser": "Actualizar",
  "Administration ID Yuki": "ID de administración de Yuki",
  "Adresse": "Dirección",
  "Adresse de l'assureur": "Dirección de la aseguradora",
  "Adresse des travaux": "Dirección de los trabajos",
  "Adresse du chantier": "Dirección de la obra",
  "Adresse indisponible.": "Dirección no disponible.",
  "Adresse mise à jour.": "Dirección actualizada.",
  "Adresse non renseignée": "Dirección no indicada",
  "Afficher l'assurance sur mes documents": "Mostrar el seguro en mis documentos",
  "Afficher les articles achetés": "Mostrar los artículos comprados",
  "Afficher mes avis clients dans les devis": "Mostrar las reseñas de mis clientes en los presupuestos",
  "Afficher mon logo dans les emails clients": "Mostrar mi logotipo en los correos electrónicos a clientes",
  "Afficher « Devis gratuit – 0 € » dans l'email": "Mostrar « Presupuesto gratuito – 0 € » en el correo electrónico",
  "Affiner avec mes réponses": "Ajustar con mis respuestas",
  "Agenda 7 jours": "Agenda de 7 días",
  "Ajout impossible": "No se puede añadir",
  "Ajout impossible.": "No se puede añadir.",
  "Ajoute deux heures de main-d'œuvre": "Añada dos horas de mano de obra",
  "Ajoute l'évacuation des déchets": "Añada la retirada de residuos",
  "Ajoute le déplacement et la mise en service": "Añada el desplazamiento y la puesta en servicio",
  "Ajoute un acompte de 30 % à la commande": "Añada un anticipo del 30 % al realizar el pedido",
  "Ajouter": "Añadir",
  "Ajouter au devis": "Añadir al presupuesto",
  "Ajouter aux remarques": "Añadir a las observaciones",
  "Ajouter depuis mes tarifs…": "Añadir desde mis tarifas…",
  "Ajouter du matériel à un chantier": "Añadir material a una obra",
  "Ajouter l'équipement": "Añadir el equipo",
  "Ajouter mon logo": "Añadir mi logotipo",
  "Ajouter un destinataire": "Añadir un destinatario",
  "Ajouter un pays": "Añadir un país",
  "Ajouter un taux": "Añadir un tipo",
  "Ajouter une intervention ce jour": "Añadir una intervención hoy",
  "Ajouter une ligne": "Añadir una línea",
  "Ajouter une question": "Añadir una pregunta",
  "Ajoutez Devisto à votre écran d'accueil": "Añada Devisto a su pantalla de inicio",
  "Ajoutez au moins une ligne au devis": "Añada al menos una línea al presupuesto",
  "Ajoutez au moins une ligne avec une description": "Añada al menos una línea con una descripción",
  "Ajoutez au moins une ligne avec une description.": "Añada al menos una línea con una descripción.",
  "Ajoutez chaque passage : la prochaine échéance se recalcule": "Añada cada visita: el próximo vencimiento se recalcula",
  "Ajoutez d'abord votre lien d'avis (Google, etc.) dans": "Añada primero el enlace a sus reseñas (Google, etc.) en",
  "Ajoutez des photos ci-dessous pour que l'IA les décrive dans le rapport": "Añada fotos a continuación para que la IA las describa en el informe",
  "Ajoutez l'email du client avant d'envoyer la planification": "Añada el correo electrónico del cliente antes de enviar la planificación",
  "Ajoutez l'email du client avant de relancer": "Añada el correo electrónico del cliente antes de enviar el recordatorio",
  "Ajoutez l'email du client avant l'envoi": "Añada el correo electrónico del cliente antes del envío",
  "Ajoutez l'email du client dans le dossier avant l'envoi": "Añada el correo electrónico del cliente al expediente antes del envío",
  "Ajoutez la chaudière, la PAC, la ventilation ou le boiler. Vous obtiendrez un QR code à coller sur l'appareil et un rappel d'entretien automatique.": "Añada la caldera, la bomba de calor, la ventilación o el calentador de agua. Obtendrá un código QR para pegar en el aparato y un recordatorio de mantenimiento automático.",
  "Ajoutez un PDF : l'IA lit le fournisseur, les montants et l'échéance.": "Añada un PDF: la IA leerá el proveedor, los importes y la fecha de vencimiento.",
  "Ajoutez un PDF ou écrivez la liste du matériel": "Añada un PDF o escriba la lista del material",
  "Ajoutez un PDF ou écrivez la liste du matériel.": "Añada un PDF o escriba la lista del material.",
  "Ajoutez une consigne (facultatif) puis envoyez : l'assistant identifie le matériel.": "Añada una indicación (opcional) y envíela: el asistente identificará el material.",
  "Ajoutez une date d'installation à vos équipements pour planifier les entretiens.": "Añada una fecha de instalación a sus equipos para planificar los mantenimientos.",
  "Ajoutez une mesure avec les boutons ci-dessous.": "Añada una medición con los botones de abajo.",
  "Ajoutez votre assurance": "Añada su seguro",
  "Ajoutez votre lien d'avis (Google) dans votre profil avant d'envoyer une demande d'avis": "Añada el enlace a sus reseñas (Google) en su perfil antes de enviar una solicitud de reseña",
  "Ajoutez votre logo et choisissez vos couleurs : devis, rapports et factures les reprendront automatiquement. Vous pourrez modifier tout ça à tout moment dans votre profil.": "Añada su logotipo y elija sus colores: los presupuestos, informes y facturas los incorporarán automáticamente. Podrá cambiarlo todo en cualquier momento desde su perfil.",
  "Ajoutées en dernière page de vos devis et factures PDF, et visibles sur les pages en ligne. Une ligne commençant par « Article » devient un titre.": "Añadidas a la última página de sus presupuestos y facturas en PDF, y visibles en las páginas en línea. Una línea que comienza por « Artículo » se convierte en un título.",
  "Alarme": "Alarma",
  "Alertes sur ce téléphone": "Alertas en este teléfono",
  "Alimentation électrique": "Alimentación eléctrica",
  "Aller directement à": "Ir directamente a",
  "Aller à mes factures": "Ir a mis facturas",
  "Amendes de 1 500 € à 5 000 € en cas de non-conformité répétée après avertissement.": "Multas de 1 500 € a 5 000 € en caso de incumplimiento reiterado tras una advertencia.",
  "Analyse de la dictée impossible. Réessayez.": "No se ha podido analizar el dictado. Inténtelo de nuevo.",
  "Analyse de la photo…": "Análisis de la foto…",
  "Analyse en cours…": "Análisis en curso…",
  "Analyse impossible.": "No se ha podido realizar el análisis.",
  "Analyse…": "Análisis…",
  "Ancienneté approximative": "Antigüedad aproximada",
  "Annuler": "Cancelar",
  "Annuler l'invitation": "Cancelar la invitación",
  "Annulée": "Anulada",
  "Année": "Año",
  "Année approximative": "Año aproximado",
  "Année de construction": "Año de construcción",
  "Août": "Agosto",
  "Aperçu": "Vista previa",
  "Aperçu PDF": "Vista previa del PDF",
  "Aperçu d'un devis": "Vista previa de un presupuesto",
  "Aperçu du document": "Vista previa del documento",
  "Aperçu du résumé du soir": "Vista previa del resumen de la tarde",
  "Aperçu impossible.": "No se puede mostrar la vista previa.",
  "Aperçu indisponible.": "Vista previa no disponible.",
  "Apparence": "Apariencia",
  "Apparence de l'espace Studio": "Apariencia del espacio Studio",
  "Apparence de vos devis et factures, pied de page et modèles d'emails envoyés à vos clients.": "Aspecto de sus presupuestos y facturas, pie de página y plantillas de correos electrónicos enviados a sus clientes.",
  "Apparent": "Aparente",
  "Apple Pay": "Apple Pay",
  "Appliquer": "Aplicar",
  "Appliquer à la fiche": "Aplicar a la ficha",
  "Apposée dans le cadre « Signature de l'entreprise » de vos devis, contrats et rapports PDF.": "Incluida en el recuadro «Firma de la empresa» de sus presupuestos, contratos e informes PDF.",
  "Appuyez sur Partager, en bas de Safari": "Pulse Compartir, en la parte inferior de Safari",
  "Après travaux": "Después de las obras",
  "Archivé": "Archivado",
  "Arrivé sur place": "Llegado al lugar",
  "Arrivée estimée": "Llegada estimada",
  "Arrivée estimée 09:15": "Llegada estimada 09:15",
  "ArrowDown": "ArrowDown",
  "ArrowUp": "ArrowUp",
  "Arrêter": "Detener",
  "Arrêter la dictée": "Detener el dictado",
  "Article 1 – Champ d'application Les présentes conditions s'appliquent à… Article 2 – Paiement …": "Artículo 1 – Ámbito de aplicación Las presentes condiciones se aplican a… Artículo 2 – Pago …",
  "Article 1 – Champ d'application\\nLes présentes conditions s'appliquent à…\\n\\nArticle 2 – Paiement\\n…": "Artículo 1 – Ámbito de aplicación\\nEstas condiciones se aplican a…\\n\\nArtículo 2 – Pago\\n…",
  "Article créé.": "Artículo creado.",
  "Article mis à jour.": "Artículo actualizado.",
  "Article supprimé.": "Artículo eliminado.",
  "Artisan :": "Artesano:",
  "Artisans": "Artesanos",
  "Ascenseurs et monte-charges": "Ascensores y montacargas",
  "Assistant": "Asistente",
  "Assistant Devisto": "Asistente Devisto",
  "Assistant IA": "Asistente de IA",
  "Assistant vocal et lecture de plaque": "Asistente de voz y lectura de matrículas",
  "Attendu :": "Previsto:",
  "Attention : ce devis est à perte (": "Atención: este presupuesto genera pérdidas (",
  "Attention : ce devis est à perte en l'état.": "Atención: este presupuesto genera pérdidas tal como está.",
  "Au": "Hasta el",
  "Au sujet d'un devis": "Sobre un presupuesto",
  "Au sujet d'une facture": "Sobre una factura",
  "Aucun": "Ninguno",
  "Aucun accès comptable pour l'instant.": "Aún no hay acceso para la gestoría.",
  "Aucun article pour le moment.": "Ningún artículo por el momento.",
  "Aucun autre dossier ne correspond.": "Ningún otro expediente coincide.",
  "Aucun avoir fournisseur": "Ningún abono de proveedor",
  "Aucun avoir pour l'instant": "Ningún abono por ahora",
  "Aucun bâtiment enregistré": "Ningún edificio registrado",
  "Aucun chantier lié": "Ninguna obra vinculada",
  "Aucun client enregistré.": "Ningún cliente registrado.",
  "Aucun client ne correspond à votre recherche.": "Ningún cliente coincide con su búsqueda.",
  "Aucun contrat": "Ningún contrato",
  "Aucun devis ne correspond": "Ningún presupuesto coincide",
  "Aucun devis pour l'instant": "Ningún presupuesto por ahora",
  "Aucun devis signé sur": "Ningún presupuesto firmado en",
  "Aucun document d'achat sur cette année": "Ningún documento de compra este año",
  "Aucun document ne correspond": "Ningún documento coincide",
  "Aucun document pour le moment.": "Ningún documento por el momento.",
  "Aucun dossier ne correspond": "Ningún expediente coincide",
  "Aucun dossier pour l'instant": "Ningún expediente por ahora",
  "Aucun dossier soumis pour le moment.": "Ningún expediente presentado por el momento.",
  "Aucun entretien cette semaine, aucun contrat à renouveler.": "Ningún mantenimiento esta semana, ningún contrato pendiente de renovación.",
  "Aucun entretien à replacer": "Ningún mantenimiento pendiente de reprogramar",
  "Aucun logo": "Ningún logotipo",
  "Aucun matériel reconnu. Précisez la liste ou vérifiez le PDF.": "No se ha identificado ningún material. Detalle la lista o compruebe el PDF.",
  "Aucun modèle — devis vierge ou IA": "Ninguna plantilla — presupuesto en blanco o IA",
  "Aucun oubli détecté, le devis est prêt à partir.": "No se ha detectado ninguna omisión, el presupuesto está listo para enviarse.",
  "Aucun ouvrier ni comptable pour l'instant. Donnez votre premier accès ci-dessus.": "Aún no hay ningún operario ni acceso para la gestoría. Conceda el primer acceso arriba.",
  "Aucun rappel à envoyer pour le moment.": "Ningún recordatorio pendiente de envío por el momento.",
  "Aucun repère fiable détecté : valeurs indicatives. Confirmez une dimension connue ci-dessous.": "No se ha detectado ninguna referencia fiable: valores orientativos. Confirme a continuación una dimensión conocida.",
  "Aucun règlement": "Ningún pago",
  "Aucun règlement enregistré.": "Ningún pago registrado.",
  "Aucun résultat pour «": "Ningún resultado para «",
  "Aucun travail listé. Ajoutez une ligne.": "Ningún trabajo incluido. Añada una línea.",
  "Aucun équipement": "Ningún equipo",
  "Aucune": "Ninguna",
  "Aucune (article indépendant)": "Ninguna (artículo independiente)",
  "Aucune conversation pour l'instant.": "Ninguna conversación por el momento.",
  "Aucune demande pour l'instant": "Ninguna solicitud por el momento",
  "Aucune facture d'achat": "Ninguna factura de compra",
  "Aucune facture de vente sur cette année": "Ninguna factura de venta este año",
  "Aucune facture en": "Ninguna factura en",
  "Aucune facture pour cette période.": "Ninguna factura para este período.",
  "Aucune facture pour l'instant": "Ninguna factura por ahora",
  "Aucune facture émise.": "No se ha emitido ninguna factura.",
  "Aucune information lisible sur cette plaque.": "No hay información legible en esta placa.",
  "Aucune intervention enregistrée": "Ninguna intervención registrada",
  "Aucune intervention enregistrée pour le moment.": "Ninguna intervención registrada por el momento.",
  "Aucune intervention enregistrée.": "Ninguna intervención registrada.",
  "Aucune intervention ne correspond": "Ninguna intervención coincide",
  "Aucune intervention pour ce chantier.": "Ninguna intervención para esta obra.",
  "Aucune intervention pour l'instant": "Ninguna intervención por ahora",
  "Aucune ligne pour l'instant": "Ninguna línea por el momento",
  "Aucune mesure proposée : ajoutez vos points à la main ou reprenez la photo avec une référence (feuille A4, mètre).": "Ninguna medición propuesta: añada los puntos manualmente o vuelva a tomar la foto con una referencia (hoja A4, metro).",
  "Aucune modification : paramètres initiaux (à vérifier) en place.": "Ninguna modificación: se mantienen los parámetros iniciales (pendientes de verificar).",
  "Aucune note de crédit sur cette année": "Ningún abono este año",
  "Aucune notification pour l'instant.": "Ninguna notificación por ahora.",
  "Aucune notification.": "Ninguna notificación.",
  "Aucune parole détectée dans l'enregistrement": "No se ha detectado voz en la grabación",
  "Aucune prestation. Importez un jeu de tarifs types pour démarrer.": "Ninguna prestación. Importe un conjunto de tarifas estándar para empezar.",
  "Aucune question en attente": "Ninguna pregunta pendiente",
  "Aucune question pour l'instant": "Ninguna pregunta por el momento",
  "Aucune réponse envoyée": "Ninguna respuesta enviada",
  "Aucune signature": "Ninguna firma",
  "Aucune société pour le moment.": "Ninguna empresa por el momento.",
  "Aucune visite planifiée": "Ninguna visita programada",
  "Aujourd'hui 09:00": "Hoy 09:00",
  "Auto si vide": "Automático si está vacío",
  "Autoliquidation": "Inversión del sujeto pasivo",
  "Autoliquidation : TVA à acquitter par le cocontractant (art. 20 de l'A.R. n° 1 du 29/12/1992). Cette mention\n          est reprise automatiquement sur le devis PDF.": "Inversión del sujeto pasivo: IVA a liquidar por la otra parte contratante (art. 20 del Real Decreto n° 1 de 29/12/1992). Esta indicación\n          se incluye automáticamente en el presupuesto PDF.",
  "Autoliquidation : TVA à acquitter par le cocontractant (art. 20 de l'A.R. n° 1 du 29/12/1992). Cette mention est reprise automatiquement sur le devis PDF.": "Inversión del sujeto pasivo: IVA a cargo del cocontratante (art. 20 del Real Decreto n° 1 del 29/12/1992). Esta mención se incluye automáticamente en el presupuesto PDF.",
  "Autoliquidation possible dans ce pays": "Inversión del sujeto pasivo posible en este país",
  "Autorisation refusée.": "Autorización denegada.",
  "Autre": "Otro",
  "Autre métier technique": "Otra profesión técnica",
  "Autre réponse…": "Otra respuesta…",
  "Autres idées": "Otras ideas",
  "Autres postes": "Otras partidas",
  "Avant / après, plaque, raccordements : jusqu'à 6 photos dans le rapport.": "Antes / después, placa, conexiones: hasta 6 fotos en el informe.",
  "Avant d'envoyer": "Antes de enviar",
  "Avant de créer votre première facture, vérifiez votre numéro de TVA (base VIES) et déposez un extrait BCE ou une facture de frais.": "Antes de crear su primera factura, compruebe su NIF-IVA (base de datos VIES) y adjunte un extracto de la BCE o una factura de gastos.",
  "Avant travaux": "Antes de las obras",
  "Avec option": "Con opción",
  "Avis client": "Opinión del cliente",
  "Avoir": "Abono",
  "Avoir fournisseur": "Abono de proveedor",
  "Avoirs": "Abonos",
  "Avoirs fournisseurs": "Abonos de proveedores",
  "Avr": "Abr",
  "Avril": "Abril",
  "BE 0123.456.789": "BE 0123.456.789",
  "BE0123456789": "BE0123456789",
  "Ballon": "Acumulador",
  "Bancontact": "Bancontact",
  "Bancontact · Payconiq": "Bancontact · Payconiq",
  "Base": "Base",
  "Bearer": "Bearer",
  "Belfius": "Belfius",
  "Belgique": "Bélgica",
  "Belgique, Benelux…": "Bélgica, Benelux…",
  "Besoin d'un devis après cette intervention ?": "¿Necesita un presupuesto después de esta intervención?",
  "Bibliothèque de prix": "Biblioteca de precios",
  "Bien": "Bien",
  "Bienvenue": "Bienvenido",
  "Bienvenue ! Voici l'espace comptable.": "¡Bienvenido! Este es el espacio de la gestoría.",
  "Bienvenue dans Devisto Studio.": "Le damos la bienvenida a Devisto Studio.",
  "Bienvenue dans le Studio !": "¡Bienvenido al Studio!",
  "Billit": "Billit",
  "Billit injoignable. Réessayez dans un instant.": "No se puede conectar con Billit. Vuelva a intentarlo en unos instantes.",
  "Bleu nuit": "Azul noche",
  "Bloquant": "Bloqueante",
  "Bloquées dans le navigateur : autorisez-les dans ses réglages.": "Bloqueadas en el navegador: autorícelas en su configuración.",
  "Boiler": "Caldera",
  "Boiler électrique": "Termo eléctrico",
  "Bon": "Parte",
  "Bon après-midi": "Buenas tardes",
  "Bonjour": "Buenos días",
  "Bonjour, je suis l'assistant Devisto. Comment puis-je vous aider ?": "Hola, soy el asistente de Devisto. ¿En qué puedo ayudarle?",
  "Bonsoir": "Buenas noches",
  "Borne de recharge": "Punto de recarga",
  "Brouillon": "Borrador",
  "Brouillon de chantier": "Borrador de obra",
  "Brouillon enregistré. Reprenez-le quand vous voulez depuis le dossier ou la liste des devis.": "Borrador guardado. Retómelo cuando quiera desde el expediente o la lista de presupuestos.",
  "Brouillon généré — relisez et ajustez avant publication.": "Borrador generado — revíselo y ajústelo antes de publicarlo.",
  "Brouillon rédigé : relisez puis envoyez.": "Borrador redactado: revíselo y envíelo.",
  "Brouillons": "Borradores",
  "Bureaux Parc Nord": "Oficinas Parque Norte",
  "Bâtiment": "Edificio",
  "Bâtiment supprimé": "Edificio eliminado",
  "Bâtiment «": "Edificio «",
  "Bâtiments": "Edificios",
  "Bâtiments & équipements": "Edificios y equipos",
  "Bâtiments ·": "Edificios ·",
  "Bénéficiaire": "Beneficiario",
  "Bénéficiaire :": "Beneficiario:",
  "Béton et fondations": "Hormigón y cimentaciones",
  "C'est fait": "Hecho",
  "C'est prêt, aller au Studio": "Está listo, ir al Studio",
  "CA HT": "Facturación sin IVA",
  "Caméra intelligente": "Cámara inteligente",
  "Candidatez aux missions B2B des entreprises": "Presente su candidatura a los encargos B2B de las empresas",
  "Capacité (litres)": "Capacidad (litros)",
  "Capture terrain, photos, mesures": "Captura en obra, fotos, mediciones",
  "Carreleur": "Alicatador",
  "Carte": "Mapa",
  "Catégorie": "Categoría",
  "Catégorie (fournitures, sous-traitance…)": "Categoría (suministros, subcontratación…)",
  "Causes probables": "Causas probables",
  "Ce PDF ne contient pas de texte lisible (scan ou photo). Prenez-le en photo dans le dossier ": "Este PDF no contiene texto legible (escaneo o foto). Hágale una foto en el expediente ",
  "Ce bouton est ajouté automatiquement sous votre texte, avec votre logo en en-tête.": "Este botón se añade automáticamente debajo de su texto, con su logotipo en la cabecera.",
  "Ce client n'a pas d'adresse email": "Este cliente no tiene dirección de correo electrónico",
  "Ce contrat n'est plus disponible. Contactez votre entrepreneur.": "Este contrato ya no está disponible. Póngase en contacto con su contratista.",
  "Ce devis a déjà reçu une réponse": "Este presupuesto ya ha recibido una respuesta",
  "Ce devis a déjà été facturé : supprimez d'abord la facture": "Este presupuesto ya se ha facturado: elimine primero la factura",
  "Ce devis est clôturé : dupliquez-le pour le modifier": "Este presupuesto está cerrado: duplíquelo para modificarlo",
  "Ce devis n'a aucune ligne à enregistrer": "Este presupuesto no tiene ninguna línea que guardar",
  "Ce devis n'est pas en attente de réponse": "Este presupuesto no está pendiente de respuesta",
  "Ce devis propose": "Este presupuesto propone",
  "Ce devis propose plusieurs options : attendez le choix du client (signature) avant de facturer un acompte": "Este presupuesto ofrece varias opciones: espere a que el cliente elija una (firma) antes de facturar un anticipo",
  "Ce document n'est plus disponible. Contactez votre entrepreneur.": "Este documento ya no está disponible. Póngase en contacto con su contratista.",
  "Ce domaine rejoint bientôt la plateforme": "Este sector se incorporará pronto a la plataforma",
  "Ce lien d'export a expiré. Demandez un nouvel envoi à l'entreprise.": "Este enlace de exportación ha caducado. Solicite a la empresa que se lo envíe de nuevo.",
  "Ce lien n'est plus valide.": "Este enlace ya no es válido.",
  "Ce mois": "Este mes",
  "Ce mois :": "Este mes:",
  "Ce navigateur ne gère pas les notifications push.": "Este navegador no admite las notificaciones push.",
  "Ce numéro de TVA n'est pas actif dans la base européenne.": "Este NIF-IVA no está activo en la base de datos europea.",
  "Ce passeport technique est introuvable.": "No se encuentra este pasaporte técnico.",
  "Ce que disent les artisans": "Lo que dicen los profesionales del sector",
  "Ce que dit la loi": "Lo que dice la ley",
  "Ce que vous avez constaté…": "Lo que ha observado…",
  "Ce qui a été constaté et réalisé…": "Lo que se ha observado y realizado…",
  "Ce qui a été fait, pièces remplacées, valeurs de combustion…": "Lo que se ha hecho, piezas sustituidas, valores de combustión…",
  "Ce rapport décrit les travaux réalisés. Les montants éventuels font l'objet d'un document séparé\n            (devis ou facture).": "Este informe describe los trabajos realizados. Los posibles importes figuran en un documento aparte\n            (presupuesto o factura).",
  "Ce rapport décrit les travaux réalisés. Les montants éventuels font l'objet d'un document séparé (devis ou facture).": "Este informe describe los trabajos realizados. Los posibles importes figuran en un documento aparte (presupuesto o factura).",
  "Ce rapport est déjà signé": "Este informe ya está firmado",
  "Centralisez et gérez tout votre parc immobilier.": "Centralice y gestione todo su patrimonio inmobiliario.",
  "Centralisez immeubles, lots, équipements et interventions dans un seul espace, et créez des demandes liées à chaque unité en quelques clics.": "Centralice edificios, unidades, equipos e intervenciones en un solo espacio y cree solicitudes vinculadas a cada unidad en unos pocos clics.",
  "Ces informations apparaissent en en-tête de vos devis PDF.": "Esta información aparece en la cabecera de sus presupuestos en PDF.",
  "Ces tarifs sont déjà présents.": "Estas tarifas ya están registradas.",
  "Cette facture est déjà réglée": "Esta factura ya está pagada",
  "Cette intervention est déjà liée à un dossier": "Esta intervención ya está vinculada a un expediente",
  "Cette page n'est plus disponible. Contactez votre entrepreneur.": "Esta página ya no está disponible. Póngase en contacto con su contratista.",
  "Cette page n'existe pas.": "Esta página no existe.",
  "Champs fiscaux obligatoires : ": "Campos fiscales obligatorios: ",
  "Changer le logo": "Cambiar el logotipo",
  "Changez d'année ou utilisez l'export pour une autre période.": "Cambie de año o utilice la exportación para otro periodo.",
  "Chantier": "Obra",
  "Chantier :": "Obra:",
  "Chantier en cours": "Obra en curso",
  "Chantier terminé": "Obra terminada",
  "Chantiers": "Obras",
  "Chantiers en cours": "Obras en curso",
  "Chantiers sur ce bâtiment": "Obras en este edificio",
  "Chapiste": "Instalador de soleras",
  "Chaque 1er janvier, avril, juillet et octobre, Devisto envoie à votre comptable le ZIP du trimestre écoulé (ventes, achats, règlements, UBL) avec un lien valable 90 jours. Vous pouvez aussi lui donner": "Cada 1 de enero, abril, julio y octubre, Devisto envía a su gestoría el archivo ZIP del trimestre anterior (ventas, compras, cobros y pagos, UBL) mediante un enlace válido durante 90 días. También puede darle",
  "Chaque appareil garde son passeport et son historique": "Cada aparato conserva su pasaporte y su historial",
  "Chaque entretien enregistré sur un équipement apparaît ici.": "Cada mantenimiento registrado en un equipo aparece aquí.",
  "Chaque facture doit avoir au moins une ligne décrite": "Cada factura debe tener al menos una línea con una descripción",
  "Chaque facture est générée au format Peppol BIS Billing 3.0 (UBL 2.1), obligatoire en Belgique entre assujettis. Téléchargez le XML pour l'envoyer via votre access point Peppol ou votre comptable.": "Cada factura se genera en formato Peppol BIS Billing 3.0 (UBL 2.1), obligatorio en Bélgica entre sujetos pasivos. Descargue el XML para enviarlo a través de su punto de acceso Peppol o de su gestoría.",
  "Chargement de votre activité…": "Cargando su actividad…",
  "Chargement des dossiers…": "Cargando expedientes…",
  "Chargement impossible.": "No se ha podido cargar.",
  "Chargement…": "Cargando…",
  "Charpentier": "Carpintero de estructuras",
  "Chaudière au sol": "Caldera de pie",
  "Chaudière existante": "Caldera existente",
  "Chaudière murale": "Caldera mural",
  "Chauffage": "Calefacción",
  "Chauffage + eau chaude": "Calefacción + agua caliente",
  "Chauffage Dupont SRL": "Calefacción Dupont SRL",
  "Chauffage seul": "Solo calefacción",
  "Chauffage sol": "Calefacción por suelo radiante",
  "Chauffage électrique": "Calefacción eléctrica",
  "Chauffagiste": "Instalador de calefacción",
  "Chauffe-eau": "Calentador de agua",
  "Checklist métier": "Lista de comprobación profesional",
  "Checklist métier générée.": "Lista de comprobación profesional generada.",
  "Cheminement": "Recorrido",
  "Cheminée tubée": "Chimenea entubada",
  "Chiffrage en cours…": "Cálculo en curso…",
  "Chiffre d'affaires": "Volumen de negocio",
  "Chiffrer le devis": "Calcular el presupuesto",
  "Chiffres à prendre avec prudence : coût d'achat manquant sur": "Cifras que deben interpretarse con cautela: falta el coste de compra en",
  "Choisir la mesure…": "Seleccionar la medida…",
  "Choisir le chantier…": "Seleccionar la obra…",
  "Choisir le client…": "Seleccionar el cliente…",
  "Choisir le devis…": "Seleccionar el presupuesto…",
  "Choisir un fichier": "Elegir un archivo",
  "Choisissez au moins un journal": "Seleccione al menos un diario",
  "Choisissez au moins un journal.": "Seleccione al menos un diario.",
  "Choisissez l'option qui vous convient avant de signer.": "Elija la opción que más le convenga antes de firmar.",
  "Choisissez l'option retenue avant de signer": "Seleccione la opción elegida antes de firmar",
  "Choisissez l'option retenue par le client.": "Seleccione la opción elegida por el cliente.",
  "Choisissez la date de la visite": "Seleccione la fecha de la visita",
  "Choisissez la date de la visite.": "Elija la fecha de la visita.",
  "Choisissez le chantier et indiquez le matériel.": "Elija la obra e indique el material.",
  "Choisissez le dossier concerné (chantier en cours ou devis enregistré) : le matériel rejoint sa liste et apparaît ici.": "Seleccione el expediente correspondiente (obra en curso o presupuesto guardado): el material se añade a su lista y aparece aquí.",
  "Choisissez un client ou indiquez son nom.": "Elija un cliente o indique su nombre.",
  "Choisissez un client ou tapez son nom. Le dossier chantier est créé automatiquement.": "Seleccione un cliente o escriba su nombre. El expediente de obra se crea automáticamente.",
  "Choisissez un client.": "Elija un cliente.",
  "Choisissez un devis.": "Seleccione un presupuesto.",
  "Choisissez une mesure et indiquez sa valeur réelle.": "Elija una medida e indique su valor real.",
  "Choisissez une note.": "Elija una nota.",
  "Choisissez une photo JPEG ou PNG.": "Seleccione una foto JPEG o PNG.",
  "Choisissez votre mot de passe pour accéder aux dossiers de chantier de la société.": "Elija su contraseña para acceder a los expedientes de obra de la empresa.",
  "Choisissez votre mot de passe pour consulter les factures de vente (PDF + UBL), les achats et l'export comptable de la société.": "Elija su contraseña para consultar las facturas de venta (PDF + UBL), las compras y la exportación contable de la empresa.",
  "Choisissez « Sur l'écran d'accueil »": "Elija « En la pantalla de inicio »",
  "Chèque": "Cheque",
  "Clair": "Claro",
  "Classe PEB": "Clase PEB",
  "Classe PEB inconnue": "Clase PEB desconocida",
  "Classique": "Clásico",
  "Classique (avec empattements)": "Clásico (con remates)",
  "Clauses": "Cláusulas",
  "Clauses du contrat": "Cláusulas del contrato",
  "Client": "Cliente",
  "Client (optionnel)": "Cliente (opcional)",
  "Client :": "Cliente:",
  "Client détecté dans la phrase": "Cliente detectado en la frase",
  "Client enregistré.": "Cliente guardado.",
  "Client et chantier": "Cliente y obra",
  "Client introuvable": "Cliente no encontrado",
  "Client particulier": "Cliente particular",
  "Client professionnel": "Cliente profesional",
  "Client professionnel assujetti : l'autoliquidation peut s'appliquer aux travaux immobiliers. Confirmez le traitement (lignes en « AC ») ou facturez avec TVA.": "Cliente profesional sujeto a IVA: la inversión del sujeto pasivo puede aplicarse a las ejecuciones de obra. Confirme el tratamiento (líneas en « ISP ») o facture con IVA.",
  "Client, dossier, devis, facture…": "Cliente, expediente, presupuesto, factura…",
  "Client, lignes, envoi": "Cliente, líneas, envío",
  "Clients": "Clientes",
  "Clients accompagnés": "Clientes asesorados",
  "Climatisation": "Climatización",
  "Climatisation / PAC": "Climatización / PAC",
  "Clé API Billit": "Clave API de Billit",
  "Clé API Mollie (test_… ou live_…)": "Clave API de Mollie (test_… o live_…)",
  "Clé API Odoo": "Clave API de Odoo",
  "Clé API Recommand": "Clave API Recommand",
  "Clé API à générer dans Odoo → Préférences → Sécurité du compte → Nouvelle clé API. La facture est créée en brouillon, vous la validez dans Odoo.": "Clave API que debe generar en Odoo → Preferencias → Seguridad de la cuenta → Nueva clave API. La factura se crea como borrador y usted la valida en Odoo.",
  "Clé active": "Clave activa",
  "Clé d'accès Web Service Yuki + identifiant d'administration (import automatique des ventes activé).": "Clave de acceso al servicio web de Yuki + identificador de administración (importación automática de ventas activada).",
  "Clé d'accès Yuki": "Clave de acceso a Yuki",
  "Clé d'accès Yuki refusée. Vérifiez votre clé dans Mon entreprise.": "Clave de acceso de Yuki rechazada. Compruebe su clave en Mi empresa.",
  "Clé enregistrée — connexion Recommand vérifiée.": "Clave guardada — conexión con Recommand verificada.",
  "Clé enregistrée.": "Clave guardada.",
  "Clé refusée par Mollie.": "Clave rechazada por Mollie.",
  "Clé retirée.": "Clave eliminada.",
  "Clôtures et portails": "Vallas y portones",
  "Clôturés": "Cerrados",
  "Code postal": "Código postal",
  "Coller une question reçue par e-mail / SMS": "Pegar una consulta recibida por correo electrónico / SMS",
  "Collez ici le message du client…": "Pegue aquí el mensaje del cliente…",
  "Collez votre clé API et votre PartyID Billit (MyBillit → Intégrations) : vos devis acceptés partiront directement en facture, sans copier-coller.\n            Laissez l'URL sandbox pour tester, puis passez à l'URL de production.": "Pegue su clave API y su PartyID de Billit (MyBillit → Integraciones): sus presupuestos aceptados se convertirán directamente en facturas, sin copiar y pegar.\n            Mantenga la URL de pruebas para hacer pruebas y, después, cambie a la URL de producción.",
  "Collez votre clé API et votre PartyID Billit (MyBillit → Intégrations) : vos devis acceptés partiront directement en facture, sans copier-coller. Laissez l'URL sandbox pour tester, puis passez à l'URL de production.": "Pegue su clave API y su PartyID de Billit (MyBillit → Integraciones): sus presupuestos aceptados se convertirán directamente en facturas, sin copiar y pegar. Mantenga la URL del entorno de pruebas para realizar las pruebas y, después, cambie a la URL de producción.",
  "Combien ça coûte ?": "¿Cuánto cuesta?",
  "Combustible": "Combustible",
  "Commandes spéciales": "Pedidos especiales",
  "Commencer": "Empezar",
  "Commencer gratuitement": "Empezar gratis",
  "Comment Devisto vous met en règle": "Cómo Devisto le ayuda a cumplir la normativa",
  "Comment ajouter un immeuble ?": "¿Cómo añadir un edificio?",
  "Comment choisir un technicien ?": "¿Cómo elegir a un técnico?",
  "Comment créer une demande pour un lot ?": "¿Cómo crear una solicitud para un lote?",
  "Comment devenir partenaire pro ?": "¿Cómo convertirse en colaborador profesional?",
  "Comment décrire mon projet ?": "¿Cómo describir mi proyecto?",
  "Comment envoyer un devis ?": "¿Cómo enviar un presupuesto?",
  "Comment faire": "Cómo hacerlo",
  "Comment fonctionne le Devisto Score ?": "¿Cómo funciona el Devisto Score?",
  "Comment gérer mes demandes ?": "¿Cómo gestionar mis solicitudes?",
  "Comment publier une mission ?": "¿Cómo publicar un trabajo?",
  "Comment s'est passée notre intervention ?": "¿Cómo ha ido nuestra intervención?",
  "Comment se passe le paiement ?": "¿Cómo se realiza el pago?",
  "Comment suivre ma demande ?": "¿Cómo hacer el seguimiento de mi solicitud?",
  "Comment suivre une intervention ?": "¿Cómo hacer el seguimiento de una intervención?",
  "Comment ça fonctionne ?": "¿Cómo funciona?",
  "Comment ça marche": "Cómo funciona",
  "Commune": "Municipio",
  "Communication": "Comunicación",
  "Communication :": "Comunicación:",
  "Compact": "Compacto",
  "Comparez les profils, échangez avec les professionnels et choisissez la meilleure solution pour votre projet.": "Compare los perfiles, hable con los profesionales y elija la mejor solución para su proyecto.",
  "Compléter": "Completar",
  "Compléter ce devis": "Completar este presupuesto",
  "Compléter mes coûts d'achat et durées": "Completar mis costes de compra y tiempos",
  "Complétez les informations fiscales du client avant d'envoyer ce document.": "Complete los datos fiscales del cliente antes de enviar este documento.",
  "Complétez seulement ce qui est utile — l'assistant utilise ces informations pour le devis.": "Complete solo lo necesario — el asistente utiliza esta información para el presupuesto.",
  "Complétez votre profil pour générer le pied de page.": "Complete su perfil para generar el pie de página.",
  "Complétion impossible.": "No se puede completar.",
  "Comptabilité": "Contabilidad",
  "Comptable": "Gestoría",
  "Comptable :": "Gestoría:",
  "Comptable enregistré.": "Gestoría registrada.",
  "Compte actif ·": "Cuenta activa ·",
  "Compte de démonstration": "Cuenta de demostración",
  "Condensation": "Condensación",
  "Conditions": "Condiciones",
  "Conditions Générales de Vente": "Condiciones Generales de Venta",
  "Conditions d'application (vide = toujours)": "Condiciones de aplicación (vacío = siempre)",
  "Conditions générales de vente": "Condiciones generales de venta",
  "Conditions générales enregistrées.": "Condiciones generales guardadas.",
  "Conditions par défaut de vos devis": "Condiciones predeterminadas de sus presupuestos",
  "Confiance": "Confianza",
  "Conforme": "Conforme",
  "Connecter mon site web": "Conectar mi sitio web",
  "Connexion": "Conexión",
  "Consolidé ≈": "Consolidado ≈",
  "Constats / pièces": "Observaciones / documentos",
  "Consulté": "Consultado",
  "Consultée par le client le": "Consultada por el cliente el",
  "Contact": "Contacto",
  "Contenu": "Contenido",
  "Contenu du pied de page": "Contenido del pie de página",
  "Contrat": "Contrato",
  "Contrat d'entretien": "Contrato de mantenimiento",
  "Contrat enregistré.": "Contrato guardado.",
  "Contrat envoyé au client pour signature.": "Contrato enviado al cliente para su firma.",
  "Contrat introuvable.": "No se ha encontrado el contrato.",
  "Contrat préparé avec": "Contrato preparado con",
  "Contrat refusé": "Contrato rechazado",
  "Contrat rédigé par l'IA :": "Contrato redactado por la IA:",
  "Contrat signé": "Contrato firmado",
  "Contrat signé. Merci !": "Contrato firmado. ¡Gracias!",
  "Contrat supprimé.": "Contrato eliminado.",
  "Contrat terminé.": "Contrato finalizado.",
  "Contrats d'entretien": "Contratos de mantenimiento",
  "Contrats, rapports d'intervention, factures et garanties liés à cet immeuble.": "Contratos, informes de intervención, facturas y garantías relacionados con este inmueble.",
  "Contrôle réglementaire": "Inspección reglamentaria",
  "Conversations": "Conversaciones",
  "Convertir en facture": "Convertir en factura",
  "Copie impossible : sélectionnez le lien": "No se puede copiar: seleccione el enlace",
  "Copie impossible — sélectionnez le texte manuellement.": "No se ha podido copiar — seleccione el texto manualmente.",
  "Copier": "Copiar",
  "Copier la liste": "Copiar la lista",
  "Copier le devis": "Copiar el presupuesto",
  "Copier le lien": "Copiar el enlace",
  "Copier le lien client": "Copiar el enlace del cliente",
  "Copier le lien public": "Copiar el enlace público",
  "Copier tout et ouvrir mon app bancaire": "Copiar todo y abrir mi aplicación bancaria",
  "Copiez votre lien ci-dessus et placez-le sur votre site, vos réseaux ou votre fiche Google.": "Copie el enlace de arriba y publíquelo en su sitio web, sus redes sociales o su ficha de Google.",
  "Copié": "Copiado",
  "Copié.": "Copiado.",
  "Courtois": "Cortés",
  "Couvreur / toiture": "Especialista en cubiertas / tejados",
  "Coût": "Coste",
  "Coût (€)": "Coste (€)",
  "Coût d'achat": "Coste de compra",
  "Coût d'achat €": "Coste de compra €",
  "Coût fournisseur (facultatif)": "Coste del proveedor (opcional)",
  "Coût horaire de mon ouvrier (€/h)": "Coste por hora de mi operario (€/h)",
  "Coûts": "Costes",
  "Création de l'intervention impossible.": "No se ha podido crear la intervención.",
  "Création du devis impossible.": "No se ha podido crear el presupuesto.",
  "Création du dossier impossible.": "No se ha podido crear el expediente.",
  "Création impossible": "No se puede crear",
  "Création impossible.": "No se ha podido crear.",
  "Création…": "Creación…",
  "Créer": "Crear",
  "Créer depuis le modèle": "Crear a partir de la plantilla",
  "Créer en brouillon": "Crear como borrador",
  "Créer et chiffrer avec l'IA": "Crear y presupuestar con IA",
  "Créer et envoyer à signer": "Crear y enviar para su firma",
  "Créer l'intervention": "Crear la intervención",
  "Créer la facture": "Crear la factura",
  "Créer le brouillon": "Crear el borrador",
  "Créer le bâtiment": "Crear el edificio",
  "Créer le compte démo": "Crear la cuenta de demostración",
  "Créer le contrat (brouillon)": "Crear el contrato (borrador)",
  "Créer le devis": "Crear el presupuesto",
  "Créer le dossier": "Crear el expediente",
  "Créer le dossier depuis cette intervention": "Crear el expediente a partir de esta intervención",
  "Créer mon compte artisan": "Crear mi cuenta de artesano",
  "Créer un compte": "Crear una cuenta",
  "Créer un compte Mollie gratuit et copier la clé API": "Crear una cuenta gratuita de Mollie y copiar la clave API",
  "Créer une facture": "Crear una factura",
  "Créer une facture vierge": "Crear una factura en blanco",
  "Créer une note de crédit": "Crear un abono",
  "Créer une note de crédit pour annuler cette facture ?": "¿Crear un abono para anular esta factura?",
  "Créez l'intervention : client, adresse, travaux et prix sont repris automatiquement du devis.": "Cree la intervención: el cliente, la dirección, los trabajos y el precio se toman automáticamente del presupuesto.",
  "Créez la fiche du bâtiment, puis ajoutez ses équipements. Vous garderez l'historique complet et vous pourrez replacer les entretiens automatiquement.": "Cree la ficha del edificio y añada sus equipos. Conservará todo el historial y podrá reprogramar los mantenimientos automáticamente.",
  "Créez votre compte": "Cree su cuenta",
  "Créez votre premier dossier chantier : photos, notes et mesures sur place.": "Cree su primer expediente de obra: fotos, notas y mediciones in situ.",
  "Créez-en une depuis un devis signé ou pour un client.": "Cree una a partir de un presupuesto firmado o para un cliente.",
  "Créez-en une directement sur place, le rapport se signe au doigt.": "Cree una directamente in situ, el informe se firma con el dedo.",
  "Cuisiniste / salle de bains": "Instalador de cocinas / baños",
  "Câblage": "Cableado",
  "Date": "Fecha",
  "Date :": "Fecha:",
  "Date d'entretien inconnue": "Fecha de mantenimiento desconocida",
  "Date d'installation": "Fecha de instalación",
  "Date de visite": "Fecha de visita",
  "Date inconnue": "Fecha desconocida",
  "Date invalide": "Fecha no válida",
  "De la demande initiale jusqu'à la fin de l'intervention, Devisto centralise les informations essentielles pour faciliter la communication entre clients, professionnels, gestionnaires immobiliers et syndics.": "Desde la solicitud inicial hasta el final de la intervención, Devisto centraliza la información esencial para facilitar la comunicación entre clientes, profesionales, gestores inmobiliarios y administradores de fincas.",
  "Demande d'avis": "Solicitud de reseña",
  "Demande d'avis envoyée au client le": "Solicitud de valoración enviada al cliente el",
  "Demande envoyée": "Solicitud enviada",
  "Demander un avis": "Solicitar una reseña",
  "Demander un avis après chaque intervention": "Solicitar una reseña después de cada intervención",
  "Demander un devis gratuit": "Solicitar un presupuesto gratuito",
  "Demandes actives": "Solicitudes activas",
  "Demandes liées à un lot ou un équipement précis": "Solicitudes relacionadas con una unidad o un equipo concretos",
  "Demandes qualifiées": "Solicitudes cualificadas",
  "Demandes reçues": "Solicitudes recibidas",
  "Demandes web": "Solicitudes web",
  "Depuis 2026, chaque facture entre professionnels en Belgique doit passer par le réseau Peppol. Devisto l'envoie pour vous, au bon format, directement depuis votre devis signé.": "Desde 2026, cada factura entre profesionales en Bélgica debe pasar por la red Peppol. Devisto la envía por usted, en el formato correcto, directamente desde su presupuesto firmado.",
  "Depuis la liste des factures, le bouton « ? » permet de poser une question sur une facture précise. L'entreprise est notifiée et vous répond par e-mail.": "Desde la lista de facturas, el botón «? » le permite hacer una consulta sobre una factura concreta. La empresa recibe una notificación y le responde por correo electrónico.",
  "Depuis le 1er janvier": "Desde el 1 de enero",
  "Dernier entretien": "Último mantenimiento",
  "Dernier rappel avant mise en demeure": "Último recordatorio antes del requerimiento de pago",
  "Dernière remise à neuf réussie.": "Última renovación completada con éxito.",
  "Des demandes claires et précises pour des devis pertinents.": "Solicitudes claras y precisas para obtener presupuestos adecuados.",
  "Des prix clairs, des devis détaillés et un suivi en temps réel.": "Precios claros, presupuestos detallados y seguimiento en tiempo real.",
  "Des professionnels vérifiés et évalués par la communauté.": "Profesionales verificados y valorados por la comunidad.",
  "Description": "Descripción",
  "Description standard reprise dans le devis": "Descripción estándar incluida en el presupuesto",
  "Description à compléter": "Descripción pendiente de completar",
  "Descriptions réécrites pour le client — pensez à enregistrer.": "Descripciones reformuladas para el cliente — recuerde guardarlas.",
  "Destinataires": "Destinatarios",
  "Deux minutes, et votre premier devis est prêt.": "Dos minutos y su primer presupuesto estará listo.",
  "Deux minutes, sans carte bancaire. Votre numéro de TVA est vérifié automatiquement.": "Dos minutos, sin tarjeta bancaria. Su NIF-IVA se verifica automáticamente.",
  "Deux minutes, une seule fois.": "Dos minutos, una sola vez.",
  "Devenir partenaire pro": "Conviértase en socio profesional",
  "Devis": "Presupuestos",
  "Devis / chantiers": "Presupuestos / obras",
  "Devis :": "Presupuesto:",
  "Devis PDF, envoi et signature en ligne": "Presupuestos en PDF, envío y firma en línea",
  "Devis accepté": "Presupuesto aceptado",
  "Devis accepté. L'entreprise est prévenue.": "Presupuesto aceptado. La empresa ha recibido una notificación.",
  "Devis brouillon créé avec": "Borrador de presupuesto creado con",
  "Devis copié — collez-le dans votre logiciel.": "Presupuesto copiado — péguelo en su programa.",
  "Devis créé": "Presupuesto creado",
  "Devis depuis un PDF ou une liste de matériel": "Presupuesto a partir de un PDF o una lista de material",
  "Devis dicté, signature en ligne, facture Peppol : tout le travail du bâtiment, du chantier à la facture.": "Presupuesto dictado, firma en línea, factura Peppol: todo el trabajo de la construcción, desde la obra hasta la factura.",
  "Devis du dossier": "Presupuesto del expediente",
  "Devis déjà créé pour cette demande.": "Ya se ha creado un presupuesto para esta solicitud.",
  "Devis en cours": "Presupuesto en curso",
  "Devis en quelques questions, conseils métier, textes clients : il garde le fil de chaque conversation.": "Presupuestos con unas pocas preguntas, consejos profesionales y textos para clientes: mantiene el hilo de cada conversación.",
  "Devis enregistré.": "Presupuesto guardado.",
  "Devis envoyé": "Presupuesto enviado",
  "Devis envoyé au client.": "Presupuesto enviado al cliente.",
  "Devis envoyés": "Presupuestos enviados",
  "Devis intelligent — à vérifier": "Presupuesto inteligente — pendiente de revisión",
  "Devis introuvable": "Presupuesto no encontrado",
  "Devis introuvable.": "No se encuentra el presupuesto.",
  "Devis mis à jour — pensez à enregistrer.": "Presupuesto actualizado — recuerde guardarlo.",
  "Devis préparé avec Devisto ·": "Presupuesto preparado con Devisto ·",
  "Devis préparé par l'assistant.": "Presupuesto preparado por el asistente.",
  "Devis prêt en 90 secondes": "Presupuesto listo en 90 segundos",
  "Devis rapides & transparents": "Presupuestos rápidos y transparentes",
  "Devis refusé": "Presupuesto rechazado",
  "Devis refusés": "Presupuestos rechazados",
  "Devis sans réponse": "Presupuestos sin respuesta",
  "Devis signé sur place. Vous pouvez facturer.": "Presupuesto firmado en el acto. Ya puede facturar.",
  "Devis signé — prochaine étape": "Presupuesto firmado — siguiente paso",
  "Devis signé → facture en un clic": "Presupuesto firmado → factura en un clic",
  "Devis signé, facture payée, résumé du soir à 18h… même app fermée.": "Presupuesto firmado, factura pagada, resumen diario a las 18h… incluso con la aplicación cerrada.",
  "Devis signés": "Presupuestos firmados",
  "Devis à créer": "Presupuestos por crear",
  "Devis à préparer": "Presupuestos por preparar",
  "Devis à relancer": "Presupuestos pendientes de recordatorio",
  "Devis à signer": "Presupuestos por firmar",
  "Devise": "Moneda",
  "Devisto": "Devisto",
  "Devisto Building ID": "Devisto Building ID",
  "Devisto Property": "Devisto Property",
  "Devisto Score": "Devisto Score",
  "Devisto Studio :": "Devisto Studio:",
  "Devisto Studio est à 25 € HTVA par mois, Peppol inclus, sans limite de factures. Essai gratuit de 30 jours.": "Devisto Studio cuesta 25 € sin IVA al mes, con Peppol incluido y sin límite de facturas. Prueba gratuita de 30 días.",
  "Devisto a été pensé pour répondre aux difficultés rencontrées quotidiennement dans le secteur : demandes mal orientées, manque de visibilité, échanges dispersés et suivi insuffisant.": "Devisto se ha concebido para responder a las dificultades cotidianas del sector: solicitudes mal dirigidas, falta de visibilidad, comunicaciones dispersas y seguimiento insuficiente.",
  "Devisto commence avec JMX Énergie et s'ouvre progressivement à des professionnels vérifiés dans toutes les techniques spéciales du bâtiment : chauffage, plomberie, ventilation, climatisation, pompes à chaleur et traitement de l'eau.": "Devisto comienza con JMX Énergie y se abre progresivamente a profesionales verificados de todas las instalaciones técnicas del edificio: calefacción, fontanería, ventilación, climatización, bombas de calor y tratamiento del agua.",
  "Devisto détecte l'absence du destinataire, vous prévient et bascule automatiquement sur l'envoi par email, sans rien perdre.": "Devisto detecta que el destinatario no está disponible, le avisa y pasa automáticamente al envío por correo electrónico, sin perder nada.",
  "Devisto identifie les professionnels adaptés": "Devisto identifica a los profesionales adecuados",
  "Devisto met en relation particuliers, professionnels, syndics et gestionnaires avec des spécialistes qualifiés des techniques du bâtiment, partout en Belgique.": "Devisto pone en contacto a particulares, profesionales, administradores de fincas y gestores con especialistas cualificados en instalaciones técnicas de edificios en toda Bélgica.",
  "Devisto réunit progressivement des professionnels dans toutes les techniques spéciales du bâtiment. Publiez votre demande : nous la transmettons au professionnel qualifié adapté.": "Devisto reúne progresivamente a profesionales de todas las instalaciones técnicas del edificio. Publique su solicitud: se la transmitiremos al profesional cualificado adecuado.",
  "Devisto vous accompagne à chaque étape de votre projet.": "Devisto le acompaña en cada etapa de su proyecto.",
  "Devisto vérifie votre document sous 24 h ouvrées. Vous pouvez déjà créer et envoyer vos factures par email ; l'envoi Peppol s'activera à la validation.": "Devisto revisa su documento en un plazo de 24 h laborables. Mientras tanto, puede crear y enviar sus facturas por correo electrónico; el envío por Peppol se activará tras la validación.",
  "Devisto établit vos factures. Transmettez-les à votre comptable ou à votre ERP en un clic.": "Devisto emite sus facturas. Envíelas a su gestoría o a su ERP en un clic.",
  "Devisto — la plateforme des techniques spéciales du bâtiment": "Devisto — la plataforma de instalaciones técnicas del edificio",
  "Diagnostic IA": "Diagnóstico con IA",
  "Diagnostic affiné avec vos réponses.": "Diagnóstico precisado con sus respuestas.",
  "Diagnostic impossible.": "Diagnóstico imposible.",
  "Diagnostic établi : causes, vérifications et réparation proposées.": "Diagnóstico establecido: causas, comprobaciones y reparación propuestas.",
  "Diamètre chauffage": "Diámetro de calefacción",
  "Diamètre gaz": "Diámetro de gas",
  "Diamètre tubage (mm)": "Diámetro del entubado (mm)",
  "Dicter": "Dictar",
  "Dicter mes constats": "Dictar mis observaciones",
  "Dicter un devis": "Dictar un presupuesto",
  "Dictez le chantier ou envoyez la photo de la plaque : l'assistant pose 2-3 questions, suggère la suite et prépare le devis avec vos prix.": "Dicte los detalles de la obra o envíe la foto de la placa: el asistente le hace 2-3 preguntas, le sugiere los siguientes pasos y prepara el presupuesto con sus precios.",
  "Dictez le chantier à l'assistant ou cliquez sur « Modifier » pour ajouter des prestations.": "Dicte los detalles de la obra al asistente o haga clic en «Modificar» para añadir prestaciones.",
  "Dictez le chantier, Devisto chiffre les lignes. Le client signe en ligne.": "Dicte los detalles de la obra, Devisto calcula el importe de las partidas. El cliente firma en línea.",
  "Dictez ou tapez ce que vous avez fait, en vrac, et laissez l'IA lire vos photos : elle remplit les travaux, le matériel, les mesures, le constat et les recommandations, puis vous suggère ce qu'il manque.": "Dicte o escriba lo que ha hecho, sin preocuparse por el orden, y deje que la IA analice sus fotos: rellenará los trabajos, el material, las mediciones, las observaciones y las recomendaciones y, después, le sugerirá qué falta.",
  "Dictez un chantier pour obtenir un devis, envoyez la photo d'une plaque signalétique, posez une question technique ou demandez un texte pour un client. Je garde le fil de chaque conversation.": "Dicte los detalles de una obra para obtener un presupuesto, envíe la foto de una placa de características, plantee una pregunta técnica o pida un texto para un cliente. Mantengo el hilo de cada conversación.",
  "Dictez, ne tapez plus": "Dicte, deje de escribir",
  "Dictée analysée par l'assistant.": "Dictado analizado por el asistente.",
  "Dictées analysées": "Dictados analizados",
  "Difficile": "Difícil",
  "Différentiels": "Interruptores diferenciales",
  "Dim": "Dom",
  "Dimensions disponibles": "Dimensiones disponibles",
  "Dimensions et surface au sol": "Dimensiones y superficie en planta",
  "Directement sur": "Directamente en",
  "Distance": "Distancia",
  "Distance depuis le tableau (m)": "Distancia desde el cuadro (m)",
  "Dites ce que vous voulez changer.": "Indique qué quiere cambiar.",
  "Dites ou écrivez ce que vous voulez changer": "Diga o escriba lo que quiere cambiar",
  "Dites-lui quoi changer": "Dígale qué cambiar",
  "Dites-nous ce que nous pouvons améliorer (lu uniquement par l'entreprise)": "Díganos qué podemos mejorar (solo lo leerá la empresa)",
  "Document": "Documento",
  "Document ajouté.": "Documento añadido.",
  "Document déposé.": "Documento subido.",
  "Document joint — remplacer": "Documento adjunto — sustituir",
  "Document lu par l'IA : vérifiez les montants.": "Documento leído por la IA: compruebe los importes.",
  "Document supprimé.": "Documento eliminado.",
  "Document émis avec": "Documento emitido con",
  "Documents": "Documentos",
  "Documents de l'équipement": "Documentos del equipo",
  "Dois-je ouvrir un compte Peppol moi-même ?": "¿Tengo que abrir una cuenta Peppol por mi cuenta?",
  "Domotique": "Domótica",
  "Domotique, alarme et caméras": "Domótica, alarmas y cámaras",
  "Donner l'accès": "Dar acceso",
  "Donner un accès": "Conceder acceso",
  "Donnez un nom au modèle": "Asigne un nombre a la plantilla",
  "Donnez un nom au modèle.": "Asigne un nombre a la plantilla.",
  "Données du virement copiées — collez-les dans votre app bancaire": "Datos de la transferencia copiados — péguelos en su aplicación bancaria",
  "Dossier": "Expediente",
  "Dossier enregistré sur l'appareil — il sera envoyé au retour du réseau.": "Expediente guardado en el dispositivo — se enviará cuando vuelva la conexión.",
  "Dossier introuvable": "Expediente no encontrado",
  "Dossier introuvable.": "No se ha encontrado el expediente.",
  "Dossier lié :": "Expediente vinculado:",
  "Dossier refusé, l'artisan est prévenu.": "Expediente rechazado, se ha avisado al profesional.",
  "Dossier soumis. La création de factures est débloquée.": "Expediente presentado. Ya puede crear facturas.",
  "Dossiers": "Expedientes",
  "Dossiers d'activation": "Expedientes de activación",
  "Dossiers de chantier illimités": "Expedientes de obra ilimitados",
  "Dossiers ouverts": "Expedientes abiertos",
  "Dossiers, devis, interventions, planning. Pas la facturation.": "Expedientes, presupuestos, intervenciones y agenda. Sin facturación.",
  "Du": "Del",
  "Du chantier": "De la obra",
  "Du dossier au devis signé": "Del expediente al presupuesto firmado",
  "Duplication impossible.": "No se puede duplicar.",
  "Dupliquer": "Duplicar",
  "Dupliquer ce devis": "Duplicar este presupuesto",
  "Dupliquer en nouveau brouillon": "Duplicar como nuevo borrador",
  "Dupliquer le devis": "Duplicar el presupuesto",
  "Durée": "Duración",
  "Durée (années)": "Duración (años)",
  "Durée (min)": "Duración (min)",
  "Durée estimée (minutes)": "Duración estimada (minutos)",
  "Dès qu'un équipement approche de sa date d'entretien, il apparaît ici — et votre client reçoit automatiquement un rappel 30 jours avant.": "En cuanto se acerca la fecha de mantenimiento de un equipo, aparece aquí — y su cliente recibe automáticamente un recordatorio 30 días antes.",
  "Dès que le rapport est signé, le client reçoit un e-mail pour noter l'intervention (1 à 5 étoiles). À partir de 4 étoiles, il est invité à laisser un avis Google via le lien ci-dessous ; en dessous, son commentaire vous est transmis en privé.": "En cuanto se firma el informe, el cliente recibe un correo electrónico para valorar la intervención (de 1 a 5 estrellas). Si otorga 4 estrellas o más, se le invita a dejar una reseña en Google mediante el enlace siguiente; si otorga menos, su comentario se le envía a usted en privado.",
  "Début": "Inicio",
  "Déc": "Dic",
  "Décembre": "Diciembre",
  "Décevant": "Decepcionante",
  "Déconnexion": "Cerrar sesión",
  "Découvrir Devisto": "Descubra Devisto",
  "Découvrir Devisto Property": "Descubrir Devisto Property",
  "Décrire mon projet": "Describir mi proyecto",
  "Décrivez l'entretien en une phrase : l'IA rédige le contrat, vous l'envoyez à signer.": "Describa el mantenimiento en una frase: la IA redacta el contrato y usted lo envía para su firma.",
  "Décrivez l'entretien, l'IA rédige le contrat": "Describa el mantenimiento, la IA redacta el contrato",
  "Décrivez l'intervention en quelques mots (15 caractères minimum) ou ajoutez des photos": "Describa la intervención en pocas palabras (15 caracteres como mínimo) o añada fotos",
  "Décrivez l'intervention en quelques mots ou ajoutez des photos.": "Describa la intervención en pocas palabras o añada fotos.",
  "Décrivez l'équipement et l'entretien souhaité.": "Describa el equipo y el mantenimiento deseado.",
  "Décrivez la panne (ou dictez-la, ou laissez l'IA lire vos photos) : l'assistant classe les causes probables, vous guide dans les vérifications, pose les bonnes questions et prépare la réparation chiffrée avec vos tarifs.": "Describa la avería (o díctela, o deje que la IA analice sus fotos): el asistente clasifica las causas probables, le guía en las comprobaciones, le hace las preguntas adecuadas y prepara un presupuesto de reparación con sus tarifas.",
  "Décrivez le chantier en une phrase complète": "Describa la obra en una frase completa",
  "Décrivez le chantier en une phrase complète.": "Describa la obra en una frase completa.",
  "Décrivez le chantier à voix haute : l'assistant transcrit, structure les informations et signale ce qui manque.": "Describa la obra en voz alta: el asistente transcribe, organiza la información e indica qué falta.",
  "Décrivez le chantier à voix haute, l'assistant chiffre le devis avec vos prix.": "Describa la obra en voz alta y el asistente calcula el presupuesto con sus precios.",
  "Décrivez les travaux en une phrase complète.": "Describa los trabajos en una frase completa.",
  "Décrivez les travaux en une phrase, à l'écrit ou à la voix : l'assistant propose les postes, quantités et prix depuis votre bibliothèque": "Describa los trabajos en una frase, por escrito o por voz: el asistente propone las partidas, cantidades y precios a partir de su biblioteca",
  "Décrivez vos travaux : quoi, où, surface, âge du logement, délai souhaité… *": "Describa los trabajos: qué hay que hacer, dónde, superficie, antigüedad de la vivienda, plazo deseado… *",
  "Décrivez vos travaux, ajoutez des photos : vous recevez un devis clair et rapide.": "Describa los trabajos y añada fotos: recibirá un presupuesto claro en poco tiempo.",
  "Décrivez votre chantier": "Describa su obra",
  "Décrivez votre chantier ci-dessus : l'IA prépare le premier devis en quelques secondes.": "Describa su obra arriba: la IA prepara el primer presupuesto en unos segundos.",
  "Décrivez votre projet": "Describa su proyecto",
  "Déjà payé": "Ya pagado",
  "Déjà transféré dans": "Ya transferido a",
  "Déjà un compte ?": "¿Ya tiene una cuenta?",
  "Déjà à jour.": "Ya está actualizado.",
  "Délai de paiement": "Plazo de pago",
  "Démarrer l'activation": "Iniciar la activación",
  "Démarrer l'intervention": "Iniciar la intervención",
  "Démarrer le trajet": "Iniciar el trayecto",
  "Démarrez votre trajet : le client verra votre position et votre heure d'arrivée estimée sur sa page de suivi.": "Inicie el trayecto: el cliente verá su ubicación y la hora estimada de llegada en su página de seguimiento.",
  "Démo Devisto Studio — le devis signé sur place": "Demostración de Devisto Studio — el presupuesto firmado en el acto",
  "Démolition": "Demolición",
  "Dépannage": "Reparación",
  "Dépannage, entretien, rapport signé": "Reparación, mantenimiento, informe firmado",
  "Dépannages & entretiens": "Reparaciones & mantenimientos",
  "Déposer le document": "Subir el documento",
  "Déposez le devis de votre fournisseur ou écrivez simplement le matériel avec les prix. Indiquez votre main-d'œuvre : l'assistant rédige les lignes et le texte de main-d'œuvre pour vous.": "Suba el presupuesto de su proveedor o indique simplemente el material y los precios. Añada la mano de obra: el asistente redacta las líneas y la descripción de la mano de obra por usted.",
  "Déposez votre extrait BCE ou une facture de frais.": "Suba su extracto del BCE o una factura de gastos.",
  "Dépôt impossible.": "No se puede subir el documento.",
  "Désactiver": "Desactivar",
  "Désamiantage": "Retirada de amianto",
  "Détails": "Detalles",
  "Détecteur": "Detector",
  "Développez votre activité avec Devisto.": "Haga crecer su negocio con Devisto.",
  "Développez votre clientèle dans votre région": "Amplíe su cartera de clientes en su región",
  "E-mail": "Correo electrónico",
  "E-mail (facultatif)": "Correo electrónico (opcional)",
  "E-mail de votre comptable": "Correo electrónico de su gestoría",
  "E-mail du client": "Correo electrónico del cliente",
  "E-mail du client (pour la signature)": "Correo electrónico del cliente (para la firma)",
  "E-mail du client (sinon repris du document)": "Correo electrónico del cliente (si no se indica, se tomará del documento)",
  "E-mail du client *": "Correo electrónico del cliente *",
  "E-mail du comptable invalide": "Correo electrónico de la gestoría no válido",
  "E-mail du signataire (facultatif)": "Correo electrónico del firmante (opcional)",
  "ESB12345678": "ESB12345678",
  "EUR HTVA / an": "EUR sin IVA / año",
  "EUR €": "EUR €",
  "Eau chaude": "Agua caliente",
  "Eau chaude sanitaire": "Agua caliente sanitaria",
  "Eau froide": "Agua fría",
  "Effacer": "Borrar",
  "Efficacité": "Eficiencia",
  "Email": "Correo electrónico",
  "Email (pour l'envoi et la signature)": "Correo electrónico (para el envío y la firma)",
  "Email *": "Correo electrónico *",
  "Email du client": "Correo electrónico del cliente",
  "Email du client (pour envoyer le rapport)": "Correo electrónico del cliente (para enviar el informe)",
  "Email invalide": "Correo electrónico no válido",
  "Emails": "Correos electrónicos",
  "Emplacement": "Ubicación",
  "Emplacement (cave, toiture, cuisine…)": "Ubicación (sótano, tejado, cocina…)",
  "Emplacement unité extérieure": "Ubicación de la unidad exterior",
  "En Belgique, la RC professionnelle couvre les dommages causés chez vos clients, et\n            l'assurance décennale est obligatoire (loi Peeters-Borsus) pour les travaux de gros œuvre sur habitations. Demandez une offre à votre\n            courtier ou comparez les assureurs belges (AXA, Ethias, AG, Baloise, Federale).": "En Bélgica, el seguro de responsabilidad civil profesional cubre los daños causados en las viviendas de sus clientes, y\n            el seguro decenal es obligatorio (ley Peeters-Borsus) para los trabajos de obra gruesa en viviendas. Solicite una oferta a su\n            corredor de seguros o compare las aseguradoras belgas (AXA, Ethias, AG, Baloise, Federale).",
  "En Belgique, la RC professionnelle couvre les dommages causés chez vos clients, et l'assurance décennale est obligatoire (loi Peeters-Borsus) pour les travaux de gros œuvre sur habitations. Demandez une offre à votre courtier ou comparez les assureurs belges (AXA, Ethias, AG, Baloise, Federale).": "En Bélgica, el seguro de responsabilidad civil profesional cubre los daños causados a sus clientes, y el seguro decenal es obligatorio (ley Peeters-Borsus) para las obras de estructura en viviendas. Solicite un presupuesto a su corredor o compare las aseguradoras belgas (AXA, Ethias, AG, Baloise, Federale).",
  "En attente": "Pendiente",
  "En attente d'activation — aucune clé": "Pendiente de activación — sin clave",
  "En attente de réponse": "Pendiente de respuesta",
  "En cours": "En curso",
  "En deux mots : que faut-il faire ?": "En pocas palabras: ¿qué hay que hacer?",
  "En essai": "En período de prueba",
  "En ligne": "En línea",
  "En préparation": "En preparación",
  "En retard": "Con retraso",
  "En route": "En camino",
  "En savoir plus": "Más información",
  "En signant, vous confirmez que les travaux décrits ci-dessus ont bien été réalisés.": "Al firmar, usted confirma que los trabajos descritos anteriormente se han realizado.",
  "En vigueur le": "En vigor el",
  "En-tête du document": "Encabezado del documento",
  "Encaisser": "Cobrar",
  "Encaissé": "Cobrado",
  "Encaissé ce mois": "Cobrado este mes",
  "Encastré": "Empotrado",
  "Enregistrement en cours… appuyez sur le carré pour terminer.": "Grabación en curso… pulse el cuadrado para finalizar.",
  "Enregistrement impossible": "No se puede grabar",
  "Enregistrement impossible.": "No se puede grabar.",
  "Enregistrement impossible. Réessayez.": "No se ha podido guardar. Inténtelo de nuevo.",
  "Enregistrement trop court.": "Grabación demasiado corta.",
  "Enregistrement trop long (24 Mo max)": "Grabación demasiado larga (máx. 24 MB)",
  "Enregistrement vide": "Grabación vacía",
  "Enregistrement…": "Grabando…",
  "Enregistrer": "Guardar",
  "Enregistrer comme modèle": "Guardar como plantilla",
  "Enregistrer dans l'historique": "Guardar en el historial",
  "Enregistrer et tester": "Guardar y probar",
  "Enregistrer l'article": "Guardar el artículo",
  "Enregistrer la question": "Guardar la pregunta",
  "Enregistrer le modèle": "Guardar la plantilla",
  "Enregistrer le passeport": "Guardar el pasaporte",
  "Enregistrer les CGV": "Guardar las condiciones generales de venta",
  "Enregistrer une nouvelle version": "Guardar una nueva versión",
  "Enter": "Intro",
  "Entrepreneur général (tous corps de métier)": "Contratista general (todos los oficios)",
  "Entreprise": "Empresa",
  "Entretien": "Mantenimiento",
  "Entretien chaudière": "Mantenimiento de la caldera",
  "Entretien en retard": "Mantenimiento atrasado",
  "Entretien enregistré — la prochaine échéance est recalculée": "Mantenimiento registrado — se ha recalculado la próxima fecha prevista",
  "Entretien tous les (mois)": "Mantenimiento cada (meses)",
  "Entretien à prévoir": "Mantenimiento pendiente de programar",
  "Entretiens des 7 prochains jours": "Mantenimientos de los próximos 7 días",
  "Entretiens à faire": "Mantenimientos pendientes",
  "Entretiens à programmer": "Mantenimientos por programar",
  "Environnement de test (sandbox)": "Entorno de pruebas (sandbox)",
  "Envoi": "Envío",
  "Envoi automatique activé : votre comptable recevra l'export chaque début de trimestre.": "Envío automático activado: su gestoría recibirá la exportación al inicio de cada trimestre.",
  "Envoi automatique chaque trimestre": "Envío automático cada trimestre",
  "Envoi de la photo impossible. Réessayez.": "No se ha podido enviar la foto. Inténtelo de nuevo.",
  "Envoi des rappels impossible.": "No se han podido enviar los recordatorios.",
  "Envoi en cours…": "Envío en curso…",
  "Envoi impossible, réessayez.": "No se ha podido enviar, inténtelo de nuevo.",
  "Envoi impossible.": "No se puede enviar.",
  "Envoi impossible. Réessayez.": "No se puede enviar. Inténtelo de nuevo.",
  "Envoi trimestriel actif": "Envío trimestral activo",
  "Envoi…": "Enviando…",
  "Envoyer": "Enviar",
  "Envoyer au client": "Enviar al cliente",
  "Envoyer et documents": "Envío y documentos",
  "Envoyer la facture": "Enviar la factura",
  "Envoyer la planification": "Enviar la planificación",
  "Envoyer la relance avec le lien de paiement": "Enviar el recordatorio con el enlace de pago",
  "Envoyer le lien de signature": "Enviar el enlace de firma",
  "Envoyer le message": "Enviar el mensaje",
  "Envoyer le rappel maintenant": "Enviar el recordatorio ahora",
  "Envoyer les rappels": "Enviar los recordatorios",
  "Envoyer ma demande": "Enviar mi solicitud",
  "Envoyer ma question": "Enviar mi pregunta",
  "Envoyer mon avis": "Enviar mi opinión",
  "Envoyer un message…": "Enviar un mensaje…",
  "Envoyer une photo": "Enviar una foto",
  "Envoyer via Peppol": "Enviar a través de Peppol",
  "Envoyer à": "Enviar a",
  "Envoyer à mon comptable": "Enviar a mi gestoría",
  "Envoyer à signer": "Enviar para firmar",
  "Envoyez d'abord le lien de signature au client": "Envíe primero el enlace de firma al cliente",
  "Envoyez via Peppol": "Envíe a través de Peppol",
  "Envoyé": "Enviado",
  "Envoyé au client": "Enviado al cliente",
  "Envoyé le": "Enviado el",
  "Envoyée": "Enviada",
  "Envoyées": "Enviadas",
  "Envoyés": "Enviados",
  "Envoyés depuis plus de 3 jours, sans réponse": "Enviados hace más de 3 días, sin respuesta",
  "Escaliers": "Escaleras",
  "Escape": "Escape",
  "Espace comptable": "Espacio para la gestoría",
  "Espace de suivi": "Espacio de seguimiento",
  "Espace entreprises": "Área de empresas",
  "Espace professionnels": "Área de profesionales",
  "Espace réservé aux artisans et professionnels": "Espacio reservado a artesanos y profesionales",
  "Espagne": "España",
  "Espèces": "Efectivo",
  "Essai": "Prueba",
  "Essai 30 j": "Prueba de 30 días",
  "Essai gratuit jusqu'au": "Prueba gratuita hasta el",
  "Essai gratuit —": "Prueba gratuita —",
  "Essai jusqu'au": "Prueba hasta el",
  "Essai terminé": "Prueba finalizada",
  "Essai —": "Prueba —",
  "Essayer gratuitement": "Probar gratis",
  "Estimation HTVA": "Estimación sin IVA",
  "Et ensuite ?": "¿Y después?",
  "Et ensuite ? Compléter le rapport": "¿Y después? Completar el informe",
  "Et ensuite ? Suggestions pour ce devis": "¿Y después? Sugerencias para este presupuesto",
  "Et mes clients particuliers ?": "¿Y mis clientes particulares?",
  "Ex. : Chauffage": "Ej.: Calefacción",
  "Ex. : Démonstration pour mon entreprise": "Ej.: Demostración para mi empresa",
  "Ex. : Local technique -1": "Ej.: Cuarto técnico -1",
  "Ex. : Mon Entreprise SRL – Rue Exemple 1, 1000 Bruxelles – TVA BE0123.456.789": "Ej.: Mi Empresa SRL – Calle Ejemplo 1, 1000 Bruselas – NIF-IVA BE0123.456.789",
  "Ex. : Prix d'une pompe à chaleur en Belgique en 2026": "Ej.: Precio de una bomba de calor en Bélgica en 2026",
  "Ex. : ajoute 3 mètres de tubage inox et deux heures de main-d'œuvre": "Ej.: añada 3 metros de tubo de acero inoxidable y dos horas de mano de obra",
  "Ex. : chaudière affiche F.28, trois tentatives d'allumage puis mise en sécurité, pression 1,4 bar, gaz OK ailleurs…": "Ej.: la caldera muestra F.28, tres intentos de encendido y después se bloquea por seguridad, presión de 1,4 bar, el gas funciona en otros puntos…",
  "Ex. : chiffre le remplacement de cette chaudière": "Ej.: calcule el coste de sustituir esta caldera",
  "Ex. : entretien annuel chaudière gaz condensation Vaillant 25 kW, maison de 1998, dépannage prioritaire sous 48 h": "Ej.: mantenimiento anual de una caldera de gas de condensación Vaillant de 25 kW, vivienda de 1998, reparación prioritaria en un plazo de 48 h",
  "Ex. : la porte fait 83 cm de large · mesurer le mur du fond": "Ej.: la puerta mide 83 cm de ancho · medir la pared del fondo",
  "Ex. : le délai d'intervention est-il garanti ? La TVA à 6 % s'applique-t-elle ?": "Ej.: ¿está garantizado el plazo de intervención? ¿Se aplica el IVA del 6 %?",
  "Ex. : le taux de TVA à 6 % est-il justifié pour ce chantier (logement > 10 ans) ?": "Ej.: ¿está justificado el tipo de IVA del 6 % para esta obra (vivienda > 10 años)?",
  "Ex. : remplacement d'une chaudière gaz 24 kW, démontage de l'ancienne, raccordement, mise en service et évacuation.": "Ej.: sustitución de una caldera de gas de 24 kW, desmontaje de la antigua, conexión, puesta en marcha y retirada.",
  "Ex. : remplacé le groupe de sécurité du boiler, purgé les 6 radiateurs, pression remise à 1,5 bar, le client doit surveiller la fuite au robinet de la cuisine…": "Ej.: sustituido el grupo de seguridad del calentador de agua, purgados los 6 radiadores, presión restablecida a 1,5 bar, el cliente debe vigilar la fuga en el grifo de la cocina…",
  "Ex. acompte de 30 % à la commande, solde à la réception…": "Ej. anticipo del 30 % al realizar el pedido, saldo restante a la recepción…",
  "Ex. mise à jour taux réduit, source BOFiP…": "Ej. actualización del tipo reducido, fuente BOFiP…",
  "Excellent": "Excelente",
  "Existante": "Existente",
  "Expiré": "Caducado",
  "Expliquez votre besoin en quelques minutes. Ajoutez des photos, précisez votre localisation et vos attentes.": "Explique qué necesita en unos minutos. Añada fotos e indique su ubicación y sus expectativas.",
  "Export": "Exportación",
  "Export / hors champ": "Exportación / no sujeto",
  "Export Billit / Yuki / Odoo / CSV": "Exportación Billit / Yuki / Odoo / CSV",
  "Export CSV": "Exportación CSV",
  "Export comptable": "Exportación para la gestoría",
  "Export comptable (ZIP)": "Exportación para la gestoría (ZIP)",
  "Export comptable CSV + UBL": "Exportación para la gestoría CSV + UBL",
  "Export impossible.": "No se puede exportar.",
  "Export prêt : transmettez le fichier ZIP à votre comptable.": "Exportación lista: envíe el archivo ZIP a su gestoría.",
  "Exports envoyés par l'entreprise": "Exportaciones enviadas por la empresa",
  "Extension": "Extensión",
  "Extrait BCE": "Extracto del BCE",
  "Extrait BCE ou facture de frais au nom de la société (PDF ou photo, 15 Mo max).": "Extracto del BCE o factura de gastos a nombre de la empresa (PDF o foto, 15 MB máx.).",
  "Facile": "Fácil",
  "Facturation": "Facturación",
  "Facturation et avis clients": "Facturación y opiniones de clientes",
  "Facturation impossible.": "No es posible facturar.",
  "Facturation non activée": "Facturación no activada",
  "Facturation électronique": "Facturación electrónica",
  "Facturation électronique Peppol": "Facturación electrónica Peppol",
  "Facturation électronique Peppol obligatoire en Belgique depuis le 1er janvier 2026 : ce que les artisans et indépendants du bâtiment doivent faire, et comment Devisto l'automatise pour 25 €/mois.": "Facturación electrónica Peppol obligatoria en Bélgica desde el 1 de enero de 2026: qué deben hacer los profesionales autónomos de la construcción y cómo Devisto lo automatiza por 25 €/mes.",
  "Facturation électronique structurée": "Facturación electrónica estructurada",
  "Facture": "Factura",
  "Facture Peppol obligatoire 2026 en Belgique — guide artisan | Devisto": "Factura Peppol obligatoria en 2026 en Bélgica — guía para profesionales de la construcción | Devisto",
  "Facture Peppol obligatoire :": "Factura Peppol obligatoria:",
  "Facture complète": "Factura completa",
  "Facture créée dans": "Factura creada en",
  "Facture créée.": "Factura creada.",
  "Facture d'achat": "Factura de compra",
  "Facture d'achat, garantie, notices et rapports d'entretien de cet équipement.": "Factura de compra, garantía, manuales e informes de mantenimiento de este equipo.",
  "Facture d'acompte": "Factura de anticipo",
  "Facture de frais au nom de la société": "Factura de gastos a nombre de la empresa",
  "Facture enregistrée.": "Factura guardada.",
  "Facture envoyée au client.": "Factura enviada al cliente.",
  "Facture finale": "Factura final",
  "Facture finale (acompte déduit)": "Factura final (anticipo descontado)",
  "Facture introuvable": "Factura no encontrada",
  "Facture introuvable.": "Factura no encontrada.",
  "Facture marquée payée.": "Factura marcada como pagada.",
  "Facture réglée": "Factura pagada",
  "Facture transmise via le réseau Peppol.": "Factura enviada a través de la red Peppol.",
  "Facturer ce devis": "Facturar este presupuesto",
  "Facturer cette intervention": "Facturar esta intervención",
  "Facturer quand même ? Vous pourrez compléter les prix sur la facture.": "¿Facturar de todos modos? Podrá completar los precios en la factura.",
  "Factures": "Facturas",
  "Factures affichées": "Facturas mostradas",
  "Factures d'achat": "Facturas de compra",
  "Factures d'achat et avoirs fournisseurs": "Facturas de compra y abonos de proveedores",
  "Factures d'achat et avoirs fournisseurs : par Peppol, par photo/PDF lu par l'IA, ou laissés à votre comptable.": "Facturas de compra y abonos de proveedores: por Peppol, mediante foto/PDF leído por la IA o en manos de su gestoría.",
  "Factures de vente": "Facturas de venta",
  "Factures de vente (PDF + UBL Peppol), notes de crédit, achats et export par période. Consultation uniquement.": "Facturas de venta (PDF + UBL Peppol), abonos, compras y exportación por período. Solo consulta.",
  "Factures de vente (PDF + UBL), achats et export comptable, en consultation uniquement.": "Facturas de venta (PDF + UBL), compras y exportación para la gestoría, solo para consulta.",
  "Factures en attente (": "Facturas pendientes (",
  "Factures en retard": "Facturas vencidas",
  "Factures reçues": "Facturas recibidas",
  "Factures à encaisser": "Facturas pendientes de cobro",
  "Factures émises": "Facturas emitidas",
  "Factures, acomptes et notes de crédit émis": "Facturas, anticipos y abonos emitidos",
  "Facturé": "Facturado",
  "Facturé TVAC": "Facturado IVA incl.",
  "Facturé par Devisto · TVA BE 0786.236.171": "Facturado por Devisto · IVA BE 0786.236.171",
  "Facturé, encaissé, à encaisser et TVA due — mois par mois.": "Facturado, cobrado, pendiente de cobro e IVA a pagar — mes a mes.",
  "Facultatif maintenant, requis pour activer Peppol.": "Opcional por ahora, obligatorio para activar Peppol.",
  "Faire signer sur place": "Solicitar la firma in situ",
  "Fais un devis pour le remplacement d'une chaudière gaz à condensation 24 kW": "Haga un presupuesto para sustituir una caldera de gas de condensación de 24 kW",
  "Fait / pas fait": "Hecho / no hecho",
  "Faites pointer le bouton « Demander un devis » de votre site vers cette page Devisto à votre nom. Les demandes (avec photos) apparaissent ci-dessous et vous êtes notifié.": "Haga que el botón « Solicitar un presupuesto » de su sitio web enlace con esta página de Devisto a su nombre. Las solicitudes (con fotos) aparecen a continuación y recibirá una notificación.",
  "Faites signer le client dans le cadre prévu": "Pida al cliente que firme en el recuadro previsto",
  "Faites signer le client dans le cadre prévu.": "Pida al cliente que firme en el recuadro previsto.",
  "Faites votre devis ou facture": "Elabore su presupuesto o factura",
  "Faux plafond": "Falso techo",
  "Façadier / crépi et enduits": "Fachadas / revocos y enlucidos",
  "Ferme": "Granja",
  "Fermer": "Cerrar",
  "Ferronnerie et soudure": "Cerrajería y soldadura",
  "Fiabilité": "Fiabilidad",
  "Fiche du bâtiment": "Ficha del edificio",
  "Fiche technique": "Ficha técnica",
  "Fiche technique complétée.": "Ficha técnica completada.",
  "Fiche technique métier": "Ficha técnica del oficio",
  "Fichiers": "Archivos",
  "Fichiers UBL (XML)": "Archivos UBL (XML)",
  "Finances": "Finanzas",
  "Finitions": "Acabados",
  "Flexible inox": "Tubo flexible de acero inoxidable",
  "Fonctionnalités": "Funcionalidades",
  "Format Peppol BIS": "Formato Peppol BIS",
  "Format Peppol BIS 3.0 généré automatiquement": "Formato Peppol BIS 3.0 generado automáticamente",
  "Format attendu : BE0123456789": "Formato esperado: BE0123456789",
  "Format audio non supporté": "Formato de audio no compatible",
  "Format non supporté : envoyez un PDF ou du texte": "Formato no compatible: envíe un PDF o texto",
  "Format prêt à publier sur Instagram Reels, TikTok, YouTube Shorts et Facebook. Voix off et sous-titres inclus — regardable sans le son.": "Formato listo para publicar en Instagram Reels, TikTok, YouTube Shorts y Facebook. Incluye voz en off y subtítulos — se puede ver sin sonido.",
  "Fournisseur": "Proveedor",
  "Fournisseur *": "Proveedor *",
  "Fournisseur, référence…": "Proveedor, referencia…",
  "Fournitures": "Suministros",
  "France": "Francia",
  "Français": "Francés",
  "Frigoriste": "Técnico frigorista",
  "Fréquence": "Frecuencia",
  "Fréquence d'entretien": "Frecuencia de mantenimiento",
  "Fév": "Feb",
  "Février": "Febrero",
  "Gagnez du temps grâce à une organisation simplifiée.": "Ahorre tiempo gracias a una organización simplificada.",
  "Garantie": "Garantía",
  "Garantie décennale": "Garantía decenal",
  "Garantie jusqu'au": "Garantía hasta el",
  "Gaz naturel": "Gas natural",
  "Gestion des bâtiments": "Gestión de edificios",
  "Gestion indisponible.": "Gestión no disponible.",
  "Gestionnaires immobiliers": "Administradores de fincas",
  "Goulotte": "Canaleta",
  "Grand": "Grande",
  "Grande": "Grande",
  "Gris industriel": "Gris industrial",
  "Gros œuvre": "Obra gruesa",
  "Guides & conseils de pros.": "Guías y consejos de profesionales.",
  "Génération de l'aperçu…": "Generación de la vista previa…",
  "Génération du QR code…": "Generación del código QR…",
  "Génération du devis": "Generación del presupuesto",
  "Génération du rapport impossible.": "No se ha podido generar el informe.",
  "Génération impossible.": "No se ha podido generar.",
  "Générer la checklist": "Generar la lista de comprobación",
  "Géothermie": "Geotermia",
  "Gérer / résilier": "Gestionar / dar de baja",
  "Gérez les interventions et le suivi technique de vos immeubles efficacement.": "Gestione las intervenciones y el seguimiento técnico de sus edificios de forma eficaz.",
  "HT": "sin IVA",
  "HTVA": "sin IVA",
  "HTVA +": "Sin IVA +",
  "HTVA :": "Sin IVA:",
  "HTVA ·": "Sin IVA ·",
  "HTVA · TVA": "Sin IVA · IVA",
  "HTVA)": "Sin IVA)",
  "HTVA, avoirs déduits": "Sin IVA, abonos deducidos",
  "HTVA/an ·": "Sin IVA/año ·",
  "HTVA/an. Relisez et ajustez.": "Sin IVA/año. Revise y ajuste.",
  "HTVA/an. Saisissez le nouveau tarif : le contrat de renouvellement reprend les mêmes prestations, prend effet le": "Sin IVA/año. Introduzca la nueva tarifa: el contrato de renovación incluye las mismas prestaciones y entra en vigor el",
  "Heures prévues": "Horas previstas",
  "Historique": "Historial",
  "Historique centralisé": "Historial centralizado",
  "Historique complet ·": "Historial completo ·",
  "Historique d'entretien": "Historial de mantenimiento",
  "Historique des interventions": "Historial de intervenciones",
  "Historique des modifications": "Historial de modificaciones",
  "Historique du bâtiment": "Historial del edificio",
  "Historique technique": "Historial técnico",
  "Historique technique centralisé de votre patrimoine": "Historial técnico centralizado de su patrimonio",
  "Hors brouillons": "Sin incluir borradores",
  "Hors ligne": "Sin conexión",
  "Hors service": "Fuera de servicio",
  "IBAN :": "IBAN:",
  "Identifiant Peppol": "Identificador Peppol",
  "Identifiants Odoo refusés. Vérifiez la base, le login et la clé API.": "Credenciales de Odoo rechazadas. Compruebe la base de datos, el nombre de usuario y la clave API.",
  "Identifiants fiscaux ·": "Datos fiscales ·",
  "Identification de l'installation": "Identificación de la instalación",
  "Ignorer": "Omitir",
  "Il reçoit un email, choisit son mot de passe et accède immédiatement aux dossiers de la société.": "Recibe un correo electrónico, elige su contraseña y accede inmediatamente a los expedientes de la empresa.",
  "Image de couverture (URL)": "Imagen de portada (URL)",
  "Immeuble Le Bosquet": "Edificio Le Bosquet",
  "Immeuble moderne géré avec Devisto": "Edificio moderno gestionado con Devisto",
  "Immeubles": "Edificios",
  "Immeubles, lots et équipements au même endroit": "Edificios, unidades y equipos en un mismo lugar",
  "Impayé": "Impagado",
  "Import impossible.": "No se puede importar.",
  "Importer": "Importar",
  "Importer les tarifs de dépannage et entretien": "Importar las tarifas de reparación y mantenimiento",
  "Importer les tarifs types chauffagiste": "Importar las tarifas estándar de técnico de calefacción",
  "Importer les tarifs types entrepreneur général": "Importar las tarifas estándar de contratista general",
  "Importer les tarifs types électricien": "Importar las tarifas estándar de electricista",
  "Importer une image": "Importar una imagen",
  "Impossible d'enregistrer, réessayez.": "No se ha podido guardar, inténtelo de nuevo.",
  "Impossible de créer le devis.": "No se puede crear el presupuesto.",
  "Impossible de générer l'aperçu pour le moment.": "No se puede generar la vista previa en este momento.",
  "Impossible de lancer la remise à neuf.": "No se puede iniciar la renovación.",
  "Imprimer": "Imprimir",
  "Imprimés sur vos devis et factures selon les mentions obligatoires de votre pays. Devise :": "Impresos en sus presupuestos y facturas según las menciones obligatorias de su país. Moneda:",
  "Inclus": "Incluido",
  "Inconnu": "Desconocido",
  "Indiquez au moins le nom du client": "Indique al menos el nombre del cliente",
  "Indiquez au moins un destinataire valide.": "Indique al menos un destinatario válido.",
  "Indiquez ce qui est mesuré": "Indique qué se está midiendo",
  "Indiquez l'e-mail du comptable dans Finances": "Indique el correo electrónico de la gestoría en Finanzas",
  "Indiquez l'e-mail du comptable pour activer l'envoi automatique": "Indique el correo electrónico de la gestoría para activar el envío automático",
  "Indiquez le matériel à acheter": "Indique el material que debe comprar",
  "Indiquez le nom du client qui signe": "Indique el nombre del cliente que firma",
  "Indiquez le nom du client qui signe.": "Indique el nombre del cliente que firma.",
  "Indiquez le nom du client.": "Indique el nombre del cliente.",
  "Indiquez un pourcentage entre 1 et 100.": "Indique un porcentaje entre 1 y 100.",
  "Indiquez votre nom et prénom.": "Indique su nombre y apellidos.",
  "Indiquez votre nom et votre question.": "Indique su nombre y su consulta.",
  "Indiquez votre nom pour signer": "Indique su nombre para firmar",
  "Indiquez votre nom pour signer.": "Indique su nombre para firmar.",
  "Indiquez votre numéro de TVA.": "Indique su NIF-IVA.",
  "Indépendants, SRL, SPRL : tous les artisans assujettis sont concernés, quel que soit le chiffre d'affaires.": "Autónomos, SRL, SPRL: la obligación afecta a todos los profesionales de la construcción sujetos al IVA, independientemente de su facturación.",
  "Information au client (ex. : merci de prévoir l'accès à la cave)": "Información para el cliente (p. ej.: le rogamos que facilite el acceso al sótano)",
  "Informations manquantes": "Información pendiente",
  "Innovation": "Innovación",
  "Inscription impossible.": "No es posible registrarse.",
  "Instagram": "Instagram",
  "Installation et entretien de pompe à chaleur air/eau pour réduire durablement votre facture énergétique.": "Instalación y mantenimiento de bombas de calor aire-agua para reducir de forma duradera su factura energética.",
  "Installation et rénovation sanitaire : salles de bain, douches, WC, robinetterie et équipements.": "Instalación y renovación de fontanería: baños, duchas, inodoros, grifería y equipos.",
  "Installation existante": "Instalación existente",
  "Installation pompe à chaleur": "Instalación de bomba de calor",
  "Installation à jour": "Instalación actualizada",
  "Installation, dépannage, mise en conformité, tableaux électriques, bornes de recharge et domotique.": "Instalación, reparación, adecuación a la normativa, cuadros eléctricos, puntos de recarga y domótica.",
  "Installation, entretien et dépannage par un professionnel chauffage qualifié : chaudière, radiateurs, chauffage central.": "Instalación, mantenimiento y reparación por un profesional de la calefacción cualificado: calderas, radiadores y calefacción central.",
  "Installer": "Instalar",
  "Installez Devisto sur votre téléphone": "Instale Devisto en su teléfono",
  "Installé le": "Instalado el",
  "Instantanée": "Instantánea",
  "Insérer le modèle belge": "Insertar el modelo belga",
  "Insérer le modèle de mon pays": "Insertar el modelo de mi país",
  "Interrupteurs à installer": "Interruptores por instalar",
  "Intervention": "Intervención",
  "Intervention en cours": "Intervención en curso",
  "Intervention enregistrée.": "Intervención guardada.",
  "Intervention introuvable": "Intervención no encontrada",
  "Intervention supprimée.": "Intervención eliminada.",
  "Intervention sur place": "Intervención in situ",
  "Intervention terminée": "Intervención finalizada",
  "Intervention —": "Intervención —",
  "Interventions": "Intervenciones",
  "Intitulé du chantier (optionnel)": "Nombre de la obra (opcional)",
  "Intitulé du contrat": "Nombre del contrato",
  "Intracommunautaire (autoliquidation)": "Intracomunitario (inversión del sujeto pasivo)",
  "Invitation en attente": "Invitación pendiente",
  "Invitation envoyée : votre comptable choisit son mot de passe et accède à son espace.": "Invitación enviada: su gestoría elige su contraseña y accede a su espacio.",
  "Invitation envoyée par email.": "Invitación enviada por correo electrónico.",
  "Invitation envoyée à votre comptable.": "Invitación enviada a su gestoría.",
  "Invitation expirée : demandez un nouveau lien à votre responsable": "Invitación caducada: solicite un nuevo enlace a su responsable",
  "Invitation impossible.": "No es posible enviar la invitación.",
  "Invitation introuvable ou déjà utilisée": "Invitación no encontrada o ya utilizada",
  "Invitation introuvable ou déjà utilisée.": "Invitación no encontrada o ya utilizada.",
  "Inviter": "Invitar",
  "Invitez vos ouvriers et votre comptable : chacun a son accès, limité à son rôle. Inclus dans l'abonnement.": "Invite a sus operarios y a su gestoría: cada uno tendrá un acceso limitado a su función. Incluido en la suscripción.",
  "Isolation": "Aislamiento",
  "J'ai effectué le paiement": "He realizado el pago",
  "J'écoute… appuyez sur le carré pour terminer.": "Escuchando… pulse el cuadrado para terminar.",
  "JMX Énergie": "JMX Énergie",
  "JPG, PNG ou photo iPhone (HEIC) — compressées automatiquement avant l'envoi.": "JPG, PNG o fotos de iPhone (HEIC) — se comprimen automáticamente antes del envío.",
  "Jan": "Ene",
  "Janvier": "Enero",
  "Jardinier / paysagiste": "Jardinero / paisajista",
  "Je cherche un technicien": "Busco un técnico",
  "Je confirme ce traitement TVA": "Confirmo este tratamiento del IVA",
  "Je connais une dimension réelle": "Conozco una dimensión real",
  "Je suis arrivé": "He llegado",
  "Je suis un particulier": "Soy un particular",
  "Je suis un professionnel": "Soy un profesional",
  "Jeu": "Jue",
  "Jour du rendez-vous": "Día de la cita",
  "Journaux": "Diarios",
  "Juil": "Jul",
  "Juillet": "Julio",
  "Juin": "Junio",
  "Jusqu'à 3 rappels envoyés au client après l'échéance, au rythme et au ton que vous choisissez ; vous êtes prévenu à chaque envoi.": "Hasta 3 recordatorios enviados al cliente después del vencimiento, con la frecuencia y el tono que usted elija; se le avisará con cada envío.",
  "KBC, Belfius, ING, BNP Paribas Fortis, Argenta, Crelan… : ouvrez votre app, choisissez « Scanner / Payer par QR » — le virement est pré-rempli (bénéficiaire, montant, communication).": "KBC, Belfius, ING, BNP Paribas Fortis, Argenta, Crelan…: abra su aplicación y elija «Escanear / Pagar con QR» — la transferencia aparecerá cumplimentada (beneficiario, importe, concepto).",
  "Ko ·": "Ko ·",
  "L'acompte est déduit automatiquement de la facture finale.": "El anticipo se descuenta automáticamente de la factura final.",
  "L'appareil": "El aparato",
  "L'assistant a besoin d'une précision.": "El asistente necesita una aclaración.",
  "L'assistant a repéré des points à vérifier.": "El asistente ha detectado puntos que conviene comprobar.",
  "L'assistant applique vos prix, propose les postes manquants et signale ce qu'il reste à confirmer avec le\n        client. Rien n'est envoyé avant votre validation.": "El asistente aplica sus precios, propone las partidas que faltan e indica lo que queda por confirmar con el\n        cliente. No se envía nada antes de que usted lo valide.",
  "L'assistant applique vos prix, propose les postes manquants et signale ce qu'il reste à confirmer avec le client. Rien n'est envoyé avant votre validation.": "El asistente aplica sus precios, propone las partidas que faltan y señala lo que queda por confirmar con el cliente. No se envía nada antes de que usted lo valide.",
  "L'assistant n'a pas pu analyser la photo. Réessayez.": "El asistente no ha podido analizar la foto. Inténtelo de nuevo.",
  "L'assistant n'a pas pu appliquer cette demande.": "El asistente no ha podido aplicar esta solicitud.",
  "L'assistant n'a pas pu appliquer cette demande. Reformulez.": "El asistente no ha podido aplicar esta solicitud. Reformúlela.",
  "L'assistant n'a pas pu rédiger. Réessayez.": "El asistente no ha podido redactar el texto. Inténtelo de nuevo.",
  "L'assistant n'a pas pu répondre. Réessayez.": "El asistente no ha podido responder. Inténtelo de nuevo.",
  "L'assistant n'a pas trouvé assez d'informations. Ajoutez des notes ou une dictée.": "El asistente no ha encontrado suficiente información. Añada notas o un dictado.",
  "L'assistant réfléchit": "El asistente está analizando la información",
  "L'assistant travaille…": "El asistente está trabajando…",
  "L'e-mail": "El correo electrónico",
  "L'intervention est déjà créée : ouvrez-la pour cocher les travaux et faire signer le rapport.": "La intervención ya está creada: ábrala para marcar los trabajos y obtener la firma del informe.",
  "L'intervention reprend le dossier et les lignes du devis, puis génère le rapport à remettre au client.": "La intervención recupera el expediente y las líneas del presupuesto y, a continuación, genera el informe que se entregará al cliente.",
  "L'obligation ne concerne que les factures entre professionnels (B2B). Pour les particuliers, Devisto envoie toujours un PDF par email, et le client paie en ligne.": "La obligación solo afecta a las facturas entre profesionales (B2B). Para los particulares, Devisto sigue enviando un PDF por correo electrónico, y el cliente paga en línea.",
  "La date de fin précède la date de début": "La fecha de finalización es anterior a la fecha de inicio",
  "La facturation est réservée au responsable de la société": "La facturación está reservada al responsable de la empresa",
  "La facturation et le chiffre d'affaires sont accessibles uniquement au patron. Vous gardez l'accès aux\n              dossiers, aux devis et à vos interventions.": "Solo el propietario puede acceder a la facturación y al volumen de negocio. Usted conserva el acceso a los\n              expedientes, los presupuestos y sus intervenciones.",
  "La facturation et le chiffre d'affaires sont accessibles uniquement au patron. Vous gardez l'accès aux dossiers, aux devis et à vos interventions.": "Solo el responsable puede acceder a la facturación y al volumen de negocio. Usted conserva el acceso a los expedientes, los presupuestos y sus intervenciones.",
  "La facturation électronique structurée devient obligatoire entre assujettis TVA belges (B2B).": "La facturación electrónica estructurada pasa a ser obligatoria entre sujetos pasivos del IVA belgas (B2B).",
  "La facture reprend les travaux réalisés et le matériel utilisé, avec vos prix de la bibliothèque.": "La factura incluye los trabajos realizados y el material utilizado, con los precios de su biblioteca.",
  "La même histoire en 9:16, sur téléphone : dossier dicté, devis IA, PDF, signature sur place.": "La misma historia en 9:16, en el móvil: expediente dictado, presupuesto con IA, PDF y firma in situ.",
  "La note est vide": "La nota está vacía",
  "La plateforme des techniques spéciales du bâtiment": "La plataforma de instalaciones técnicas del edificio",
  "La plateforme qui": "La plataforma que",
  "La réponse part à votre marque (logo, coordonnées) avec un bouton vers le document. Relisez-la : l'IA ne connaît que les données du document.": "La respuesta se envía con su imagen de marca (logotipo, datos de contacto) y un botón que lleva al documento. Revísela: la IA solo conoce los datos del documento.",
  "La technologie au service d'un secteur essentiel.": "La tecnología al servicio de un sector esencial.",
  "Laisser l'IA chiffrer les lignes": "Dejar que la IA calcule los importes de las partidas",
  "Laisser un avis Google": "Dejar una reseña en Google",
  "Laissez vide pour créer un devis vierge.": "Déjelo en blanco para crear un presupuesto vacío.",
  "Lancer le diagnostic": "Iniciar el diagnóstico",
  "Langue de l'application et des documents": "Idioma de la aplicación y de los documentos",
  "Langue de l'article": "Idioma del artículo",
  "Le PDF n'a pas pu être affiché.": "No se ha podido mostrar el PDF.",
  "Le blog Devisto": "El blog Devisto",
  "Le bouton «": "El botón «",
  "Le bouton « Envoyer via Peppol » est actif sur chaque facture d'un client professionnel enregistré sur le réseau.": "El botón « Enviar por Peppol » está activo en cada factura de un cliente profesional registrado en la red.",
  "Le choix s'applique après « Enregistrer ».": "La opción se aplica después de pulsar « Guardar ».",
  "Le client a été informé de la fin de l'intervention.": "Se ha informado al cliente de que la intervención ha finalizado.",
  "Le client indique avoir payé (": "El cliente indica que ha pagado (",
  "Le client n'est plus sur place ? Envoyez-lui le rapport à signer.": "¿El cliente ya no está allí? Envíele el informe para que lo firme.",
  "Le client reçoit un email « Visite technique – Devis » avec le jour, l'heure d'arrivée, l'adresse et le motif.": "El cliente recibe un correo electrónico « Visita técnica – Presupuesto » con la fecha, la hora de llegada, la dirección y el motivo.",
  "Le client reçoit un rappel 7 puis 14 jours après l'envoi du devis tant qu'il n'a pas signé ou refusé.": "El cliente recibe un recordatorio a los 7 y a los 14 días del envío del presupuesto, siempre que no lo haya firmado ni rechazado.",
  "Le client signe sur votre téléphone à la fin de l'intervention, ou à distance via un lien sécurisé.": "El cliente firma en su teléfono al finalizar la intervención o a distancia mediante un enlace seguro.",
  "Le comptable ne voit jamais vos devis, vos chantiers ni vos marges : uniquement ventes, achats, règlements et exports.": "La gestoría nunca ve sus presupuestos, sus obras ni sus márgenes: solo ventas, compras, cobros y exportaciones.",
  "Le compte n'existe pas encore sur ce site : cliquez sur « Créer / remettre à neuf ».": "La cuenta aún no existe en este sitio: haga clic en «Crear / reacondicionar».",
  "Le coût d'achat et la durée servent à calculer votre marge et votre temps sur chaque devis. Vous pouvez les\n        modifier directement dans la liste : c'est enregistré dès que vous quittez le champ.": "El coste de compra y la duración sirven para calcular su margen y el tiempo dedicado a cada presupuesto. Puede\n        modificarlos directamente en la lista: se guardan en cuanto sale del campo.",
  "Le coût d'achat et la durée servent à calculer votre marge et votre temps sur chaque devis. Vous pouvez les modifier directement dans la liste : c'est enregistré dès que vous quittez le champ.": "El coste de compra y la duración sirven para calcular su margen y el tiempo previsto en cada presupuesto. Puede modificarlos directamente en la lista: los cambios se guardan en cuanto sale del campo.",
  "Le devis semble complet.": "El presupuesto parece estar completo.",
  "Le lien d'avis doit commencer par https://": "El enlace para las reseñas debe comenzar por https://",
  "Le minimum pour démarrer : le nom du client. Vous complétez le reste sur le chantier.": "Lo mínimo para empezar: el nombre del cliente. Puede completar el resto en la obra.",
  "Le mot de passe doit contenir au moins 6 caractères": "La contraseña debe contener al menos 6 caracteres",
  "Le même ton est utilisé par le bouton « Relancer » de la liste des factures. Le lien de paiement est toujours joint.": "El botón « Enviar recordatorio » de la lista de facturas utiliza el mismo tono. El enlace de pago siempre se adjunta.",
  "Le nom de la prestation est obligatoire": "El nombre del servicio es obligatorio",
  "Le nom du client est obligatoire": "El nombre del cliente es obligatorio",
  "Le paiement n'a pas abouti. Vous pouvez réessayer.": "El pago no se ha completado. Puede volver a intentarlo.",
  "Le passeport technique de chaque installation : chaudière, PAC, ventilation, PEB, numéros de série, garanties et historique d'entretien.": "El pasaporte técnico de cada instalación: caldera, bomba de calor, ventilación, PEB, números de serie, garantías e historial de mantenimiento.",
  "Le premier entretien enregistré déclenchera le rappel automatique à la date suivante.": "El primer mantenimiento registrado activará el recordatorio automático para la siguiente fecha.",
  "Le service email est indisponible, réessayez dans quelques minutes": "El servicio de correo electrónico no está disponible, inténtelo de nuevo dentro de unos minutos",
  "Le service email est indisponible, réessayez dans quelques minutes. Rien n'a été envoyé.": "El servicio de correo electrónico no está disponible, inténtelo de nuevo dentro de unos minutos. No se ha enviado nada.",
  "Le tableau de bord technique de vos immeubles.": "El panel técnico de sus inmuebles.",
  "Lecture IA en cours…": "Lectura con IA en curso…",
  "Lecture en cours…": "Lectura en curso…",
  "Lecture impossible.": "No se puede leer.",
  "Lecture impossible. Rapprochez-vous et évitez les reflets.": "No se puede realizar la lectura. Acérquese y evite los reflejos.",
  "Lecture impossible. Reprenez la photo de plus près.": "No se puede leer. Vuelva a hacer la foto desde más cerca.",
  "Lecture seule : factures de vente, achats, export comptable": "Solo lectura: facturas de venta, compras, exportación contable",
  "Les": "Los",
  "Les 90 prochains jours, et tout ce qui est déjà en retard": "Los próximos 90 días y todo lo que ya está atrasado",
  "Les bons professionnels pour vos projets.": "Los profesionales adecuados para sus proyectos.",
  "Les demandes de devis envoyées depuis votre site arrivent ici. Une touche : l'IA en fait un devis chiffré que vous ajustez.": "Las solicitudes de presupuesto enviadas desde su sitio web llegan aquí. Con un toque, la IA las convierte en un presupuesto con importes que usted puede ajustar.",
  "Les dossiers rattachés à ce bâtiment apparaîtront ici.": "Los expedientes vinculados a este edificio aparecerán aquí.",
  "Les factures adressées à votre n° de TVA sur le réseau Peppol apparaissent ici « à vérifier ».": "Las facturas dirigidas a su NIF-IVA a través de la red Peppol aparecen aquí «pendientes de revisión».",
  "Les factures d'achat Peppol arriveront ici.": "Las facturas de compra de Peppol llegarán aquí.",
  "Les factures d'achat encodées ou reçues par Peppol apparaissent ici.": "Las facturas de compra registradas o recibidas a través de Peppol aparecen aquí.",
  "Les gestes du quotidien": "Los gestos del día a día",
  "Les liens raccourcis sont bloqués par les messageries. Utilisez le lien long, ": "Los servicios de correo bloquean los enlaces acortados. Utilice el enlace completo, ",
  "Les lignes ajoutées ne sont pas encore enregistrées : cliquez sur « Enregistrer » en haut du devis.": "Las partidas añadidas aún no se han guardado: haga clic en « Guardar » en la parte superior del presupuesto.",
  "Les lignes, prix et conditions du modèle sont repris ; vous ajustez ensuite les quantités.": "Se copian las partidas, los precios y las condiciones de la plantilla; después, puede ajustar las cantidades.",
  "Les lignes, prix, conditions et remarques sont copiés dans un nouveau brouillon daté d'aujourd'hui. Choisissez où le créer.": "Las partidas, los precios, las condiciones y las observaciones se copian en un nuevo borrador con fecha de hoy. Elija dónde crearlo.",
  "Les montants incluent les travaux de base et la TVA.": "Los importes incluyen los trabajos básicos y el IVA.",
  "Les paiements enregistrés sur vos factures apparaîtront ici.": "Los cobros registrados en sus facturas aparecerán aquí.",
  "Les photos seront classées dans «": "Las fotos se clasificarán en «",
  "Les professionnels qualifiés de votre région, correspondant à votre projet, reçoivent votre demande.": "Los profesionales cualificados de su zona que se ajusten a su proyecto reciben su solicitud.",
  "Les questions posées sur vos devis et factures arrivent ici. Claude rédige la réponse à partir du document : relisez, ajustez, envoyez.": "Las preguntas sobre sus presupuestos y facturas llegan aquí. Claude redacta la respuesta a partir del documento: revísela, ajústela y envíela.",
  "Les rappels partent automatiquement au rythme et au ton choisis dans votre": "Los recordatorios se envían automáticamente con la frecuencia y el tono elegidos en su",
  "Libellé": "Concepto",
  "Libellé manquant": "Falta la descripción",
  "Lien client": "Enlace del cliente",
  "Lien copié": "Enlace copiado",
  "Lien copié.": "Enlace copiado.",
  "Lien de paiement introuvable.": "No se encuentra el enlace de pago.",
  "Lien de signature envoyé au client.": "Enlace de firma enviado al cliente.",
  "Lien du passeport copié": "Enlace del pasaporte copiado",
  "Lien « Laisser un avis Google »": "Enlace « Dejar una reseña en Google »",
  "Ligne": "Partida",
  "Ligne ajoutée — pensez à enregistrer le devis": "Partida añadida — recuerde guardar el presupuesto",
  "Ligne libre": "Partida libre",
  "Ligne « Assurance": "Línea « Seguro",
  "Lignes ajoutées au devis.": "Líneas añadidas al presupuesto.",
  "Lignes du devis": "Líneas del presupuesto",
  "Lignes probablement oubliées": "Líneas probablemente olvidadas",
  "Lire": "Leer",
  "Lire la photo de l'intervention (matériel, état, travaux visibles)": "Analizar la foto de la intervención (material, estado, trabajos visibles)",
  "Lire la plaque signalétique": "Leer la placa de características",
  "Lire les": "Leer los",
  "Liste copiée.": "Lista copiada.",
  "Liste de matériel copiée.": "Lista de material copiada.",
  "Liste magasin": "Lista para la tienda",
  "Liste magasin Devisto": "Lista para la tienda Devisto",
  "Liste matériel —": "Lista de material —",
  "Livrée": "Entregada",
  "Livrées": "Entregadas",
  "Logiciel belge ·": "Software belga ·",
  "Login Odoo": "Usuario de Odoo",
  "Logo": "Logotipo",
  "Logo enregistré.": "Logotipo guardado.",
  "Logo, couleurs, police et mise en page appliqués à vos devis, rapports de visite et rapports d'intervention.": "Logotipo, colores, tipografía y diseño aplicados a sus presupuestos, informes de visita e informes de intervención.",
  "Longueur de tubes à poser": "Longitud de los tubos por instalar",
  "Longueur des liaisons (m)": "Longitud de las conexiones (m)",
  "Longueur totale (m)": "Longitud total (m)",
  "Longueur tubage (m)": "Longitud del entubado (m)",
  "Longueur, largeur, hauteur": "Longitud, anchura, altura",
  "Lu et approuvé": "Leído y aprobado",
  "Lun": "Lun",
  "Luxembourg": "Luxemburgo",
  "MRR —": "MRR —",
  "Ma couleur": "Mi color",
  "Ma rentabilité": "Mi rentabilidad",
  "Magasin": "Almacén",
  "Mai": "Mayo",
  "Main-d'œuvre": "Mano de obra",
  "Main-d'œuvre (€ HTVA)": "Mano de obra (€ sin IVA)",
  "Maintenance en cours": "Mantenimiento en curso",
  "Mar": "Mar",
  "Marc Dupont": "Marc Dupont",
  "Marge": "Margen",
  "Marge ligne": "Margen de la línea",
  "Marge matériel (%)": "Margen del material (%)",
  "Marge minimum souhaitée (%)": "Margen mínimo deseado (%)",
  "Marge par heure": "Margen por hora",
  "Marge à": "Margen a",
  "Marque": "Marca",
  "Marquer comme acheté": "Marcar como comprado",
  "Marquer comme pris": "Marcar como recogido",
  "Marquer comme reçu": "Marcar como recibido",
  "Marquer payée": "Marcar como pagada",
  "Mars": "Marzo",
  "Masquer": "Ocultar",
  "Masquer les articles achetés": "Ocultar los artículos comprados",
  "Masquez les informations que votre logo affiche déjà.": "Oculte la información que ya aparece en su logotipo.",
  "Matériel": "Material",
  "Matériel (ex. : kit raccordement)": "Material (p. ej.: kit de conexión)",
  "Matériel :": "Material:",
  "Matériel ajouté au chantier.": "Material añadido a la obra.",
  "Matériel enregistré hors ligne.": "Material guardado sin conexión.",
  "Matériel introuvable": "Material no encontrado",
  "Matériel noté hors ligne.": "Material registrado sin conexión.",
  "Matériel retiré.": "Material retirado.",
  "Matériel utilisé": "Material utilizado",
  "Matériel à acheter": "Material por comprar",
  "Mazout": "Gasóleo",
  "Maçon / gros œuvre": "Albañil / obra gruesa",
  "Me mettre en règle gratuitement": "Regularizar mi situación gratis",
  "Mention autoliquidation": "Mención de inversión del sujeto pasivo",
  "Mention export / hors champ": "Mención de exportación / fuera del ámbito de aplicación",
  "Mention intracommunautaire": "Mención intracomunitaria",
  "Mention sur le document : «": "Mención en el documento: «",
  "Mentions obligatoires (une par ligne)": "Menciones obligatorias (una por línea)",
  "Menuiserie extérieure (châssis, portes)": "Carpintería exterior (marcos, puertas)",
  "Menuisier intérieur": "Carpintero de interiores",
  "Mer": "Mié",
  "Merci ! L'entreprise est prévenue de votre paiement.": "¡Gracias! Se ha informado a la empresa de su pago.",
  "Merci de régler sous 7 jours": "Le rogamos que pague en un plazo de 7 días",
  "Merci pour votre avis !": "Gracias por su opinión!",
  "Merci, cette facture est déjà payée.": "Gracias, esta factura ya está pagada.",
  "Mes 7 prochains jours": "Mis próximos 7 días",
  "Mes demandes": "Mis solicitudes",
  "Mes documents": "Mis documentos",
  "Mes factures": "Mis facturas",
  "Mes immeubles": "Mis inmuebles",
  "Mes interventions": "Mis intervenciones",
  "Mes modèles de contrat": "Mis plantillas de contrato",
  "Mes questions": "Mis preguntas",
  "Mes tarifs": "Mis tarifas",
  "Message": "Mensaje",
  "Message envoyé !": "Mensaje enviado!",
  "Mesure enregistrée hors ligne.": "Medición guardada sin conexión.",
  "Mesurer avec la caméra": "Medir con la cámara",
  "Mesures": "Medidas",
  "Mesures relevées": "Medidas tomadas",
  "Mesures sur photo par IA — à confirmer avec une dimension connue pour une précision pro": "Medidas en foto mediante IA — confírmelas con una dimensión conocida para obtener una precisión profesional",
  "Mets 6 % de TVA partout": "Aplique un 6 % de IVA a todo",
  "Mettre à jour le rapport": "Actualizar el informe",
  "Micro inaccessible. Autorisez l'accès au micro.": "Micrófono inaccesible. Autorice el acceso al micrófono.",
  "Micro inaccessible. Autorisez le microphone dans votre navigateur.": "Micrófono inaccesible. Autorice el micrófono en su navegador.",
  "Micro indisponible. Autorisez l'accès au micro.": "Micrófono no disponible. Autorice el acceso al micrófono.",
  "Mise en conformité": "Adecuación a la normativa",
  "Mise en page": "Diseño de página",
  "Mise en service": "Puesta en servicio",
  "Mise à jour impossible.": "No se puede actualizar.",
  "Mise à la terre": "Puesta a tierra",
  "Mixte": "Mixto",
  "Mode chantier hors ligne — notes, mesures, matériel et photos sont conservés sur l'appareil.": "Modo obra sin conexión — las notas, las medidas, el material y las fotos se guardan en el dispositivo.",
  "Mode clair": "Modo claro",
  "Mode hors ligne sur chantier": "Modo sin conexión en obra",
  "Mode sombre": "Modo oscuro",
  "Mode sombre pour travailler confortablement le soir. Réglage propre à cet appareil ; les pages vues par vos clients restent claires.": "Modo oscuro para trabajar cómodamente por la noche. Este ajuste solo afecta a este dispositivo; las páginas que ven sus clientes siguen en modo claro.",
  "Mode édition": "Modo de edición",
  "Moderne": "Moderno",
  "Moderne (sans empattement)": "Moderno (sin remates)",
  "Modification annulée.": "Modificación cancelada.",
  "Modifier": "Modificar",
  "Modifier (nouvelle version)": "Modificar (nueva versión)",
  "Modifier l'article": "Modificar el artículo",
  "Modifiez la recherche ou le filtre.": "Modifique la búsqueda o el filtro.",
  "Modèle": "Plantilla",
  "Modèle d'email enregistré.": "Plantilla de correo electrónico guardada.",
  "Modèle indisponible.": "Plantilla no disponible.",
  "Modèle inséré : adaptez-le puis enregistrez.": "Plantilla insertada: adáptela y después guárdela.",
  "Modèle introuvable": "Plantilla no encontrada",
  "Modèle réinitialisé.": "Plantilla restablecida.",
  "Modèle supprimé.": "Plantilla eliminada.",
  "Modèle «": "Plantilla «",
  "Modèles d'emails": "Plantillas de correo electrónico",
  "Mois": "Mes",
  "Mollie (en ligne) + virement": "Mollie (en línea) + transferencia",
  "Mollie + virement": "Mollie + transferencia",
  "Mollie activé (": "Mollie activado (",
  "Mollie désactivé.": "Mollie desactivado.",
  "Mon abonnement": "Mi suscripción",
  "Mon argent": "Mi dinero",
  "Mon assurance": "Mi seguro",
  "Mon comptable": "Mi gestoría",
  "Mon comptable peut-il récupérer mes factures ?": "¿Puede mi gestoría recuperar mis facturas?",
  "Mon compte": "Mi cuenta",
  "Mon entreprise": "Mi empresa",
  "Mon logiciel de facturation (Billit)": "Mi programa de facturación (Billit)",
  "Mon métier par défaut": "Mi oficio predeterminado",
  "Mon pipeline": "Mi embudo de ventas",
  "Mon planning": "Mi agenda",
  "Mon équipe": "Mi equipo",
  "Mono-split": "Monosplit",
  "Monophasé": "Monofásico",
  "Montant (solde": "Importe (saldo",
  "Montant (solde par défaut)": "Importe (saldo por defecto)",
  "Montant :": "Importe:",
  "Montant du règlement invalide": "Importe del cobro no válido",
  "Montant à payer": "Importe a pagar",
  "Montants": "Importes",
  "Montants masqués": "Importes ocultos",
  "Mot de passe": "Contraseña",
  "Mot de passe *": "Contraseña *",
  "Moteur IA": "Motor de IA",
  "Moteur IA inconnu": "Motor de IA desconocido",
  "Moteur d'intelligence artificielle": "Motor de inteligencia artificial",
  "Motif :": "Motivo:",
  "Motif du refus": "Motivo del rechazo",
  "Moyen": "Medio",
  "Multi-split": "Multisplit",
  "Multiservices / petits travaux": "Multiservicios / pequeños trabajos",
  "Mur, sol, plafond en m²": "Pared, suelo, techo en m²",
  "Méthodes :": "Métodos:",
  "Métier principal": "Oficio principal",
  "Métier principal *": "Actividad principal *",
  "Métiers couverts par Devisto": "Oficios cubiertos por Devisto",
  "Même dossier ·": "Mismo expediente ·",
  "Mêmes prestations, nouveau tarif": "Mismos servicios, nueva tarifa",
  "NIF / CIF": "NIF / CIF",
  "Navigation espace": "Navegación del espacio",
  "Nederlands": "Neerlandés",
  "Nettoyage et fin de chantier": "Limpieza y fin de obra",
  "Neutre": "Neutro",
  "Noir & or": "Negro & dorado",
  "Nom": "Nombre",
  "Nom (ex. : Heure de main-d'œuvre) *": "Nombre (p. ej.: Hora de mano de obra) *",
  "Nom (laissez vide = auto)": "Nombre (déjelo en blanco = automático)",
  "Nom *": "Nombre *",
  "Nom de l'assureur": "Nombre de la aseguradora",
  "Nom de l'entreprise": "Nombre de la empresa",
  "Nom de l'option (ex. : Confort, Premium, Pompe à chaleur)": "Nombre de la opción (p. ej.: Confort, Premium, Bomba de calor)",
  "Nom de la base": "Nombre de la base",
  "Nom du bâtiment (ex. Villa Dupont, Résidence Les Tilleuls)": "Nombre del edificio (p. ej., Villa Dupont, Residencia Les Tilleuls)",
  "Nom du client": "Nombre del cliente",
  "Nom du client (sinon repris du document)": "Nombre del cliente (si no, se toma del documento)",
  "Nom du client *": "Nombre del cliente *",
  "Nom du comptable / fiduciaire": "Nombre de la gestoría",
  "Nom du document (ex. : Contrat maintenance)": "Nombre del documento (p. ej.: Contrato de mantenimiento)",
  "Nom du modèle (ex. Remplacement chaudière gaz 25 kW)": "Nombre de la plantilla (p. ej., Sustitución de caldera de gas de 25 kW)",
  "Nom du modèle de contrat :": "Nombre de la plantilla de contrato:",
  "Nom, adresse, TVA, IBAN et coordonnées depuis votre profil.": "Nombre, dirección, IVA, IBAN y datos de contacto de su perfil.",
  "Nombre d'unités intérieures": "Número de unidades interiores",
  "Nombre de coudes": "Número de codos",
  "Nombre de disjoncteurs": "Número de interruptores automáticos",
  "Nombre de modules": "Número de módulos",
  "Non conforme": "No conforme",
  "Non inclus": "No incluido",
  "Non inclus (une par ligne)": "No incluido (uno por línea)",
  "Non-condensation": "Sin condensación",
  "Non. Devisto est connecté à un point d'accès Peppol certifié : vous envoyez depuis l'application, nous nous occupons du reste.": "No. Devisto está conectado a un punto de acceso Peppol certificado: usted envía desde la aplicación y nosotros nos ocupamos del resto.",
  "Normale": "Normal",
  "Nos derniers guides pour réussir vos projets techniques.": "Nuestras últimas guías para llevar a buen término sus proyectos técnicos.",
  "Note": "Nota",
  "Note (historique)": "Nota (historial)",
  "Note ajoutée aux remarques du devis": "Nota añadida a las observaciones del presupuesto",
  "Note de crédit": "Abono",
  "Note de crédit liée :": "Abono vinculado:",
  "Note enregistrée hors ligne.": "Nota guardada sin conexión.",
  "Note moyenne des clients": "Valoración media de los clientes",
  "Note moyenne et meilleurs commentaires (≥ 4 étoiles) affichés sur la page de signature et dans le PDF du devis : la preuve sociale au moment de décider.": "Valoración media y mejores opiniones (≥ 4 estrellas) mostradas en la página de firma y en el PDF del presupuesto: la prueba social en el momento de decidir.",
  "Note pour vous (facultatif)": "Nota para usted (opcional)",
  "Note rapide": "Nota rápida",
  "Note rédigée pour le client": "Nota redactada para el cliente",
  "Notes": "Notas",
  "Notes de chantier": "Notas de obra",
  "Notes de crédit": "Abonos",
  "Notes de crédit émises à vos clients, reliées à la facture d'origine.": "Abonos emitidos a sus clientes, vinculados a la factura original.",
  "Notes techniques (facultatif)": "Notas técnicas (opcional)",
  "Notez sur place ce qu'il faut commander. Les matériels cités dans vos dictées s'ajoutent automatiquement.": "Anote en el lugar de la obra lo que hay que pedir. Los materiales mencionados en sus dictados se añaden automáticamente.",
  "Notification": "Notificación",
  "Notifications": "Notificaciones",
  "Notifications activées : vous serez prévenu même app fermée.": "Notificaciones activadas: recibirá avisos incluso con la aplicación cerrada.",
  "Notifications bloquées : autorisez-les dans les réglages du navigateur.": "Notificaciones bloqueadas: permítalas en la configuración del navegador.",
  "Notifications désactivées sur cet appareil.": "Notificaciones desactivadas en este dispositivo.",
  "Notre objectif est simple :": "Nuestro objetivo es sencillo:",
  "Notre plateforme est momentanément indisponible le temps d'une mise à jour technique. Merci de votre patience — nous revenons très vite.": "Nuestra plataforma no está disponible temporalmente debido a una actualización técnica. Gracias por su paciencia — volveremos muy pronto.",
  "Nous améliorons Devisto": "Estamos mejorando Devisto",
  "Nous appeler": "Llámenos",
  "Nous revenons vers vous au plus vite.": "Nos pondremos en contacto con usted lo antes posible.",
  "Nous sommes désolés que l'intervention n'ait pas été à la hauteur.": "Lamentamos que la intervención no haya estado a la altura.",
  "Nouveau": "Nuevo",
  "Nouveau bâtiment": "Nuevo edificio",
  "Nouveau client": "Nuevo cliente",
  "Nouveau client (saisie rapide)": "Nuevo cliente (introducción rápida)",
  "Nouveau client (à taper)": "Nuevo cliente (para escribir)",
  "Nouveau contrat": "Nuevo contrato",
  "Nouveau devis": "Nuevo presupuesto",
  "Nouveau dossier": "Nuevo expediente",
  "Nouveau dossier chantier": "Nuevo expediente de obra",
  "Nouveau sur Devisto": "Nuevo en Devisto",
  "Nouvel article": "Nuevo artículo",
  "Nouvelle": "Nueva",
  "Nouvelle construction": "Nueva construcción",
  "Nouvelle conversation": "Nueva conversación",
  "Nouvelle facture": "Nueva factura",
  "Nouvelle installation": "Nueva instalación",
  "Nouvelle intervention": "Nueva intervención",
  "Nouvelle photo": "Nueva foto",
  "Nouvelle prestation": "Nuevo servicio",
  "Nouvelle réponse": "Nueva respuesta",
  "Nouvelle version enregistrée pour": "Nueva versión guardada para",
  "Nov": "Nov",
  "Novembre": "Noviembre",
  "Numéro de TVA": "NIF-IVA",
  "Numéro de TVA / identifiant fiscal du client": "NIF-IVA / identificador fiscal del cliente",
  "Numéro de TVA inconnu dans la base officielle VIES.": "NIF-IVA no encontrado en la base de datos oficial VIES.",
  "Numéro de TVA trop court": "NIF-IVA demasiado corto",
  "Numéro de TVA vérifié à l'inscription": "NIF-IVA verificado durante el registro",
  "Numéro de contrat": "Número de contrato",
  "Numéro inconnu dans VIES.": "Número no encontrado en VIES.",
  "N° TVA / identifiant fiscal du client": "NIF-IVA / identificador fiscal del cliente",
  "N° TVA intracommunautaire (si applicable)": "NIF-IVA intracomunitario (si procede)",
  "N° de TVA": "NIF-IVA",
  "N° de TVA (BE 0123.456.789)": "NIF-IVA (BE 0123.456.789)",
  "N° de TVA (ex. BE0123456789)": "NIF-IVA (p. ej., BE0123456789)",
  "N° de facture": "N° de factura",
  "N° de facture (ex. FAC-2026-0001)": "N° de factura (ej. FAC-2026-0001)",
  "N° de série": "N° de serie",
  "N° du devis (ex. DEV-2026-0001)": "N° del presupuesto (ej. DEV-2026-0001)",
  "Objectif": "Objetivo",
  "Objectif atteint": "Objetivo alcanzado",
  "Objet": "Asunto",
  "Objet de l'email": "Asunto del correo electrónico",
  "Obligation légale depuis le 1er janvier 2026": "Obligación legal desde el 1 de enero de 2026",
  "Obligations déclaratives": "Obligaciones de declaración",
  "Observations": "Observaciones",
  "Observations et recommandations": "Observaciones y recomendaciones",
  "Oct": "Oct",
  "Octobre": "Octubre",
  "Odoo": "Odoo",
  "Odoo injoignable. Vérifiez l'URL de votre instance.": "No se puede conectar con Odoo. Compruebe la URL de su instancia.",
  "Option": "Opción",
  "Option (variante proposée au client)": "Opción (variante propuesta al cliente)",
  "Option retenue :": "Opción elegida:",
  "Option retenue par le client *": "Opción elegida por el cliente *",
  "Option retenue par le client :": "Opción elegida por el cliente:",
  "Ou par virement manuel": "O mediante transferencia manual",
  "Ou un autre dossier (chantier similaire)": "O bien otro expediente (obra similar)",
  "Ou écrivez la liste, une par ligne : Chaudière Vaillant ecoTEC 24 kW — 1 pièce — 1450 € Vase expansion 18 L — 1 — 65 € Tubage inox 60/100 — 6 m — 22 €/m": "O escriba la lista, un elemento por línea: Caldera Vaillant ecoTEC 24 kW — 1 unidad — 1450 € Vaso de expansión 18 L — 1 — 65 € Conducto de acero inoxidable 60/100 — 6 m — 22 €/m",
  "Oui : export CSV comptable en un clic, et format UBL standard accepté par les logiciels de comptabilité belges.": "Sí: exportación contable en CSV con un clic y formato UBL estándar aceptado por los programas de contabilidad belgas.",
  "Ouvrez un dossier chantier qui reprend automatiquement le client, l'adresse, les travaux réalisés, le matériel, les mesures et vos photos.": "Abra un expediente de obra que incluya automáticamente los datos del cliente, la dirección, los trabajos realizados, el material, las mediciones y sus fotos.",
  "Ouvrier": "Operario",
  "Ouvrir": "Abrir",
  "Ouvrir l'assistant": "Abrir el asistente",
  "Ouvrir l'intervention": "Abrir la intervención",
  "Ouvrir la facture": "Abrir la factura",
  "Ouvrir le chat": "Abrir el chat",
  "Ouvrir le devis": "Abrir el presupuesto",
  "Ouvrir « Mon comptable »": "Abrir «Mi gestoría»",
  "Où va l'argent ?": "¿Adónde va el dinero?",
  "P.U. HTVA": "P.U. sin IVA",
  "PDF ou photo de la facture (lecture IA du PDF)": "PDF o foto de la factura (lectura del PDF mediante IA)",
  "PDF trop lourd (12 Mo maximum)": "PDF demasiado grande (máximo 12 MB)",
  "PDF téléchargé.": "PDF descargado.",
  "PDF, Word, JPG, PNG ou photo iPhone (HEIC) — 25 Mo max, images compressées automatiquement.": "PDF, Word, JPG, PNG o foto de iPhone (HEIC) — 25 MB máx., imágenes comprimidas automáticamente.",
  "Page de suivi du client (avancement, documents, prochaine visite) :": "Página de seguimiento del cliente (avance, documentos, próxima visita):",
  "Page précédente": "Página anterior",
  "Page suivante": "Página siguiente",
  "Paiement comptant": "Pago al contado",
  "Paiement des factures clients": "Pago de las facturas de los clientes",
  "Paiement en ligne des factures (Mollie)": "Pago en línea de facturas (Mollie)",
  "Paiement en ligne indisponible pour le moment.": "Pago en línea no disponible por el momento.",
  "Paiement indisponible. Réessayez.": "Pago no disponible. Inténtelo de nuevo.",
  "Paiement instantané": "Pago instantáneo",
  "Paiement reçu — merci !": "Pago recibido — ¡gracias!",
  "Paiement signalé — merci, l'entreprise a été prévenue.": "Pago notificado — gracias, se ha avisado a la empresa.",
  "Paiement sur le compte": "Pago en la cuenta",
  "Paiement sécurisé par Stripe": "Pago seguro mediante Stripe",
  "Paiement sécurisé par virement SEPA vers le compte de l'entreprise · by Devisto": "Pago seguro mediante transferencia SEPA a la cuenta de la empresa · por Devisto",
  "Paiements encaissés (date, moyen, facture)": "Cobros recibidos (fecha, método, factura)",
  "Panneaux solaires / photovoltaïque": "Paneles solares / fotovoltaicos",
  "Pans, faîte, surface": "Faldones, cumbrera, superficie",
  "Par mois (HTVA)": "Por mes (sin IVA)",
  "Paramètres fiscaux internationaux": "Configuración fiscal internacional",
  "Parcours": "Recorrido",
  "Parcours, coudes, hauteur": "Recorrido, codos, altura",
  "Parler à Devisto": "Hablar con Devisto",
  "Parlez ou écrivez, il modifie les lignes du devis": "Hable o escriba, y modificará las líneas del presupuesto",
  "Parlez-en au responsable de la société": "Hable de ello con el responsable de la empresa",
  "Parquet et sols souples": "Parqué y suelos flexibles",
  "Partager la démo": "Compartir la demostración",
  "Partenaire de lancement": "Socio de lanzamiento",
  "Particulier": "Particular",
  "Particuliers": "Particulares",
  "Particuliers, professionnels, syndics et gestionnaires immobiliers réunis dans un même écosystème.": "Particulares, profesionales, administradores de fincas y gestores inmobiliarios reunidos en un mismo ecosistema.",
  "Partiel": "Parcial",
  "Partiellement payée": "Parcialmente pagada",
  "Partir d'un modèle": "Partir de una plantilla",
  "Partir d'un modèle…": "Partir de una plantilla…",
  "PartyID Billit": "PartyID Billit",
  "Pas d'IBAN": "No hay IBAN",
  "Pas de photo": "Sin foto",
  "Pas de rappel": "Sin recordatorio",
  "Pas encore assuré ?": "¿Aún no está asegurado?",
  "Pas encore d'historique": "Aún no hay historial",
  "Passeport mis à jour.": "Pasaporte actualizado.",
  "Passeport technique": "Pasaporte técnico",
  "Passeport technique et équipements": "Pasaporte técnico y equipos",
  "Passeport technique généré par Devisto": "Pasaporte técnico generado por Devisto",
  "Passez à la facture Peppol en 2 minutes": "Pase a la factura Peppol en 2 minutos",
  "Pavage et allées": "Pavimentación y caminos",
  "Payconiq": "Payconiq",
  "Payer": "Pagar",
  "Payer avec mon app bancaire": "Pagar con mi aplicación bancaria",
  "Pays": "País",
  "Pays (ISO-2)": "País (ISO-2)",
  "Pays de l'entreprise (devise & TVA)": "País de la empresa (moneda & IVA)",
  "Pays de votre entreprise *": "País de su empresa *",
  "Pays du client": "País del cliente",
  "Pays du client non précisé : pays de l'artisan supposé.": "País del cliente no indicado: se supone el país del artesano.",
  "Pays non disponible": "País no disponible",
  "Pays non disponible pour l'instant": "País no disponible por el momento",
  "Pays, devise, taux, mentions, abonnement et change. Chaque modification crée une version datée ; les documents déjà émis gardent leurs règles.": "País, moneda, tipos, menciones, suscripción y tipo de cambio. Cada modificación crea una versión fechada; los documentos ya emitidos conservan sus reglas.",
  "Payé": "Pagado",
  "Payée": "Pagada",
  "Payées": "Pagadas",
  "Peintre en bâtiment": "Pintor de edificios",
  "Peppol": "Peppol",
  "Peppol (UBL)": "Peppol (UBL)",
  "Peppol :": "Peppol:",
  "Peppol : réservé aux clients professionnels avec un numéro de TVA (ajoutez-le sur la fiche client).": "Peppol: reservado a clientes profesionales con NIF-IVA (añádalo a la ficha del cliente).",
  "Peppol BIS 3.0": "Peppol BIS 3.0",
  "Peppol sert uniquement à envoyer vos factures clients ; vous ajoutez ici ce que vous voulez suivre.": "Peppol solo sirve para enviar sus facturas a los clientes; aquí puede añadir lo que quiera controlar.",
  "Peppol ·": "Peppol ·",
  "Percements / traversées": "Perforaciones / pasos",
  "Personnalisation de mes documents": "Personalización de mis documentos",
  "Personnalisez simplement les emails envoyés à vos clients. Votre logo est ajouté automatiquement en en-tête.": "Personalice fácilmente los correos electrónicos enviados a sus clientes. Su logotipo se añade automáticamente en la cabecera.",
  "Personnalisé": "Personalizado",
  "Personne de contact": "Persona de contacto",
  "Petit": "Pequeño",
  "Photo": "Foto",
  "Photo ajoutée.": "Foto añadida.",
  "Photo analysée": "Foto analizada",
  "Photo de l'intervention": "Foto de la intervención",
  "Photo envoyée": "Foto enviada",
  "Photo illisible. Réessayez.": "La foto no se puede leer. Vuelva a intentarlo.",
  "Photo introuvable": "No se encuentra la foto",
  "Photo jointe. Complétez les montants.": "Foto adjunta. Complete los importes.",
  "Photo non enregistrée.": "Foto no guardada.",
  "Photographier la plaque": "Fotografiar la placa",
  "Photographier une plaque signalétique : j'identifie le modèle et je chiffre": "Fotografiar una placa de características: identifico el modelo y calculo el precio",
  "Photographiez la plaque : l'IA propose marque, modèle, puissance, année et n° de série. Vous validez avant d'enregistrer.": "Fotografíe la placa: la IA propone la marca, el modelo, la potencia, el año y el n° de serie. Usted valida los datos antes de guardarlos.",
  "Photos + dictée": "Fotos + dictado",
  "Photos ajoutées.": "Fotos añadidas.",
  "Photos de l'intervention": "Fotos de la intervención",
  "Photos de la situation actuelle (facultatif)": "Fotos de la situación actual (opcional)",
  "Photos du chantier": "Fotos de la obra",
  "Photos gardées sur l'appareil — envoi au retour du réseau.": "Fotos guardadas en el dispositivo — se enviarán cuando vuelva la conexión.",
  "Photovoltaïque": "Fotovoltaica",
  "Pied de page": "Pie de página",
  "Pied de page des documents (ex. : Chauffage Marc SPRL — IBAN BE00 0000 0000 0000 — merci de votre confiance)": "Pie de página de los documentos (p. ej.: Chauffage Marc SPRL — IBAN BE00 0000 0000 0000 — gracias por su confianza)",
  "Pilotage": "Gestión",
  "Pilotez votre parc immobilier et vos interventions en un clic.": "Gestione su parque inmobiliario y sus intervenciones con un solo clic.",
  "Piscines et spas": "Piscinas y spas",
  "Pièce": "Estancia",
  "Placez au moins": "Coloque al menos",
  "Plafonneur / enduits intérieurs": "Yesero / enlucidos interiores",
  "Plan d'entretien": "Plan de mantenimiento",
  "Planification envoyée à": "Planificación enviada a",
  "Planifier l'intervention": "Planificar la intervención",
  "Planifier la visite technique": "Planificar la visita técnica",
  "Planifiez d'abord la visite technique": "Programe primero la visita técnica",
  "Planifiez une visite technique depuis un dossier chantier, elle apparaîtra ici et le client recevra son rappel la veille.": "Planifique una visita técnica desde un expediente de obra. Aparecerá aquí y el cliente recibirá un recordatorio el día anterior.",
  "Planifiée": "Planificada",
  "Planning": "Agenda",
  "Plaque": "Placa",
  "Plaque illisible sur cette photo. Rapprochez-vous et évitez les reflets.": "La placa no se puede leer en esta foto. Acérquese y evite los reflejos.",
  "Plaque lue (fiabilité": "Placa leída (fiabilidad",
  "Plaque signalétique": "Placa de características",
  "Plaquiste / cloisons et faux plafonds": "Instalador de placas de yeso / tabiques y falsos techos",
  "Plein écran": "Pantalla completa",
  "Plomberie": "Fontanería",
  "Plombier / Sanitaire": "Fontanero / Sanitarios",
  "Plus": "Más",
  "Plus d'actions": "Más acciones",
  "Plus dense : idéal pour les longs devis.": "Más compacto: ideal para presupuestos largos.",
  "Plus tard": "Más tarde",
  "Point d'accès Peppol (Recommand)": "Punto de acceso Peppol (Recomendado)",
  "Points lumineux": "Puntos de luz",
  "Police": "Fuente",
  "Pompe de relevage nécessaire": "Bomba de elevación necesaria",
  "Pompe à chaleur": "Bomba de calor",
  "Pompe à chaleur / clim": "Bomba de calor / climatización",
  "Pompe à chaleur / climatisation": "Bomba de calor / climatización",
  "Portail": "Portal",
  "Pose / fourniture et pose": "Instalación / suministro e instalación",
  "Pose et maintenance de climatiseurs et systèmes réversibles pour votre confort en toute saison.": "Instalación y mantenimiento de equipos de aire acondicionado y sistemas reversibles para su comodidad durante todo el año.",
  "Poser ma question": "Hacer mi pregunta",
  "Poser une question sur cette facture": "Hacer una pregunta sobre esta factura",
  "Posez votre question…": "Escriba su pregunta…",
  "Position non partagée (activez la géolocalisation)": "Ubicación no compartida (active la geolocalización)",
  "Position partagée en direct": "Ubicación compartida en tiempo real",
  "Postes, quantités,": "Partidas, cantidades,",
  "Pour": "Para",
  "Pour affiner le diagnostic": "Para precisar el diagnóstico",
  "Pour le client :": "Para el cliente:",
  "Pour qui ?": "¿Para quién?",
  "Pour un client": "Para un cliente",
  "Pour une mesure fiable : photo prise bien de face, et un repère de taille connue dans le cadre (porte, feuille A4, mètre déplié, carte bancaire). L'IA détecte le repère et propose les mesures ; vous ajustez les points et confirmez une dimension réelle.": "Para obtener una medida fiable: tome la foto de frente e incluya en el encuadre una referencia de tamaño conocido (puerta, hoja A4, metro desplegado, tarjeta bancaria). La IA detecta la referencia y propone las medidas; usted ajusta los puntos y confirma una dimensión real.",
  "Premier partenaire Devisto dans le domaine du chauffage": "Primer socio de Devisto en el sector de la calefacción",
  "Prendre / choisir la photo": "Tomar / elegir la foto",
  "Prestation (ex. : entretien chaudière)": "Servicio (p. ej.: mantenimiento de caldera)",
  "Prestation ajoutée.": "Servicio añadido.",
  "Prestation introuvable": "No se encuentra el servicio",
  "Prestations": "Servicios",
  "Prestations et montants": "Servicios e importes",
  "Prestations incluses": "Servicios incluidos",
  "Prestations incluses (une par ligne)": "Servicios incluidos (uno por línea)",
  "Preuve de la société": "Justificante de la empresa",
  "Preuve déposée": "Justificante presentado",
  "Preuve introuvable.": "Prueba no encontrada.",
  "Prises à installer": "Enchufes que instalar",
  "Prises, interrupteurs, éclairage": "Enchufes, interruptores, iluminación",
  "Prix HTVA": "Precio sin IVA",
  "Prix HTVA / an": "Precio sin IVA / año",
  "Prix IA": "Precio de la IA",
  "Problème constaté": "Problema detectado",
  "Prochain entretien": "Próximo mantenimiento",
  "Prochain entretien :": "Próximo mantenimiento:",
  "Prochain entretien conseillé :": "Próximo mantenimiento recomendado:",
  "Prochaine visite": "Próxima visita",
  "Prochaine visite d'entretien :": "Próxima visita de mantenimiento:",
  "Prochaine échéance": "Próximo vencimiento",
  "Prochaine échéance le": "Próximo vencimiento el",
  "Production": "Producción",
  "Professionnel": "Profesional",
  "Professionnel (assujetti)": "Profesional (sujeto a IVA)",
  "Professionnel assigné": "Profesional asignado",
  "Professionnels": "Profesionales",
  "Professionnels partenaires": "Profesionales colaboradores",
  "Professionnels vérifiés": "Profesionales verificados",
  "Profil": "Perfil",
  "Profil enregistré — il apparaîtra sur vos devis.": "Perfil guardado — aparecerá en sus presupuestos.",
  "Profil indisponible.": "Perfil no disponible.",
  "Profil introuvable.": "Perfil no encontrado.",
  "Projets publiés": "Proyectos publicados",
  "Propane": "Propano",
  "Propose une option avec du matériel haut de gamme": "Proponga una opción con material de alta gama",
  "Propulsé par": "Desarrollado por",
  "Protection dédiée": "Protección específica",
  "Précisez de nouveaux éléments pour relancer le diagnostic…": "Indique nuevos datos para reanudar el diagnóstico…",
  "Précisez le type de client et son pays pour déterminer le traitement TVA.": "Indique el tipo de cliente y su país para determinar el tratamiento del IVA.",
  "Prénom / nom": "Nombre / apellidos",
  "Prénom et nom": "Nombre y apellidos",
  "Préparation de l'email…": "Preparación del correo electrónico…",
  "Préparation impossible. Réessayez.": "No se ha podido preparar. Inténtelo de nuevo.",
  "Préparer les lignes": "Preparar las líneas",
  "Préparer mon devis": "Preparar mi presupuesto",
  "Présentation du devis": "Presentación del presupuesto",
  "Présente et conforme": "Presente y conforme",
  "Présente à vérifier": "Presente, pendiente de verificar",
  "Prêt à simplifier vos interventions ?": "¿Está listo para simplificar sus intervenciones?",
  "Publier l'article (visible sur /blog)": "Publicar el artículo (visible en /blog)",
  "Publiez une mission de sous-traitance — chauffage, plomberie, sanitaire, ventilation, climatisation, pompe à chaleur ou électricité — et trouvez des professionnels qualifiés, avec les bonnes certifications, au bon endroit.": "Publique un trabajo de subcontratación — calefacción, fontanería, instalaciones sanitarias, ventilación, climatización, bomba de calor o electricidad — y encuentre profesionales cualificados, con las certificaciones adecuadas, en la zona que necesita.",
  "Publié": "Publicado",
  "Puis": "Después",
  "Puissance": "Potencia",
  "Puissance (kW)": "Potencia (kW)",
  "Puissance nécessaire": "Potencia necesaria",
  "PushManager": "PushManager",
  "Période": "Período",
  "Période invalide": "Periodo no válido",
  "Période invalide (AAAA-MM-JJ)": "Periodo no válido (AAAA-MM-JJ)",
  "Périodicité": "Periodicidad",
  "QR code de l'appareil": "Código QR del aparato",
  "QR code de paiement SEPA": "Código QR de pago SEPA",
  "QR code du passeport": "Código QR del pasaporte",
  "Qté": "Cant.",
  "Quantité": "Cantidad",
  "Que puis-je faire pour vous ?": "¿Qué puedo hacer por usted?",
  "Que se passe-t-il si le destinataire n'est pas sur Peppol ?": "¿Qué ocurre si el destinatario no está en Peppol?",
  "Que voulez-vous créer ?": "¿Qué desea crear?",
  "Quel est le prix de marché d'un entretien de chaudière mazout en Belgique ?": "¿Cuál es el precio de mercado del mantenimiento de una caldera de gasóleo en Bélgica?",
  "Quel que soit votre projet, Devisto transmet votre demande au professionnel qualifié adapté à votre besoin et à votre région, dans l'ensemble des métiers techniques de l'habitation.": "Sea cual sea su proyecto, Devisto transmite su solicitud al profesional cualificado que mejor se adapta a sus necesidades y a su zona, en todas las especialidades técnicas de la vivienda.",
  "Quelles factures sont encore impayées ?": "¿Qué facturas siguen pendientes de pago?",
  "Quelques secondes : l'IA relit votre bibliothèque de prix.": "Unos segundos: la IA revisa su biblioteca de precios.",
  "Question enregistrée.": "Pregunta registrada.",
  "Question envoyée : l'entreprise est notifiée pour": "Pregunta enviada: se ha notificado a la empresa para",
  "Question envoyée. L'entreprise vous répond par e-mail dans les meilleurs délais.": "Pregunta enviada. La empresa le responderá por correo electrónico lo antes posible.",
  "Question générale": "Pregunta general",
  "Question sur": "Pregunta sobre",
  "Questions": "Preguntas",
  "Questions clients": "Preguntas de los clientes",
  "Questions du client": "Preguntas del cliente",
  "Questions du comptable": "Preguntas de la gestoría",
  "Questions fréquentes": "Preguntas frecuentes",
  "Quoi ? (ex. : tubage)": "¿Qué? (p. ej.: entubado)",
  "RC exploitation": "RC de explotación",
  "RC professionnelle": "RC profesional",
  "Raccordements": "Conexiones",
  "Radiateurs": "Radiadores",
  "Ramonage et conduits de fumée": "Deshollinado y conductos de humos",
  "Rappel au client 3 puis 7 jours après l'envoi du lien de signature ; à la dernière relance, vous êtes prévenu pour l'appeler.": "Recordatorio al cliente 3 y, después, 7 días tras el envío del enlace de firma; con el último recordatorio, se le avisa para que llame al cliente.",
  "Rappel automatique la veille": "Recordatorio automático el día anterior",
  "Rappel envoyé au client.": "Recordatorio enviado al cliente.",
  "Rappels automatiques 30 jours avant chaque échéance.": "Recordatorios automáticos 30 días antes de cada vencimiento.",
  "Rappels de visite, envoi de devis et rapports : votre logo apparaît en tête de l'email.": "Recordatorios de visita, envío de presupuestos e informes: su logotipo aparece al principio del correo electrónico.",
  "Rapport": "Informe",
  "Rapport client": "Informe para el cliente",
  "Rapport d'intervention": "Informe de intervención",
  "Rapport de visite": "Informe de visita",
  "Rapport de visite envoyé au client.": "Informe de visita enviado al cliente.",
  "Rapport de visite pour le client": "Informe de visita para el cliente",
  "Rapport envoyé au client.": "Informe enviado al cliente.",
  "Rapport introuvable": "Informe no encontrado",
  "Rapport rédigé": "Informe redactado",
  "Rapport signé": "Informe firmado",
  "Rapport signé par le client.": "Informe firmado por el cliente.",
  "Rapport signé. L'entreprise est prévenue.": "Informe firmado. Se ha avisado a la empresa.",
  "Rapport technique sans montants : travaux réalisés, matériel, mesures, photos et signature.": "Informe técnico sin importes: trabajos realizados, material, mediciones, fotos y firma.",
  "Rapport établi avec Devisto ·": "Informe elaborado con Devisto ·",
  "Rassurez vos clients : les coordonnées de votre assurance apparaissent en bas de vos devis et factures.": "Dé tranquilidad a sus clientes: los datos de contacto de su aseguradora aparecen al pie de sus presupuestos y facturas.",
  "Rattachée au devis": "Vinculada al presupuesto",
  "Recevez des demandes correspondant à vos spécialités": "Reciba solicitudes relacionadas con sus especialidades",
  "Recevez des demandes qualifiées et développez votre activité simplement.": "Reciba solicitudes cualificadas y haga crecer su negocio fácilmente.",
  "Recevez des demandes qualifiées, développez votre clientèle et gagnez en visibilité auprès de particuliers qui recherchent des professionnels comme vous.": "Reciba solicitudes cualificadas, amplíe su cartera de clientes y gane visibilidad entre particulares que buscan profesionales como usted.",
  "Recevoir par Peppol dans Devisto": "Recibir a través de Peppol en Devisto",
  "Recevoir une copie": "Recibir una copia",
  "Recherche impossible.": "No se puede realizar la búsqueda.",
  "Rechercher : initiales, nom, société, ville, TVA…": "Buscar: iniciales, nombre, empresa, ciudad, NIF-IVA…",
  "Rechercher la société": "Buscar la empresa",
  "Rechercher un bâtiment, une adresse, un client…": "Buscar un edificio, una dirección, un cliente…",
  "Rechercher un client, un dossier…": "Buscar un cliente, un expediente…",
  "Rechercher un devis…": "Buscar un presupuesto…",
  "Rechercher un dossier…": "Buscar un expediente…",
  "Rechercher un règlement…": "Buscar un cobro…",
  "Rechercher une facture…": "Buscar una factura…",
  "Rechercher une intervention…": "Buscar una intervención…",
  "Rechercher…": "Buscar…",
  "Recherche…": "Búsqueda…",
  "Recommand :": "Recomienda:",
  "Recommandations": "Recomendaciones",
  "Recommandations pour le client (entretien, points à surveiller…)": "Recomendaciones para el cliente (mantenimiento, aspectos que debe vigilar…)",
  "Redevance annuelle": "Cuota anual",
  "Reformuler": "Reformular",
  "Refus :": "Rechazo:",
  "Refuser": "Rechazar",
  "Refusé": "Rechazado",
  "Refusé par le client : vous pouvez proposer un nouveau tarif ci-dessous.": "Rechazado por el cliente: puede proponer un nuevo precio a continuación.",
  "Refusée": "Rechazada",
  "Refusés": "Rechazados",
  "Regardez comment Devisto fait signer le devis chez le client, avant de partir (démo 6 min) :": "Vea cómo Devisto permite que el cliente firme el presupuesto antes de que usted se marche (demostración de 6 min):",
  "Rejoignez Devisto dès aujourd'hui.": "Únase a Devisto hoy mismo.",
  "Relance": "Recordatorio",
  "Relance automatique 3 puis 7 jours après l'envoi si le client n'a pas signé.": "Recordatorio automático a los 3 y, después, a los 7 días del envío si el cliente no ha firmado.",
  "Relance automatique du client 10 jours après l'envoi d'un renouvellement.": "Recordatorio automático al cliente 10 días después del envío de una renovación.",
  "Relance email automatique si Peppol échoue": "Recordatorio automático por correo electrónico si falla Peppol",
  "Relance envoyée à": "Recordatorio enviado a",
  "Relance envoyée.": "Recordatorio enviado.",
  "Relance impossible.": "No se puede enviar el recordatorio.",
  "Relancer": "Enviar un recordatorio",
  "Relancer automatiquement les devis sans réponse": "Enviar recordatorios automáticos de los presupuestos sin respuesta",
  "Relancer automatiquement les factures impayées": "Enviar recordatorios automáticos de las facturas impagadas",
  "Relancer le client": "Enviar un recordatorio al cliente",
  "Relancer le diagnostic": "Volver a ejecutar el diagnóstico",
  "Relancer les rapports d'intervention non signés": "Enviar recordatorios de los informes de intervención sin firmar",
  "Relancer maintenant": "Enviar un recordatorio ahora",
  "Relecture de l'assistant": "Revisión del asistente",
  "Relire avec l'IA": "Revisar con IA",
  "Remarques": "Observaciones",
  "Remarques pour le client": "Observaciones para el cliente",
  "Remettre le compte démo à neuf ? Toutes ses données seront recréées (environ 1 minute).": "¿Restablecer la cuenta de demostración? Se volverán a crear todos sus datos (aproximadamente 1 minuto).",
  "Remettre à neuf": "Restablecer",
  "Remise à neuf en cours…": "Restablecimiento en curso…",
  "Remise à neuf lancée.": "Restablecimiento iniciado.",
  "Remplacement": "Sustitución",
  "Remplacement chaudière gaz": "Sustitución de caldera de gas",
  "Remplacement complet": "Sustitución completa",
  "Remplacement d'une chaudière gaz Vaillant 24 kW chez Monsieur Dubois, avec démontage de l'ancienne chaudière, raccordement, mise en service et évacuation.": "Sustitución de una caldera de gas Vaillant de 24 kW en el domicilio del Sr. Dubois, con desmontaje de la caldera antigua, conexión, puesta en marcha y retirada.",
  "Remplacement de chaudière": "Sustitución de caldera",
  "Remplacement de tableau": "Sustitución de cuadro",
  "Remplacement partiel": "Sustitución parcial",
  "Remplacer le document": "Sustituir el documento",
  "Remplacer vos conditions actuelles par le modèle belge ?": "¿Sustituir sus condiciones actuales por el modelo belga?",
  "Remplacer vos conditions actuelles par le modèle de votre pays ?": "¿Sustituir sus condiciones actuales por el modelo de su país?",
  "Remplacé par son renouvellement": "Sustituido por su renovación",
  "Rendu identique au document reçu par le client": "Presentación idéntica a la del documento recibido por el cliente",
  "Renouvellement": "Renovación",
  "Renouvellement créé en brouillon.": "Renovación creada como borrador.",
  "Renouvellement créé et envoyé au client pour signature.": "Renovación creada y enviada al cliente para su firma.",
  "Renouvellement de votre contrat": "Renovación de su contrato",
  "Renouvellement du contrat": "Renovación del contrato",
  "Renouvellements en attente de signature": "Renovaciones pendientes de firma",
  "Renseignez l'URL, la base, le login et la clé API Odoo dans Mon entreprise": "Introduzca la URL, la base de datos, el nombre de usuario y la clave API de Odoo en Mi empresa",
  "Renseignez l'e-mail de votre comptable et activez l'envoi : l'export du trimestre (ventes, achats, règlements, UBL) partira seul, plus rien à préparer pour la TVA.": "Introduzca el correo electrónico de su gestoría y active el envío: la exportación trimestral (ventas, compras, cobros, UBL) se enviará automáticamente y ya no tendrá que preparar nada para el IVA.",
  "Renseignez votre clé API et votre PartyID Billit dans Mon entreprise": "Introduzca su clave API y su PartyID de Billit en Mi empresa",
  "Renseignez votre clé d'accès et votre administration Yuki dans Mon entreprise": "Introduzca su clave de acceso y su administración de Yuki en Mi empresa",
  "Rentabilité — visible par vous uniquement": "Rentabilidad — visible solo para usted",
  "Renvoyer": "Reenviar",
  "Report impossible.": "No se puede aplazar.",
  "Reporter dans le rapport": "Incluir en el informe",
  "Reporté dans le rapport": "Incluido en el informe",
  "Reprendre et valider →": "Retomar y validar →",
  "Reprendre →": "Retomar →",
  "Repris du devis. Décochez ce qui n'a pas été fait, ajoutez ce qui s'est ajouté sur place.": "Tomado del presupuesto. Desmarque lo que no se haya hecho y añada lo que se haya incorporado durante la visita.",
  "Repère détecté :": "Identificador detectado:",
  "Responsable": "Responsable",
  "Retirer": "Retirar",
  "Retirer de la liste": "Quitar de la lista",
  "Retirer l'accès": "Retirar el acceso",
  "Retirer la clé": "Retirar la clave",
  "Retirer la clé Recommand ? L'envoi Peppol repassera en attente d'activation.": "¿Retirar la clave Recommand? El envío por Peppol volverá a quedar pendiente de activación.",
  "Retirer la photo": "Quitar la foto",
  "Retour au bâtiment": "Volver al edificio",
  "Retour au devis": "Volver al presupuesto",
  "Retour au dossier": "Volver al expediente",
  "Retour au tableau de bord": "Volver al panel",
  "Retour prévu": "Regreso previsto",
  "Retour à l'accueil": "Volver al inicio",
  "Retour à l'immeuble": "Volver al edificio",
  "Retour à l'édition": "Volver a la edición",
  "Retour à la facture": "Volver a la factura",
  "Retour à la liste": "Volver a la lista",
  "Revenu mensuel HTVA": "Ingresos mensuales sin IVA",
  "Reçu": "Recibido",
  "Reçu le": "Recibido el",
  "Rien de planifié": "Nada programado",
  "Rien de prévu ce jour.": "No hay nada previsto para este día.",
  "Rien à acheter pour l'instant. Ajoutez du matériel ci-dessus ou depuis un dossier de chantier.": "No hay nada que comprar por ahora. Añada material arriba o desde un expediente de obra.",
  "Rigide inox": "Rígido de acero inoxidable",
  "Rue et numéro": "Calle y número",
  "Rue, code postal, ville": "Calle, código postal, localidad",
  "Rythme des relances": "Frecuencia de los recordatorios",
  "Règlement enregistré.": "Cobro registrado.",
  "Règlements": "Cobros",
  "Règles indisponibles.": "Reglas no disponibles.",
  "Réalisation": "Realización",
  "Réalisé par": "Realizado por",
  "Réception des factures fournisseurs": "Recepción de facturas de proveedores",
  "Réception des travaux": "Recepción de las obras",
  "Réception laissée au logiciel de votre comptable.": "Recepción gestionada por el software de su gestoría.",
  "Rédaction assistée Devisto AI": "Redacción asistida por Devisto AI",
  "Rédaction en cours…": "Redactando…",
  "Rédaction impossible.": "No se puede redactar.",
  "Rédaction…": "Redacción…",
  "Rédige un SMS pour prévenir un client d'un retard de 30 minutes": "Redacte un SMS para avisar a un cliente de un retraso de 30 minutos",
  "Rédiger avec l'IA": "Redactar con IA",
  "Rédiger depuis les photos": "Redactar a partir de las fotos",
  "Rédiger la réponse (IA)": "Redactar la respuesta (IA)",
  "Rédiger le brouillon": "Redactar el borrador",
  "Rédiger le rapport": "Redactar el informe",
  "Rédiger le rapport avec l'IA": "Redactar el informe con IA",
  "Rédiger les descriptions avec l'IA": "Redactar las descripciones con IA",
  "Rédigés par l'IA, signés en ligne, suivis automatiquement : rappel au client, intervention et facture à chaque échéance.": "Redactados por la IA, firmados en línea y gestionados automáticamente: recordatorio al cliente, intervención y factura en cada vencimiento.",
  "Référence": "Referencia",
  "Référence / note (facultatif)": "Referencia / nota (opcional)",
  "Réglages enregistrés.": "Ajustes guardados.",
  "Rénovation": "Reforma",
  "Rénovation complète": "Reforma integral",
  "Rénovation générale": "Reforma general",
  "Rénovation salle de bain": "Reforma de baño",
  "Réparation": "Reparación",
  "Réparation proposée": "Reparación propuesta",
  "Réparation reportée dans le rapport : travaux, matériel et constat mis à jour.": "Reparación incorporada al informe: trabajos, material y observaciones actualizados.",
  "Répondez à au moins une question.": "Responda al menos a una pregunta.",
  "Répondre": "Responder",
  "Répondre moi-même": "Responder personalmente",
  "Répondue": "Respondida",
  "Répondue le": "Respondida el",
  "Répondues": "Respondidas",
  "Réponse (": "Respuesta (",
  "Réponse IA illisible. Réessayez.": "La respuesta de la IA no se puede leer. Vuelva a intentarlo.",
  "Réponse IA inattendue. Réessayez.": "Respuesta inesperada de la IA. Vuelva a intentarlo.",
  "Réponse IA incomplète. Réessayez.": "Respuesta incompleta de la IA. Vuelva a intentarlo.",
  "Réponse envoyée au comptable par e-mail.": "Respuesta enviada a la gestoría por correo electrónico.",
  "Réponse envoyée à": "Respuesta enviada a",
  "Réponse envoyée.": "Respuesta enviada.",
  "Réponse rédigée par l'IA : relisez puis envoyez.": "Respuesta redactada por la IA: revísela y envíela.",
  "Réseau": "Red",
  "Réserve disponible": "Reserva disponible",
  "Réservé au responsable de la société": "Reservado al responsable de la empresa",
  "Résidence Les Tilleuls": "Residencia Les Tilleuls",
  "Résumé (SEO)": "Resumen (SEO)",
  "Résumé pour le client (ex. : chaudière de 2004 en fin de vie, tubage à remplacer…)": "Resumen para el cliente (p. ej.: caldera de 2004 al final de su vida útil, entubado por sustituir…)",
  "Rétablir le modèle par défaut": "Restablecer la plantilla predeterminada",
  "Rôle invalide": "Rol no válido",
  "Sam": "Sáb",
  "Sanctions progressives": "Sanciones progresivas",
  "Sanitaire": "Fontanería",
  "Sanitaire / eau chaude": "Fontanería / agua caliente",
  "Sans carte bancaire": "Sin tarjeta bancaria",
  "Sans engagement": "Sin compromiso",
  "Sans engagement, résiliable à tout moment": "Sin permanencia, cancelable en cualquier momento",
  "Sans préférence": "Sin preferencias",
  "Sans suite": "Sin seguimiento",
  "Sauf erreur de notre part…": "Salvo error por nuestra parte…",
  "Scannez avec votre app bancaire": "Escanee con su aplicación bancaria",
  "Se connecter": "Iniciar sesión",
  "Secret API Recommand": "Secreto de API Recommand",
  "Secret webhook (facultatif)": "Secreto del webhook (opcional)",
  "Section (mm²)": "Sección (mm²)",
  "Sep": "Sep",
  "Septembre": "Septiembre",
  "Serrurier / métallier": "Cerrajero / metalista",
  "Sert à calculer la marge et le temps de main-d'œuvre affichés sur vos devis avant l'envoi. Ces chiffres restent\n            privés : ils n'apparaissent ni sur le PDF client ni dans les emails.": "Sirve para calcular el margen y el tiempo de mano de obra que se muestran en sus presupuestos antes de enviarlos. Estas cifras son\n            privadas: no aparecen ni en el PDF del cliente ni en los correos electrónicos.",
  "Sert à calculer la marge et le temps de main-d'œuvre affichés sur vos devis avant l'envoi. Ces chiffres restent privés : ils n'apparaissent ni sur le PDF client ni dans les emails.": "Sirve para calcular el margen y el tiempo de mano de obra que se muestran en sus presupuestos antes de enviarlos. Estas cifras son privadas: no aparecen ni en el PDF del cliente ni en los correos electrónicos.",
  "Service VIES indisponible. Réessayez dans un instant.": "El servicio VIES no está disponible. Vuelva a intentarlo en un momento.",
  "Service worker indisponible.": "Service worker no disponible.",
  "Seul le responsable de la société gère l'abonnement.": "Solo el responsable de la empresa gestiona la suscripción.",
  "Seul le responsable de la société peut gérer les accès": "Solo la persona responsable de la empresa puede gestionar los accesos",
  "Seul un brouillon peut être supprimé. Créez une note de crédit.": "Solo se puede eliminar un borrador. Cree un abono.",
  "Seul un devis accepté peut être transféré en facture": "Solo se puede convertir en factura un presupuesto aceptado",
  "Seule une facture envoyée peut être relancée": "Solo se puede enviar un recordatorio de una factura enviada",
  "Signature": "Firma",
  "Signature de l'entreprise": "Firma de la empresa",
  "Signature du client": "Firma del cliente",
  "Signature du client, ici et maintenant": "Firma del cliente, aquí y ahora",
  "Signature enregistrée : elle apparaîtra sur vos devis, rapports et contrats.": "Firma guardada: aparecerá en sus presupuestos, informes y contratos.",
  "Signature horodatée avec l'adresse IP de l'appareil, conservée comme preuve (eIDAS). Le client reçoit une copie par e-mail s'il est renseigné.": "Firma con sello de tiempo y dirección IP del dispositivo, conservada como prueba (eIDAS). El cliente recibe una copia por correo electrónico si se ha indicado su dirección.",
  "Signature impossible.": "No se puede firmar.",
  "Signature invalide (image PNG trop lourde ou format inattendu)": "Firma no válida (imagen PNG demasiado grande o formato inesperado)",
  "Signature retirée.": "Firma eliminada.",
  "Signature électronique horodatée (eIDAS) : nom, date et adresse IP conservés comme preuve.": "Firma electrónica con sello de tiempo (eIDAS): nombre, fecha y dirección IP conservados como prueba.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont\n              conservés comme preuve, uniquement pour ce devis.": "Firma electrónica con sello de tiempo (Reglamento eIDAS). Su nombre, la fecha y su dirección IP se\n              conservan como prueba únicamente para este presupuesto.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont\n              conservés comme preuve, uniquement pour ce rapport.": "Firma electrónica con sello de tiempo (Reglamento eIDAS). Su nombre, la fecha y su dirección IP se\n              conservan como prueba únicamente para este informe.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont conservés comme preuve, uniquement pour ce devis.": "Firma electrónica con sello de tiempo (reglamento eIDAS). Su nombre, la fecha y su dirección IP se conservan como prueba únicamente para este presupuesto.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont conservés comme preuve, uniquement pour ce rapport.": "Firma electrónica con sello de tiempo (reglamento eIDAS). Su nombre, la fecha y su dirección IP se conservan como prueba únicamente para este informe.",
  "Signer au doigt": "Firmar con el dedo",
  "Signer le contrat": "Firmar el contrato",
  "Signer le rapport": "Firmar el informe",
  "Signez d'abord dans le cadre.": "Firme primero en el recuadro.",
  "Signez dans le cadre prévu": "Firme en el recuadro indicado",
  "Signez dans le cadre prévu.": "Firme en el recuadro indicado.",
  "Signé": "Firmado",
  "Signé ce mois": "Firmado este mes",
  "Signé cette année": "Firmado este año",
  "Signé par": "Firmado por",
  "Signé sur place": "Firmado en el lugar",
  "Signé sur place, sur votre appareil": "Firmado en persona, en su dispositivo",
  "Signé à distance via le lien sécurisé": "Firmado a distancia mediante el enlace seguro",
  "Signée": "Firmada",
  "Signées": "Firmadas",
  "Signés": "Firmados",
  "Simple et efficace": "Sencillo y eficaz",
  "Simple, rapide et sans engagement": "Sencillo, rápido y sin compromiso",
  "Slug (URL)": "Slug (URL)",
  "Société": "Empresa",
  "Société (facultatif)": "Empresa (opcional)",
  "Société activée sur Peppol.": "Empresa activada en Peppol.",
  "Société fictive « Thermo Confort SRL » (chauffagiste, Namur) avec clients, devis signés, factures, interventions, avis et contrats. À donner au vidéaste ou pour une démo commerciale. La remise à neuf efface et recrée toutes ses données.": "Empresa ficticia « Thermo Confort SRL » (instaladora de calefacción, Namur) con clientes, presupuestos firmados, facturas, intervenciones, reseñas y contratos. Para facilitarla al videógrafo o utilizarla en una demostración comercial. El restablecimiento borra y vuelve a crear todos sus datos.",
  "Société reconnue": "Empresa reconocida",
  "Société trouvée. Complétez le nom du contact.": "Empresa encontrada. Indique el nombre de la persona de contacto.",
  "Société vérifiée (Peppol en attente de la clé).": "Empresa verificada (Peppol a la espera de la clave).",
  "Sociétés inscrites (": "Empresas registradas (",
  "Solde dû": "Saldo pendiente",
  "Sombre": "Oscuro",
  "Soumettre mon dossier": "Enviar mi expediente",
  "Soumis le": "Presentado el",
  "Soumission impossible.": "No se puede enviar.",
  "Source : SPF Finances — loi du 6 février 2024 relative à la facturation électronique B2B. Informations indicatives, vérifiez auprès de votre comptable.": "Fuente: SPF Finances — ley del 6 de febrero de 2024 relativa a la facturación electrónica B2B. Información orientativa, consúltela con su gestoría.",
  "Sous garantie jusqu'au": "En garantía hasta el",
  "Sous l'objectif": "Por debajo del objetivo",
  "Statut": "Estado",
  "Statut Peppol actualisé.": "Estado de Peppol actualizado.",
  "Statut TVA": "Régimen de IVA",
  "Statut de votre société": "Estado de su empresa",
  "Statut fiscal": "Régimen fiscal",
  "Statut invalide": "Estado no válido",
  "Stores, volets et portes de garage": "Estores, persianas y puertas de garaje",
  "Studio": "Estudio",
  "Suggestions pour compléter ce devis": "Sugerencias para completar este presupuesto",
  "Suivant": "Siguiente",
  "Suivez chaque opportunité dans votre pipeline : contactée, devis envoyé, mission gagnée": "Siga cada oportunidad en su proceso comercial: contacto realizado, presupuesto enviado, trabajo conseguido",
  "Suivez l'avancement de vos interventions en direct.": "Siga el avance de sus intervenciones en directo.",
  "Suivi": "Seguimiento",
  "Suivi de chaque intervention, de la demande à la clôture": "Seguimiento de cada intervención, desde la solicitud hasta el cierre",
  "Suivi de livraison : reçue, en attente, échec": "Seguimiento de la entrega: recibida, pendiente, fallida",
  "Suivi en temps réel": "Seguimiento en tiempo real",
  "Suivi en temps réel pour le client": "Seguimiento en tiempo real para el cliente",
  "Suivi proposé avec": "Seguimiento propuesto con",
  "Sujet": "Asunto",
  "Sujeto pasivo IVA": "Sujeto pasivo IVA",
  "Suppression impossible": "No se puede eliminar",
  "Suppression impossible.": "No se puede eliminar.",
  "Supprimer": "Eliminar",
  "Supprimer ce brouillon": "Eliminar este borrador",
  "Supprimer ce bâtiment et tous ses équipements ?": "¿Eliminar este edificio y todos sus equipos?",
  "Supprimer ce devis": "Eliminar este presupuesto",
  "Supprimer ce modèle": "Eliminar esta plantilla",
  "Supprimer cet équipement": "Eliminar este equipo",
  "Supprimer cet équipement et son historique ?": "¿Eliminar este equipo y su historial?",
  "Supprimer cette question ?": "¿Eliminar esta pregunta?",
  "Supprimer définitivement ce document ?": "¿Eliminar definitivamente este documento?",
  "Supprimer l'intervention": "Eliminar la intervención",
  "Supprimer la photo": "Eliminar la foto",
  "Supprimer le brouillon": "Eliminar el borrador",
  "Supprimer le bâtiment": "Eliminar el edificio",
  "Supprimer le contrat": "Eliminar el contrato",
  "Supprimer le devis": "Eliminar el presupuesto",
  "Supprimer le modèle": "Eliminar la plantilla",
  "Supprimer le modèle «": "Eliminar la plantilla «",
  "Supprimer «": "Eliminar «",
  "Sur iPhone : Partager → « Sur l'écran d'accueil », puis ouvrez Devisto depuis l'icône.": "En iPhone: Compartir → «Añadir a pantalla de inicio» y, después, abra Devisto desde el icono.",
  "Sur les devis": "En los presupuestos",
  "Sur les factures": "En las facturas",
  "Sur place": "In situ",
  "Sur téléphone ? Enregistrer le QR puis l'importer dans l'app bancaire": "¿En el móvil? Guarde el QR y después impórtelo en la aplicación bancaria",
  "Surface": "Superficie",
  "Surface chauffée": "Superficie calefactada",
  "Synchroniser": "Sincronizar",
  "Syndics": "Administradores de fincas",
  "Sélectionner la garantie": "Seleccionar la garantía",
  "Sélectionnez au moins une information.": "Seleccione al menos un dato.",
  "TTC": "IVA incl.",
  "TVA": "IVA",
  "TVA & fiscalité du client": "IVA & fiscalidad del cliente",
  "TVA 21 %": "IVA 21 %",
  "TVA 6 %": "IVA 6 %",
  "TVA :": "IVA:",
  "TVA =": "IVA =",
  "TVA client (BE 0123.456.789)": "NIF-IVA del cliente (BE 0123.456.789)",
  "TVA collectée": "IVA repercutido",
  "TVA de votre pays": "IVA de su país",
  "TVA du pays du bien": "IVA del país donde se encuentra el bien",
  "TVA due": "IVA adeudado",
  "TVA facturée": "IVA facturado",
  "TVA facturée à déclarer — déduisez votre TVA sur achats avec votre comptable.": "IVA facturado que debe declarar — deduzca el IVA de sus compras con su gestoría.",
  "TVA fournisseur": "NIF-IVA del proveedor",
  "TVA par trimestre": "IVA por trimestre",
  "TVA par mois": "IVA por mes",
  "Prochaines échéances TVA (trimestrielles)": "Próximos plazos de IVA (trimestrales)",
  "Prochaines échéances TVA (mensuelles)": "Próximos plazos de IVA (mensuales)",
  "Période en cours": "Periodo en curso",
  "Période close": "Periodo cerrado",
  "Période à venir": "Periodo futuro",
  "export envoyé au comptable": "exportación enviada a la gestoría",
  "TVA estimée à ce jour": "IVA estimado a día de hoy",
  "TVA facturée": "IVA repercutido",
  "dépassée": "vencido",
  "aujourd'hui": "hoy",
  "· dépôt avant le": "· presentar antes del",

  "Envoi automatique chaque mois": "Envío automático cada mes",
  "Envoi mensuel actif": "Envío mensual activo",
  "Chaque 1er du mois, Devisto envoie à votre comptable le ZIP du mois écoulé (ventes, achats, règlements, UBL) avec un lien valable 90 jours. Vous pouvez aussi lui donner": "Cada día 1 del mes, Devisto envía a su gestoría el archivo ZIP del mes anterior (ventas, compras, cobros, UBL) mediante un enlace válido durante 90 días. También puede darle",
  "Envoi automatique activé : votre comptable recevra l'export chaque début de mois.": "Envío automático activado: su gestoría recibirá la exportación al inicio de cada mes.",
  "— dépôt": "— presentación",

  "TVAC": "IVA incl.",
  "TVAC / an": "IVA incl. / año",
  "TVAC ·": "IVA incl. ·",
  "Tableau de bord": "Panel",
  "Tableau de bord international": "Panel internacional",
  "Tableau électrique": "Cuadro eléctrico",
  "Taille du logo": "Tamaño del logotipo",
  "Taille du texte": "Tamaño del texto",
  "Tapez au moins 2 lettres. La recherche couvre vos clients, dossiers chantier, devis, interventions et\n              factures.": "Escriba al menos 2 letras. La búsqueda abarca sus clientes, expedientes de obra, presupuestos, intervenciones y\n              facturas.",
  "Tapez au moins 2 lettres. La recherche couvre vos clients, dossiers chantier, devis, interventions et factures.": "Escriba al menos 2 letras. La búsqueda incluye sus clientes, expedientes de obra, presupuestos, intervenciones y facturas.",
  "Tapissier / décoration murale": "Empapelador / decoración de paredes",
  "Tarif actuel": "Tarifa actual",
  "Taux de TVA": "Tipo de IVA",
  "Taux de change → EUR (statistiques consolidées)": "Tipo de cambio → EUR (estadísticas consolidadas)",
  "Taux normal": "Tipo general",
  "Technicien": "Técnico",
  "Technicien en route": "Técnico en camino",
  "Technique (chasse fixe)": "Técnica (descarga fija)",
  "Temps de main-d'œuvre": "Tiempo de mano de obra",
  "Temps de trajet estimé (minutes)": "Tiempo estimado de desplazamiento (minutos)",
  "Tendez votre téléphone au client : il relit le total et signe au doigt.": "Entregue su teléfono al cliente: revisará el total y firmará con el dedo.",
  "Tension": "Tensión",
  "Terminer": "Finalizar",
  "Terminer (": "Finalizar (",
  "Terminer ce contrat ? Les échéances automatiques s'arrêtent.": "¿Finalizar este contrato? Los vencimientos automáticos se detendrán.",
  "Terminer l'intervention": "Finalizar la intervención",
  "Terminer la dictée": "Finalizar el dictado",
  "Terminer le contrat": "Finalizar el contrato",
  "Terminé": "Finalizado",
  "Terminée": "Finalizada",
  "Terminés": "Finalizados",
  "Terrassement et égouttage": "Movimientos de tierras y alcantarillado",
  "Terrasses et aménagements extérieurs": "Terrazas y acondicionamientos exteriores",
  "Tester": "Probar",
  "Texte généré automatiquement": "Texto generado automáticamente",
  "Texte libre": "Texto libre",
  "Thème": "Tema",
  "Tipo reducido 10 % (rénovation de logements sous conditions)": "Tipo reducido 10 % (reformas de vivienda con requisitos)",
  "Titre": "Título",
  "Titre et encarts en teinte douce, modes de paiement et totaux côte à côte.": "Título y recuadros en tonos suaves, métodos de pago y totales uno al lado del otro.",
  "Titres et en-têtes de tableau dans votre couleur pleine, plus sobre.": "Títulos y encabezados de tabla en su color sólido, más sobrio.",
  "Toiture": "Cubierta",
  "Ton du message": "Tono del mensaje",
  "Total": "Total",
  "Total HTVA": "Total sin IVA",
  "Total HTVA :": "Total sin IVA:",
  "Total TVAC": "Total IVA incl.",
  "Total TVAC *": "Total IVA incl. *",
  "Total avec option": "Total con opción",
  "Total base TVAC": "Total base IVA incl.",
  "Total encaissé": "Total cobrado",
  "Touchez la photo pour placer les points (": "Toque la foto para colocar los puntos (",
  "Tous": "Todos",
  "Tous fournisseurs": "Todos los proveedores",
  "Tous les 12 mois": "Cada 12 meses",
  "Tous les 2 ans": "Cada 2 años",
  "Tous les 6 mois": "Cada 6 meses",
  "Tous les bâtiments": "Todos los edificios",
  "Tous les chantiers": "Todas las obras",
  "Tous les comptes de vos ouvriers inclus": "Todas las cuentas de sus operarios incluidas",
  "Tous les contrats": "Todos los contratos",
  "Tous les dossiers": "Todos los expedientes",
  "Tous les entretiens et réparations": "Todos los mantenimientos y reparaciones",
  "Tous les guides": "Todas las guías",
  "Tous les mois": "Todos los meses",
  "Tous les métiers du CVC": "Todos los oficios de calefacción, ventilación y climatización",
  "Tous les paiements encaissés sur vos factures, du plus récent au plus ancien.": "Todos los pagos recibidos de sus facturas, del más reciente al más antiguo.",
  "Tous risques chantier": "Seguro a todo riesgo de obra",
  "Tous vos devis, du brouillon à la signature.": "Todos sus presupuestos, del borrador a la firma.",
  "Tous vos documents et rapports accessibles en un seul endroit.": "Todos sus documentos e informes accesibles en un solo lugar.",
  "Tout Devisto Studio": "Todo Devisto Studio",
  "Tout Devisto, en quelques fonctionnalités clés.": "Todo Devisto, en unas pocas funciones clave.",
  "Tout ce qui concerne votre comptable au même endroit : envoi automatique chaque trimestre, accès à l'application en lecture seule, questions sur vos factures.": "Todo lo relativo a su gestoría en un mismo lugar: envío automático cada trimestre, acceso de solo lectura a la aplicación y consultas sobre sus facturas.",
  "Tout est en ordre : aucune action urgente aujourd'hui.": "Todo está en orden: no hay ninguna acción urgente hoy.",
  "Tout le matériel à emporter, tous vos chantiers en cours réunis. Cochez au comptoir, le dossier se met à jour.": "Todo el material que debe llevar para sus obras en curso, reunido en un solo lugar. Márquelo en el mostrador y el expediente se actualizará.",
  "Tout lu": "Todo leído",
  "Tout marquer comme lu": "Marcar todo como leído",
  "Toute la Belgique": "Toda Bélgica",
  "Toutes": "Todas",
  "Toutes les 2 semaines": "Cada 2 semanas",
  "Toutes les factures": "Todas las facturas",
  "Toutes les périodes": "Todos los periodos",
  "Toutes les questions": "Todas las preguntas",
  "Toutes les semaines": "Todas las semanas",
  "Toutes les tailles": "Todos los tamaños",
  "Toutes répondues": "Todas respondidas",
  "Traitement de l'eau": "Tratamiento del agua",
  "Traitement de l'humidité et des caves": "Tratamiento de humedades y sótanos",
  "Traitement du bois et de la charpente": "Tratamiento de la madera y de la estructura de madera",
  "Transcription en cours…": "Transcripción en curso…",
  "Transcription impossible.": "No se puede transcribir.",
  "Transcription impossible. Réessayez.": "No se ha podido transcribir. Vuelva a intentarlo.",
  "Transcription…": "Transcripción…",
  "Transfert impossible.": "No se puede transferir.",
  "Transformation / extension": "Reforma / ampliación",
  "Transformer en devis (IA)": "Convertir en presupuesto (IA)",
  "Transmettre à ma comptabilité": "Enviar a mi gestoría",
  "Transmises via Peppol": "Enviadas a través de Peppol",
  "Transparence": "Transparencia",
  "Travail réalisé": "Trabajo realizado",
  "Travaux :": "Trabajos:",
  "Travaux réalisés": "Trabajos realizados",
  "Trimestre": "Trimestre",
  "Triphasé": "Trifásico",
  "Triphasé 230V": "Trifásico 230V",
  "Triphasé 400V": "Trifásico 400V",
  "Trouver un chauffagiste, un plombier, un électricien ou un spécialiste HVAC": "Encontrar un instalador de calefacción, un fontanero, un electricista o un especialista en climatización",
  "Trouver un plombier pour vos installations sanitaires, réparations de fuites et rénovations de salle de bain.": "Encontrar un fontanero para sus instalaciones sanitarias, reparaciones de fugas y reformas de baños.",
  "Trouvez facilement un professionnel qualifié pour vos travaux et besoins techniques, partout en Belgique.": "Encuentre fácilmente un profesional cualificado para sus obras y necesidades técnicas en cualquier lugar de Bélgica.",
  "Trouvez le bon professionnel": "Encuentre al profesional adecuado",
  "Trouvez rapidement un professionnel de confiance et suivez votre intervention en toute transparence.": "Encuentre rápidamente un profesional de confianza y siga su intervención con total transparencia.",
  "Très bien": "Muy bien",
  "Tubage / cheminée": "Entubado / chimenea",
  "Tubage cheminée": "Entubado de chimenea",
  "Tube encastré": "Tubo empotrado",
  "Tuyauterie": "Tuberías",
  "Type": "Tipo",
  "Type d'installation": "Tipo de instalación",
  "Type d'équipement": "Tipo de equipo",
  "Type de bâtiment": "Tipo de edificio",
  "Type de client": "Tipo de cliente",
  "Type de conduit": "Tipo de conducto",
  "Type de câble": "Tipo de cable",
  "Type de facture invalide": "Tipo de factura no válido",
  "Type de garantie": "Tipo de garantía",
  "Type de pose": "Tipo de instalación",
  "Type de poste (détecté automatiquement, modifiable)": "Tipo de partida (detectado automáticamente, modificable)",
  "Type de production": "Tipo de producción",
  "Type de raccordement": "Tipo de conexión",
  "Téléchargement impossible.": "No se puede descargar.",
  "Téléchargement impossible. Réessayez.": "No se ha podido descargar. Vuelva a intentarlo.",
  "Télécharger": "Descargar",
  "Télécharger PDF": "Descargar PDF",
  "Télécharger la version verticale": "Descargar la versión vertical",
  "Télécharger le CSV": "Descargar el CSV",
  "Télécharger le PDF": "Descargar el PDF",
  "Télécharger le ZIP": "Descargar el ZIP",
  "Téléphone": "Teléfono",
  "Téléphone *": "Teléfono *",
  "Téléversement impossible.": "No se ha podido subir el archivo.",
  "UBL Peppol": "UBL Peppol",
  "URL webhook à déclarer chez Recommand :": "URL del webhook que debe registrar en Recommand:",
  "Un PDF envoyé par email ne suffit plus : la facture doit transiter par le réseau Peppol au format UBL.": "Un PDF enviado por correo electrónico ya no es suficiente: la factura debe enviarse a través de la red Peppol en formato UBL.",
  "Un ZIP avec vos journaux en CSV (Excel, WinBooks, Exact, Yuki…) et les factures de vente en UBL.": "Un archivo ZIP con sus libros contables en CSV (Excel, WinBooks, Exact, Yuki…) y las facturas de venta en UBL.",
  "Un accès direct depuis votre écran d'accueil, même sur chantier.": "Acceso directo desde su pantalla de inicio, incluso en la obra.",
  "Un clic : la facture part au format officiel. Vous suivez la livraison (reçue, en attente, échec).": "Un clic: la factura se envía en el formato oficial. Puede consultar el estado de la entrega (recibida, pendiente, fallida).",
  "Un commentaire ? (facultatif)": "¿Algún comentario? (opcional)",
  "Un compte Devisto existe déjà avec cet email": "Ya existe una cuenta de Devisto con este correo electrónico",
  "Un compte existe déjà avec cet email": "Ya existe una cuenta con este correo electrónico",
  "Un devis en 5 minutes, pas en 3 heures ce soir": "Un presupuesto en 5 minutos, no en 3 horas esta noche",
  "Un devis signé ne peut pas être supprimé": "No se puede eliminar un presupuesto firmado",
  "Un document clair à laisser au client à la fin de la visite : constats, mesures, matériel prévu et photos. Aucun prix, aucun engagement.": "Un documento claro para entregar al cliente al terminar la visita: observaciones, mediciones, material previsto y fotos. Sin precios ni compromisos.",
  "Un dossier par chantier : capturez sur place, complétez pendant la journée.": "Un expediente por obra: capture la información allí mismo y complétela a lo largo del día.",
  "Un fichier Peppol BIS 3 par facture de vente, importable directement dans le logiciel du comptable": "Un archivo Peppol BIS 3 por cada factura de venta, que puede importarse directamente en el software de la gestoría",
  "Un grand merci ! Pourriez-vous partager votre expérience publiquement ?": "¡Muchas gracias! ¿Podría compartir públicamente su experiencia?",
  "Un modèle portant le même nom sera remplacé.": "Se sustituirá la plantilla que tenga el mismo nombre.",
  "Un mot sur l'intervention ? (facultatif)": "¿Algún comentario sobre la intervención? (opcional)",
  "Un professionnel HVAC pour vos systèmes de chauffage, ventilation et conditionnement d'air, en résidentiel comme en tertiaire.": "Un profesional de climatización para sus sistemas de calefacción, ventilación y aire acondicionado, tanto en edificios residenciales como terciarios.",
  "Un réseau de professionnels qualifiés et évalués.": "Una red de profesionales cualificados y valorados.",
  "Une erreur est survenue. Réessayez.": "Se ha producido un error. Vuelva a intentarlo.",
  "Une facture envoyée ne se supprime pas : créez une note de crédit depuis la facture concernée.": "Una factura enviada no se puede eliminar: cree un abono desde la factura correspondiente.",
  "Une facture payée ne peut plus être modifiée": "Una factura pagada ya no se puede modificar",
  "Une invitation est déjà en attente pour cet email": "Ya hay una invitación pendiente para este correo electrónico",
  "Une ligne par facture : numéro, date, client, n° de TVA, base HTVA, TVA 21 %, total TVAC et référence Stripe. Fichier prêt à envoyer à votre comptable (séparateur point-virgule, ouvrable dans Excel).": "Una línea por factura: número, fecha, cliente, NIF-IVA, base sin IVA, IVA 21 %, total IVA incl. y referencia de Stripe. Archivo listo para enviar a su gestoría (separador de punto y coma, compatible con Excel).",
  "Une minute suffit, cela nous aide énormément.": "Basta un minuto, nos ayuda muchísimo.",
  "Une note de crédit ne peut pas être créditée": "No se puede emitir un abono de otro abono",
  "Une nouvelle façon de gérer les interventions techniques": "Una nueva forma de gestionar las intervenciones técnicas",
  "Une phrase dictée ou écrite, et le devis est chiffré": "Una frase dictada o escrita y el presupuesto queda valorado",
  "Une question ? Parlons-en.": "¿Tiene alguna pregunta? Hablemos.",
  "Une question sur": "Una pregunta sobre",
  "Une question sur Devisto Studio, une démonstration pour votre équipe, un besoin particulier pour votre métier ? Écrivez-nous, nous répondons rapidement.": "¿Tiene alguna pregunta sobre Devisto Studio, desea una demostración para su equipo o tiene una necesidad específica de su oficio? Escríbanos, le responderemos rápidamente.",
  "Une remarque ? (facultatif)": "¿Alguna observación? (opcional)",
  "Une seule clé Devisto pour toutes les sociétés. Créez-la sur app.recommand.eu → Paramètres → API, puis collez-la ici : l'envoi réel s'active sans redéploiement.": "Una única clave Devisto para todas las empresas. Créela en app.recommand.eu → Configuración → API y péguela aquí: el envío real se activará sin necesidad de volver a desplegar la aplicación.",
  "Unité": "Unidad",
  "Urgence": "Urgencia",
  "Utilisé dans l'e-mail de rapport et sur la page d'avis après intervention.": "Se utiliza en el correo electrónico del informe y en la página de reseñas tras la intervención.",
  "Utilisé pour les devis dictés, rapports, réponses aux clients, contrats et modèles suggérés. Si le moteur choisi ne répond pas, Devisto bascule automatiquement sur l'autre.": "Se utiliza para los presupuestos dictados, informes, respuestas a clientes, contratos y plantillas sugeridas. Si el motor elegido no responde, Devisto cambia automáticamente al otro.",
  "VMC simple et double flux : une ventilation performante pour une qualité d'air intérieur optimale.": "VMC de flujo simple y doble: una ventilación eficaz para una calidad óptima del aire interior.",
  "Va-et-vient": "Conmutador",
  "Valable jusqu'au": "Válido hasta el",
  "Valeur": "Valor",
  "Valider": "Validar",
  "Valider la signature": "Validar la firma",
  "Validité des devis (jours)": "Validez de los presupuestos (días)",
  "Validé le": "Validado el",
  "Valorisez votre Devisto Score : réactivité, qualifications et avis clients": "Destaque su Devisto Score: rapidez de respuesta, cualificaciones y opiniones de clientes",
  "Variante ou nouvelle version pour ce chantier": "Variante o nueva versión para esta obra",
  "Variateur": "Regulador de intensidad",
  "Ven": "Vie",
  "Ventes": "Ventas",
  "Ventilation": "Ventilación",
  "Ventilation du local": "Ventilación del local",
  "Ventouse horizontale": "Salida de humos horizontal",
  "Ventouse verticale": "Salida de humos vertical",
  "Version liée (autre langue)": "Versión vinculada (otro idioma)",
  "Version verticale · Reels & TikTok": "Versión vertical · Reels & TikTok",
  "Vert atelier": "Verde taller",
  "Via le logiciel de mon comptable": "A través del software de mi gestoría",
  "Vide technique": "Hueco técnico",
  "Vidéophone": "Videoportero",
  "Ville": "Ciudad",
  "Ville du chantier": "Localidad de la obra",
  "Virement": "Transferencia",
  "Virement bancaire uniquement": "Solo transferencia bancaria",
  "Virement effectué ?": "¿Transferencia realizada?",
  "Visite envoyée au client ·": "Visita enviada al cliente ·",
  "Visite et conseil": "Visita y asesoramiento",
  "Visite à effectuer": "Visita pendiente de realizar",
  "Visites et interventions": "Visitas e intervenciones",
  "Visites techniques et interventions": "Visitas técnicas e intervenciones",
  "Visualiser": "Visualizar",
  "Visualiser le devis": "Visualizar el presupuesto",
  "Vitrier": "Cristalero",
  "Voici une photo.": "Aquí tiene una foto.",
  "Voir": "Ver",
  "Voir l'abonnement": "Ver la suscripción",
  "Voir la page": "Ver la página",
  "Voir la preuve": "Ver el justificante",
  "Voir la réponse envoyée": "Ver la respuesta enviada",
  "Vos clients paient par Bancontact, Payconiq ou virement depuis le bouton « Payer maintenant » de l'e-mail : leur app bancaire s'ouvre pré-remplie et la facture passe": "Sus clientes pagan por Bancontact, Payconiq o transferencia desde el botón « Pagar ahora » del correo electrónico: su aplicación bancaria se abre con los datos cumplimentados y la factura pasa",
  "Vos clients peuvent poser une question depuis la page de leur devis ou facture. Vous pouvez aussi coller un e-mail reçu.": "Sus clientes pueden hacer una pregunta desde la página de su presupuesto o factura. También puede pegar un correo electrónico recibido.",
  "Vos clients verront votre RC professionnelle en bas des devis et factures.": "Sus clientes verán los datos de su seguro de responsabilidad civil profesional al pie de los presupuestos y las facturas.",
  "Vos coûts sont déjà renseignés.": "Sus costes ya están indicados.",
  "Vos devis acceptés et signés, depuis le 1er janvier, par trimestre et par mois.": "Sus presupuestos aceptados y firmados, desde el 1 de enero, por trimestre y por mes.",
  "Vos documents sont à votre charte.": "Sus documentos siguen su identidad corporativa.",
  "Vos documents à votre image": "Sus documentos con su imagen corporativa",
  "Vos données et vos demandes sont conservées en sécurité.": "Sus datos y solicitudes se almacenan de forma segura.",
  "Vos données ne servent qu'à établir votre devis. Page sécurisée by Devisto.": "Sus datos solo se utilizan para elaborar su presupuesto. Página protegida por Devisto.",
  "Vos factures clients continuent de partir par Peppol depuis": "Sus facturas a clientes siguen enviándose por Peppol desde",
  "Vos nom et prénom *": "Su nombre y apellidos *",
  "Vos visites techniques et interventions du mois. Touchez un jour pour y ajouter une intervention.": "Sus visitas técnicas e intervenciones del mes. Toque un día para añadir una intervención.",
  "Votre abonnement est en cours.": "Su suscripción está activa.",
  "Votre avis Google aide d'autres clients à nous faire confiance.": "Su reseña en Google ayuda a otros clientes a confiar en nosotros.",
  "Votre bibliothèque de prestations : l'assistant l'utilise pour chiffrer vos devis avec VOS prix.": "Su biblioteca de servicios: el asistente la utiliza para calcular sus presupuestos con SUS precios.",
  "Votre carnet d'adresses : réutilisez un client en un tap lors de la création d'un dossier.": "Su agenda de contactos: seleccione un cliente con un toque al crear un expediente.",
  "Votre comptable n'a pas encore son envoi trimestriel automatique": "Su gestoría aún no tiene activado el envío trimestral automático",
  "Votre comptable reçoit un email, choisit son mot de passe et consulte vos factures, achats et exports quand il en a besoin : plus rien à lui envoyer.": "Su gestoría recibe un correo electrónico, elige su contraseña y consulta sus facturas, compras y exportaciones cuando lo necesita: ya no tendrá que enviarle nada.",
  "Votre comptable se connecte sur Devisto avec son propre mot de passe et ne voit que vos factures de vente (PDF + UBL), vos achats et l'export comptable. Ni devis, ni chantiers, aucune modification possible.": "Su gestoría accede a Devisto con su propia contraseña y solo puede ver sus facturas de venta (PDF + UBL), sus compras y la exportación contable. No puede ver presupuestos ni obras, ni realizar modificaciones.",
  "Votre dossier a été refusé :": "Su expediente ha sido rechazado:",
  "Votre e-mail (facultatif)": "Su correo electrónico (opcional)",
  "Votre e-mail pour la réponse": "Su correo electrónico para recibir la respuesta",
  "Votre essai est terminé": "Su período de prueba ha terminado",
  "Votre installateur": "Su instalador",
  "Votre message…": "Su mensaje…",
  "Votre nom": "Su nombre",
  "Votre nom *": "Su nombre *",
  "Votre nom et prénom *": "Su nombre y apellidos *",
  "Votre retour a bien été transmis à l'équipe.": "Sus comentarios se han enviado al equipo.",
  "Votre réponse": "Su respuesta",
  "Votre réponse (envoyée par e-mail au comptable)": "Su respuesta (enviada por correo electrónico a la gestoría)",
  "Votre société": "Su empresa",
  "Votre société est vérifiée. Le point d'accès Peppol de Devisto est en cours d'activation : vos factures partent par email ou en fichier UBL en attendant.": "Su empresa está verificada. El punto de acceso Peppol de Devisto está en proceso de activación: mientras tanto, sus facturas se envían por correo electrónico o como archivo UBL.",
  "Votre statut est « non assujetti / franchise » : pas de TVA à facturer, mention d'exonération obligatoire.": "Su situación es « no sujeto / franquicia »: no se factura IVA, mención de exención obligatoria.",
  "Vous cherchez un technicien pour vos chantiers ?": "¿Busca un técnico para sus obras?",
  "Vous intervenez d'abord, vous ouvrez le dossier ensuite si un devis est nécessaire.": "Realice primero la intervención y abra después el expediente si necesita un presupuesto.",
  "Vous pourrez le relire, télécharger le PDF, l'envoyer à signer et l'enregistrer comme modèle.": "Podrá revisarlo, descargar el PDF, enviarlo para su firma y guardarlo como modelo.",
  "Vous refusez ce contrat. Un mot pour l'entreprise ? (facultatif)": "Rechaza este contrato. ¿Quiere dejar un mensaje a la empresa? (opcional)",
  "Vous rédigez le pied de page vous-même.": "Usted redacta el pie de página.",
  "Vous êtes déjà le responsable de la société": "Usted ya es la persona responsable de la empresa",
  "Vu par le client": "Visto por el cliente",
  "Vue": "Vista",
  "Vérification du paiement…": "Verificando el pago…",
  "Vérification impossible.": "No se ha podido realizar la verificación.",
  "Vérifications sur place": "Comprobaciones in situ",
  "Vérifier": "Verificar",
  "Vérifier et activer": "Verificar y activar",
  "Vérifier et envoyer": "Comprobar y enviar",
  "Vérifiez d'abord votre numéro de TVA.": "Compruebe primero su NIF-IVA.",
  "Vérifiez le QR code ou contactez votre installateur.": "Compruebe el código QR o póngase en contacto con su instalador.",
  "Vérifiez votre TVA et déposez votre preuve pour débloquer les factures Peppol.": "Verifique su NIF-IVA y adjunte el justificante para desbloquear las facturas Peppol.",
  "Vérifié en direct dans la base officielle européenne VIES.": "Verificado en tiempo real en la base de datos oficial europea VIES.",
  "Vétuste": "Deteriorado",
  "WhatsApp": "WhatsApp",
  "XML Peppol": "XML Peppol",
  "Yuki": "Yuki",
  "Yuki injoignable. Réessayez dans un instant.": "No se puede conectar con Yuki. Vuelva a intentarlo en un momento.",
  "ZIP du trimestre (CSV + UBL), lien valable 90 jours. Confirmez la réception pour prévenir l'entreprise.": "ZIP del trimestre (CSV + UBL), enlace válido durante 90 días. Confirme la recepción para avisar a la empresa.",
  "Zinguerie et corniches": "Trabajos de zinc y cornisas",
  "Zone de couverture": "Zona de cobertura",
  "Zoom arrière": "Alejar",
  "Zoom avant": "Acercar",
  "[aria-current=\"page\"]": "[aria-current=\"page\"]",
  "[data-testid=email-template-": "[data-testid=email-template-",
  "],\n            [\"En retard\", eur(summary.late_amount),": "],\n            [\"Con retraso\", eur(summary.late_amount),",
  "],\n    [\"En retard\", eur(summary.late_amount),": "],\n    [\"Con retraso\", eur(summary.late_amount),",
  "a reçu votre demande et vous recontacte rapidement avec un devis.": "ha recibido su solicitud y se pondrá en contacto con usted pronto con un presupuesto.",
  "a répondu en": "ha respondido en",
  "acceptés": "aceptados",
  "adresse VIES indisponible": "dirección VIES no disponible",
  "adresse@email.be": "adresse@email.be",
  "ajouté au bâtiment": "añadido al edificio",
  "ajoutée": "añadida",
  "annulés": "anulados",
  "ans d'expérience": "años de experiencia",
  "application/ld+json": "application/ld+json",
  "article(s) à acheter sur": "artículo(s) que comprar en",
  "article(s) à prendre": "artículo(s) que llevar",
  "au devis": "al presupuesto",
  "au devis — complétez le prix unitaire.": "al presupuesto — complete el precio unitario.",
  "aucun retard": "ningún retraso",
  "avec la communication": "con el concepto",
  "avec le lien de paiement.": "con el enlace de pago.",
  "avec mon app bancaire": "con mi aplicación bancaria",
  "avis client": "opinión del cliente",
  "basculées par email automatiquement": "enviadas automáticamente por correo electrónico",
  "bg-[#0F2645]": "bg-[#0F2645]",
  "bg-[#3A5CC8]": "bg-[#3A5CC8]",
  "bg-[#EEF1FC]": "bg-[#EEF1FC]",
  "bg-[#F3F5FC]": "bg-[#F3F5FC]",
  "border-[#3A5CC8]": "border-[#3A5CC8]",
  "border-[#C9D4F4]": "border-[#C9D4F4]",
  "border-[#E2E7F7]": "border-[#E2E7F7]",
  "boîte": "caja",
  "caractères ·": "caracteres ·",
  "ce devis": "este presupuesto",
  "cette facture": "esta factura",
  "cette note de crédit": "este abono",
  "chaudière": "caldera",
  "chiffré par l'IA :": "calculado por la IA:",
  "children ? (": "children? (",
  "châssis": "carpintería exterior",
  "cm (trait jaune)": "cm (línea amarilla)",
  "collée par vous": "pegada por usted",
  "complétude": "grado de cumplimentación",
  "compte Mollie, puis viré sur": "cuenta de Mollie, luego transferido a",
  "connecter les bonnes compétences au bon moment": "conectar las competencias adecuadas en el momento adecuado",
  "contrat(s) actif(s)": "contrato(s) activo(s)",
  "contrôle": "control",
  "copié": "copiado",
  "créé avec": "creado con",
  "créé depuis l'intervention.": "creado a partir de la intervención.",
  "créé depuis le diagnostic : à faire signer par le client avant travaux.": "creado a partir del diagnóstico: debe firmarlo el cliente antes de iniciar los trabajos.",
  "créé en brouillon à partir de": "creado como borrador a partir de",
  "créé en brouillon.": "creado como borrador.",
  "créé à partir de votre modèle «": "creado a partir de su plantilla «",
  "créé.": "creado.",
  "créée depuis le diagnostic.": "creada a partir del diagnóstico.",
  "créée.": "creada.",
  "câblage": "cableado",
  "câble": "cable",
  "de CA ·": "de facturación ·",
  "de devis (il choisit le plus proche)": "de presupuesto (elige el más parecido)",
  "de main-d'œuvre": "de mano de obra",
  "depuis la page du document": "desde la página del documento",
  "depuis le": "desde el",
  "devFadeUp .16s ease-out": "devFadeUp .16s ease-out",
  "devFadeUp .18s ease-out": "devFadeUp .18s ease-out",
  "devFadeUp .25s ease-out": "devFadeUp .25s ease-out",
  "devSlideUp .22s ease-out": "devSlideUp .22s ease-out",
  "devSlideUp .2s ease-out": "devSlideUp .2s ease-out",
  "devis en attente de réponse": "presupuestos pendientes de respuesta",
  "devis signés": "presupuestos firmados",
  "devis ·": "presupuestos ·",
  "démolition": "demolición",
  "démontage": "desmontaje",
  "déplacement": "desplazamiento",
  "dépose": "retirada",
  "email@fiduciaire.be": "email@fiduciaire.be",
  "email@ouvrier.be": "email@ouvrier.be",
  "en attente": "pendiente",
  "en attente de réponse": "pendiente de respuesta",
  "en cours de livraison": "en proceso de entrega",
  "en retard": "con retraso",
  "encaissés": "cobrados",
  "end start": "fin inicio",
  "enregistrée.": "registrada.",
  "ensuite, vos ouvriers inclus.": "después, con sus operarios incluidos.",
  "envoyé": "enviado",
  "envoyé à": "enviado a",
  "est renseigné : activez l'envoi pour que l'export (ventes, achats, règlements, UBL) parte seul chaque 1er janvier, avril, juillet et octobre.": "está indicado: active el envío para que la exportación (ventas, compras, cobros, UBL) se envíe automáticamente cada 1 de enero, abril, julio y octubre.",
  "et le client le signe en un clic.": "y el cliente lo firma con un clic.",
  "et rendre chaque intervention plus transparente, plus réactive et mieux suivie.": "y hacer que cada intervención sea más transparente, más ágil y tenga un mejor seguimiento.",
  "et simplifie les techniques spéciales du bâtiment.": "y simplifica las instalaciones técnicas del edificio.",
  "et vos": "y sus",
  "ex. 2,40": "p. ej. 2,40",
  "facture(s)": "factura(s)",
  "facture(s) —": "factura(s) —",
  "factures et notes de crédit": "facturas y abonos",
  "facturés ·": "facturados ·",
  "facturés)": "facturados)",
  "fenêtre": "ventana",
  "forfait": "a tanto alzado",
  "heure": "hora",
  "hover:bg-[#F6F8FD]": "hover:bg-[#F6F8FD]",
  "iPhone : Partager → « Sur l'écran d'accueil », puis activez depuis l'icône Devisto.": "iPhone: Compartir → « En la pantalla de inicio », luego actívelo desde el icono de Devisto.",
  "il y a": "hace",
  "image/*": "image/*",
  "info@devis-to.be": "info@devis-to.be",
  "it.separator ? (": "it.separator? (",
  "j de retard": "d de retraso",
  "jour(s) restant(s)": "día(s) restante(s)",
  "journée": "jornada",
  "ligne(s) proposée(s)": "línea(s) propuesta(s)",
  "ligne(s) préparée(s).": "línea(s) preparada(s).",
  "ligne(s), durée manquante sur": "línea(s), falta la duración en",
  "ligne(s).": "línea(s).",
  "lignes : ajustez les prix puis envoyez.": "líneas: ajuste los precios y después envíe.",
  "lignes), ajusté par l'IA.": "líneas), ajustado por la IA.",
  "lignes).": "líneas).",
  "lignes). Retrouvez-le dans « Nouveau devis ».": "líneas). Encuéntrelo en «Nuevo presupuesto».",
  "lignes, prix, conditions et remarques de": "líneas, precios, condiciones y observaciones de",
  "linear-gradient(168deg, #163663 0%, #0F2645 55%, #0A1B33 100%)": "linear-gradient(168deg, #163663 0%, #0F2645 55%, #0A1B33 100%)",
  "linear-gradient(to top, rgba(15,38,69,0.9), rgba(15,38,69,0))": "linear-gradient(to top, rgba(15,38,69,0.9), rgba(15,38,69,0))",
  "main d": "mano de",
  "marqué comme reçu : l'entreprise est prévenue.": "marcado como recibido: se avisa a la empresa.",
  "matériaux": "materiales",
  "matériel": "material",
  "meta[name=\"description\"]": "meta[name=\"description\"]",
  "min de trajet": "min de desplazamiento",
  "mise en conformité": "adecuación a la normativa",
  "mise en route": "puesta en marcha",
  "mise en service": "puesta en servicio",
  "ml-auto shrink-0": "ml-auto shrink-0",
  "modèle": "plantilla",
  "mètre": "metro",
  "méthodes à activer dans Mollie": "métodos que activar en Mollie",
  "no token": "sin token",
  "noopener noreferrer": "noopener noreferrer",
  "nouvelle version (effet": "nueva versión (efecto",
  "ouvrier(s)": "operario(s)",
  "paiements reçus cette année": "pagos recibidos este año",
  "par mois pour toute votre société, ouvriers inclus.": "al mes para toda su empresa, operarios incluidos.",
  "payée": "pagada",
  "photos de l'intervention (matériel, état, travaux visibles)": "fotos de la intervención (material, estado, trabajos visibles)",
  "pièce": "ud.",
  "pièces": "piezas",
  "planifiée.": "programada.",
  "ponçage": "lijado",
  "pour ce document (vérifié avec mon comptable si nécessaire). Sans confirmation, l'envoi est bloqué.": "para este documento (verificado con mi gestoría si es necesario). Sin confirmación, el envío está bloqueado.",
  "prestations ajoutées.": "servicios añadidos.",
  "prestations complétées.": "servicios completados.",
  "prestations incluses,": "servicios incluidos,",
  "profilé": "perfil",
  "préparation": "preparación",
  "pts ·": "pts ·",
  "radial-gradient(110% 80% at 80% 6%, rgba(58,92,200,0.26) 0%, rgba(58,92,200,0) 60%)": "radial-gradient(110% 80% at 80% 6%, rgba(58,92,200,0.26) 0%, rgba(58,92,200,0) 60%)",
  "rappel(s) envoyé(s) par email.": "recordatorio(s) enviado(s) por correo electrónico.",
  "rappel(s) envoyé(s) — dernier le": "recordatorio(s) enviado(s) — último el",
  "refusés": "rechazados",
  "relance(s)": "recordatorio(s)",
  "relance(s) déjà envoyée(s)": "recordatorio(s) ya enviado(s)",
  "relance(s) · dernière le": "recordatorio(s) · último el",
  "remise en service": "restablecimiento del servicio",
  "rendez-vous sur 7 jours": "citas en 7 días",
  "repeat(": "repeat(",
  "resize-none pr-14": "resize-none pr-14",
  "retenue par le client": "retenida por el cliente",
  "reçu le": "recibido el",
  "reçues par le client": "recibidas por el cliente",
  "rien de planifié cette semaine": "nada programado esta semana",
  "ring-[#C9D4F4]": "ring-[#C9D4F4]",
  "ring-[#E2E7F7]": "ring-[#E2E7F7]",
  "règlement": "cobro",
  "réel": "real",
  "réglage": "ajuste",
  "réparation": "reparación",
  "répondue": "respondida",
  "sans tarif": "sin tarifa",
  "seront proposés à la création d'un nouveau devis.": "se propondrán al crear un nuevo presupuesto.",
  "signé": "firmado",
  "soumis le": "presentado el",
  "start start": "start start",
  "supposé)": "supuesto)",
  "supprimé.": "eliminado.",
  "sur 5": "sobre 5",
  "sur l'année": "a lo largo del año",
  "tarifs d'intervention ajoutés.": "tarifas de intervención añadidas.",
  "text-[#0F2645]": "text-[#0F2645]",
  "text-[#3A5CC8]": "text-[#3A5CC8]",
  "text-[#5C6A87]": "text-[#5C6A87]",
  "text-[#93A0BC]": "text-[#93A0BC]",
  "text-[#9FB4F2]": "text-[#9FB4F2]",
  "text-[#C9D4F4]": "text-[#C9D4F4]",
  "text-[#E2E7F7]": "text-[#E2E7F7]",
  "text-[#F97316]": "text-[#F97316]",
  "text/csv;charset=utf-8": "text/csv;charset=utf-8",
  "tous les": "todos los",
  "toute seule.": "por sí sola.",
  "un accès direct en consultation": "un acceso directo de solo lectura",
  "unité": "unidad",
  "valable jusqu'au": "válido hasta el",
  "virement uniquement": "solo transferencia bancaria",
  "voir le dossier": "ver el expediente",
  "votre assureur": "su aseguradora",
  "votre compte bancaire": "su cuenta bancaria",
  "votre profil": "su perfil",
  "vous invite": "le invita",
  "vous recontactera rapidement": "volverá a ponerse en contacto con usted pronto",
  "vous@entreprise.": "vous@entreprise.",
  "vous@exemple.be": "vous@exemple.be",
  "vérification": "verificación",
  "vérifiés après intervention": "verificados tras la intervención",
  "· Connexion itsme : bientôt, dès l'agrément partenaire": "· Inicio de sesión con itsme: próximamente, tras la autorización como socio",
  "· Création de factures débloquée immédiatement": "· Creación de facturas habilitada inmediatamente",
  "· Devis": "· Presupuesto",
  "· Devis gratuit – 0 €": "· Presupuesto gratuito – 0 €",
  "· Envoi Peppol via le point d'accès unique Devisto": "· Envío por Peppol a través del punto de acceso único de Devisto",
  "· IP": "· IP",
  "· Peppol": "· Peppol",
  "· TVA": "· IVA",
  "· Vérification du document par Devisto sous 24 h ouvrées": "· Verificación del documento por Devisto en un plazo de 24 h laborables",
  "· accès actif depuis le": "· acceso activo desde el",
  "· acompte déjà facturé déduit": "· anticipo ya facturado deducido",
  "· ancien tarif": "· tarifa anterior",
  "· change → EUR": "· cambio → EUR",
  "· consultation des ventes, achats et exports": "· consulta de ventas, compras y exportaciones",
  "· depuis «": "· desde «",
  "· en attente de réponse": "· pendiente de respuesta",
  "· en vigueur depuis le": "· vigente desde el",
  "· encaissé": "· cobrado",
  "· envoyé le": "· enviado el",
  "· envoyé à": "· enviado a",
  "· fin le": "· finaliza el",
  "· horodatage conservé comme preuve (eIDAS)": "· sello de tiempo conservado como prueba (eIDAS)",
  "· invitation envoyée le": "· invitación enviada el",
  "· l'entreprise reçoit une notification et vous répond par e-mail.": "· la empresa recibe una notificación y le responde por correo electrónico.",
  "· main-d'œuvre": "· mano de obra",
  "· mode": "· modo",
  "· modèle «": "· modelo «",
  "· prend effet le": "· entra en vigor el",
  "· prochaine visite": "· próxima visita",
  "· rappel envoyé": "· recordatorio enviado",
  "· rappel prévu la veille": "· recordatorio programado para el día anterior",
  "· renouvelle": "· se renueva",
  "· reçu le": "· recibido el",
  "· sans dossier": "· sin expediente",
  "· sans rappel": "· sin recordatorio",
  "· signée": "· firmada",
  "· solde": "· saldo",
  "· téléchargé": "· descargado",
  "· utilisé": "· utilizado",
  "· valable jusqu'au": "· válido hasta el",
  "· à payer": "· por pagar",
  "· éch.": "· venc.",
  "· échue le": "· vencida el",
  "· échéance": "· vencimiento",
  "» créé": "» creado",
  "» enregistré (": "» guardado (",
  "» enregistré : proposé à la création d'un contrat.": "» guardado: se propone al crear un contrato.",
  "» est ajouté automatiquement sous votre texte.": "» se añade automáticamente debajo de su texto.",
  "À adapter": "Para adaptar",
  "À coller sur l'équipement": "Para pegar en el equipo",
  "À coller sur la chaudière : le client voit son historique et vos coordonnées": "Para pegar en la caldera: el cliente puede ver su historial y sus datos de contacto",
  "À compléter :": "Por completar:",
  "À créer": "Por crear",
  "À encaisser": "Pendiente de cobro",
  "À faire valider et signer par le client avant les travaux": "Para que el cliente lo apruebe y firme antes de los trabajos",
  "À jour": "Al día",
  "À partir d'un devis": "A partir de un presupuesto",
  "À payer": "Pendiente de pago",
  "À perte": "Con pérdidas",
  "À programmer": "Pendiente de programar",
  "À prévoir": "Por prever",
  "À relancer": "Pendiente de enviar recordatorio",
  "À renouveler": "Pendiente de renovar",
  "À renouveler · fin": "Por renovar · fin",
  "À réception de facture": "Al recibir la factura",
  "À répondre": "Por responder",
  "À signer": "Por firmar",
  "À traiter": "Pendiente de tramitar",
  "À traiter ·": "Por tramitar ·",
  "À venir": "Próximamente",
  "À vérifier": "Pendiente de verificar",
  "Ébéniste": "Ebanista",
  "Échangez et avancez sur votre projet": "Comuníquese y avance en su proyecto",
  "Échec": "Error",
  "Échec de la remise à neuf.": "Error al reacondicionar.",
  "Échec pour :": "Error en:",
  "Échec → envoyée par email": "Error → enviada por correo electrónico",
  "Échecs": "Errores",
  "Échelle recalibrée : toutes les mesures ont été recalculées.": "Escala recalibrada: se han recalculado todas las medidas.",
  "Échéance": "Vencimiento",
  "Échéance :": "Vencimiento:",
  "Échéances traitées": "Vencimientos tramitados",
  "Écrire": "Escribir",
  "Électricien": "Electricista",
  "Électricité": "Electricidad",
  "Électrique": "Eléctrico",
  "Élément introuvable": "Elemento no encontrado",
  "Éléments enregistrés hors ligne, prêts à être synchronisés.": "Elementos guardados sin conexión, listos para sincronizarse.",
  "Émis le": "Emitido el",
  "Équipe": "Equipo",
  "Équipement": "Equipo",
  "Équipement concerné": "Equipo afectado",
  "Équipement introuvable.": "No se ha encontrado el equipo.",
  "Équipement supprimé": "Equipo eliminado",
  "Équipements": "Equipos",
  "Équipements spécifiques": "Equipos específicos",
  "Étape 1": "Paso 1",
  "Étape 2": "Paso 2",
  "Étape 3": "Paso 3",
  "Étape obligatoire": "Paso obligatorio",
  "Étape obligatoire avant de créer vos factures : société vérifiée, puis envoi Peppol via le point d'accès Devisto.": "Paso obligatorio antes de crear sus facturas: empresa verificada y, después, envío por Peppol a través del punto de acceso Devisto.",
  "État": "Estado",
  "État de l'installation": "Estado de la instalación",
  "État général": "Estado general",
  "Évacuation condensats": "Evacuación de condensados",
  "à chiffrer": "por presupuestar",
  "à facturer": "por facturar",
  "à l'instant": "ahora mismo",
  "à la facture": "a la factura",
  "à partir de": "a partir de",
  "à reverser (déclarations)": "a ingresar (declaraciones)",
  "à répondre": "por responder",
  "à vérifier)": "por comprobar)",
  "échéance": "vencimiento",
  "élément(s) capturé(s)": "elemento(s) capturado(s)",
  "élément(s) n'ont pas pu être envoyés — nouvel essai plus tard.": "elemento(s) no se han podido enviar — se volverá a intentar más tarde.",
  "élément(s) synchronisé(s).": "elemento(s) sincronizado(s).",
  "équipement": "equipo",
  "équipements": "equipos",
  "étoiles": "estrellas",
  "évacuation": "evacuación",
  "êtes-vous en règle ?": "¿está usted en regla?",
  "– contrat n° … » en pied de page des devis et factures PDF.": "– contrato n° … » en el pie de página de los presupuestos y las facturas PDF.",
  "— aperçu client": "— vista previa del cliente",
  "— base": "— base",
  "— choisir": "— elegir",
  "— choisissez celle qui vous convient": "— elija la que más le convenga",
  "— email envoyé à": "— correo electrónico enviado a",
  "— figé pour préserver le référencement": "— fijado para preservar el posicionamiento",
  "— fin du contrat le": "— fin del contrato el",
  "— mesure caméra": "— medición con cámara",
  "— non précisé (": "— no especificado (",
  "— votre app bancaire s'ouvre avec le virement pré-rempli ; la facture est marquée payée automatiquement.": "— su aplicación bancaria se abre con la transferencia ya cumplimentada; la factura se marca como pagada automáticamente.",
  "— à faire avant le": "— por hacer antes del",
  "— à préciser": "— por especificar",
  "€ HTVA + TVA": "€ sin IVA + IVA",
  "← Tous les modèles": "← Todos los modelos",
  "≈ EUR": "≈ EUR",
  "Quel est le prix de marché d'un entretien de chaudière gaz en Espagne ?": "¿Cuál es el precio de mercado del mantenimiento de una caldera de gas en España?",
  "Quel est le prix de marché d'un entretien de chaudière gaz en France ?": "¿Cuál es el precio de mercado del mantenimiento de una caldera de gas en Francia?",
  "Quel est le prix de marché d'un entretien de chaudière mazout au Luxembourg ?": "¿Cuál es el precio de mercado del mantenimiento de una caldera de gasóleo en Luxemburgo?"
};
